export type IDeclareClosedDealByTokenInput = {
  configurationId?: InputMaybe<Scalars['String']['input']>
  expectedStayMonths?: InputMaybe<Scalars['Int']['input']>
  /** Agreed monthly rent, before IVA. */
  monthlyPriceMxn: Scalars['Float']['input']
  note?: InputMaybe<Scalars['String']['input']>
  onDemandCity?: InputMaybe<Scalars['String']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  renterName?: InputMaybe<Scalars['String']['input']>
  renterPhone?: InputMaybe<Scalars['String']['input']>
  sourceLeadId?: InputMaybe<Scalars['String']['input']>
  /** YYYY-MM the rent started; the server normalizes it to the 15th. */
  startMonth: Scalars['String']['input']
  /** «¿Quién confirma?» — the attribution on a no-login confirmation. */
  submitterName: Scalars['String']['input']
  token: Scalars['String']['input']
}

export type IMutationAckHostLeadByPartnerLinkArgs = {
  leadId: Scalars['String']['input']
  token: Scalars['String']['input']
}

export type IMutationConfirmStaffRecordedDealArgs = {
  corrections?: InputMaybe<IPartnerDealCorrectionInput>
  submitterName: Scalars['String']['input']
  token: Scalars['String']['input']
}

export type IMutationDeclareClosedDealByTokenArgs = {
  input: IDeclareClosedDealByTokenInput
}

export type IMutationRequestPartnerCloseConfirmationArgs = {
  dealId: Scalars['String']['input']
}

export type IPartnerConfirmation = {
  __typename?: 'PartnerConfirmation'
  at: Scalars['String']['output']
  /** The typed «¿Quién confirma?» name (or the admin uid). */
  by?: Maybe<Scalars['String']['output']>
  /** close_link | staff_link | roster | wa_tap | admin */
  via: Scalars['String']['output']
}

export type IPartnerConfirmLink = {
  __typename?: 'PartnerConfirmLink'
  confirmUrl: Scalars['String']['output']
  contactLabel?: Maybe<Scalars['String']['output']>
  /** wa.me link to the deal's primary lead contact, prefilled — staff tap and send. */
  waDeeplink?: Maybe<Scalars['String']['output']>
}

export type IPartnerDealCorrectionInput = {
  monthlyPriceMxn?: InputMaybe<Scalars['Float']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  startMonth?: InputMaybe<Scalars['String']['input']>
}

export type IPartnerLinkConfig = {
  __typename?: 'PartnerLinkConfig'
  configurationId: Scalars['String']['output']
  label: Scalars['String']['output']
  listedPriceMxn: Scalars['Float']['output']
}

export type IPartnerLinkDeal = {
  __typename?: 'PartnerLinkDeal'
  clientLabel: Scalars['String']['output']
  confirmedAt?: Maybe<Scalars['String']['output']>
  confirmedBy?: Maybe<Scalars['String']['output']>
  dealId: Scalars['String']['output']
  listingLabel?: Maybe<Scalars['String']['output']>
  monthlyPriceMxn: Scalars['Float']['output']
  quantity: Scalars['Int']['output']
  /** True when the recorded price is not the partner's (renter-stated or unknown) — the page must ask the partner to type it. */
  requiresTypedPrice: Scalars['Boolean']['output']
  /** YYYY-MM of chargeStartDate (else closedAt). */
  startMonth: Scalars['String']['output']
}

export type IPartnerLinkLead = {
  __typename?: 'PartnerLinkLead'
  /** When the lead was reported CLOSED (its hostOutcome timestamp). */
  closedAt?: Maybe<Scalars['String']['output']>
  configurationId?: Maybe<Scalars['String']['output']>
  group: PartnerLinkLeadGroup
  hostContactedAt?: Maybe<Scalars['String']['output']>
  leadId: Scalars['String']['output']
  listingLabel?: Maybe<Scalars['String']['output']>
  locationId?: Maybe<Scalars['String']['output']>
  /** Full or masked phone, exactly as the partner's lead card discloses it. */
  maskedPhone?: Maybe<Scalars['String']['output']>
  /** Full or first-name-only, exactly as the partner's lead card discloses it. */
  name?: Maybe<Scalars['String']['output']>
  onDemandCity?: Maybe<Scalars['String']['output']>
  sentAt: Scalars['String']['output']
  sizeLabel?: Maybe<Scalars['String']['output']>
  /** The lead's configuration list price — prefill only, the partner edits it. */
  suggestedPriceMxn?: Maybe<Scalars['Float']['output']>
}

export type IPartnerLinkListing = {
  __typename?: 'PartnerLinkListing'
  configurations: Array<IPartnerLinkConfig>
  label: Scalars['String']['output']
  locationId: Scalars['String']['output']
}

export type IPartnerLinkResult = {
  __typename?: 'PartnerLinkResult'
  alreadyReportedAt?: Maybe<Scalars['String']['output']>
  closedDealId?: Maybe<Scalars['String']['output']>
  error?: Maybe<PartnerLinkError>
  ok: Scalars['Boolean']['output']
}

export type IPartnerLinkView = {
  __typename?: 'PartnerLinkView'
  /** True when the link is sucursal-scoped and the team has a team-wide contact. */
  canWiden: Scalars['Boolean']['output']
  contactLabel?: Maybe<Scalars['String']['output']>
  /** YYYY-MM in America/Mexico_City — the client never computes the month. */
  currentMonth?: Maybe<Scalars['String']['output']>
  deal?: Maybe<IPartnerLinkDeal>
  focusLeadId?: Maybe<Scalars['String']['output']>
  leads: Array<IPartnerLinkLead>
  listings: Array<IPartnerLinkListing>
  onDemandCities: Array<Scalars['String']['output']>
  scope?: Maybe<PartnerLinkScope>
  teamLabel?: Maybe<Scalars['String']['output']>
  valid: Scalars['Boolean']['output']
}

export type IQueryPartnerLinkViewArgs = {
  token: Scalars['String']['input']
  widen?: InputMaybe<Scalars['Boolean']['input']>
}

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export enum PartnerLinkError {
  AlreadyReported = 'ALREADY_REPORTED',
  Disabled = 'DISABLED',
  InvalidInput = 'INVALID_INPUT',
  InvalidToken = 'INVALID_TOKEN',
  NotAllowed = 'NOT_ALLOWED',
  NotFound = 'NOT_FOUND',
  RateLimited = 'RATE_LIMITED'
}

export enum PartnerLinkLeadGroup {
  /** A closed deal was RECORDED for the lead (stored status RESERVED) — not a tag-only «Cerré». */
  Closed = 'CLOSED',
  /** Old enough (or already contacted) to ask «¿cerraste?». */
  ToConfirm = 'TO_CONFIRM',
  /** Recent and not yet contacted. */
  Uncontacted = 'UNCONTACTED'
}

export enum PartnerLinkScope {
  Deal = 'DEAL',
  Lead = 'LEAD',
  Team = 'TEAM'
}

export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
}

export enum AccessAvailability {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Unfrequently = 'UNFREQUENTLY',
  Weekly = 'WEEKLY'
}

export enum AccessFrequency {
  Anyday = 'ANYDAY',
  FriToSun = 'FRI_TO_SUN',
  MonToFri = 'MON_TO_FRI',
  MonToSat = 'MON_TO_SAT',
  Weekends = 'WEEKENDS'
}

export enum AccessHours {
  Anytime = 'ANYTIME',
  DaytimeHours = 'DAYTIME_HOURS',
  EveningHours = 'EVENING_HOURS',
  ExtendedHours = 'EXTENDED_HOURS'
}

export enum AccessPermission {
  Notice = 'NOTICE',
  NoNotice = 'NO_NOTICE'
}

/**
 * Structured correction a partner proposed from the month-close roster ('algo
 * no cuadra' with concrete fields instead of free text). Rides alongside
 * `disputedAt` — the deal stays excluded from invoicing until an admin resolves
 * it via `resolveAccrualRosterProposal` (approve applies the fields / discards
 * the deal; reject keeps the recorded terms). Only the proposed-changed fields
 * are set; null = 'no change proposed' for that field.
 */
export type IAccrualChangeProposal = {
  __typename?: 'AccrualChangeProposal'
  /** Proposed billing-clock start date (ISO). */
  chargeStartDate?: Maybe<Scalars['String']['output']>
  /** Proposed different unit (configuration) at the SAME location. */
  configurationId?: Maybe<Scalars['String']['output']>
  /** Display label of the proposed unit — denormalized at submit time. */
  configurationLabel?: Maybe<Scalars['String']['output']>
  /** Proposed plazo estimado in months. */
  duration?: Maybe<Scalars['Int']['output']>
  kind: AccrualProposalKind
  /** Proposed PER-UNIT monthly price (same semantics as ClosedDeal.monthlyPrice). */
  monthlyPrice?: Maybe<Scalars['Float']['output']>
  /** The partner's free-text note sent with the proposal, verbatim. */
  note?: Maybe<Scalars['String']['output']>
  proposedAt: Scalars['String']['output']
  /** Attribution label of the partner user who proposed (name/email). */
  proposedBy?: Maybe<Scalars['String']['output']>
  quantity?: Maybe<Scalars['Int']['output']>
}

/**
 * One per-client decision recorded at a roster submit — powers the authed
 * "Cierres" history on the host closed-deals dashboard.
 */
export type IAccrualCloseAction = {
  __typename?: 'AccrualCloseAction'
  action: AccrualRosterAction
  clientLabel: Scalars['String']['output']
  /**
   * ADMIN-ONLY: the conflict severity on the lead that sourced this deal (spec
   * §D3/§D5). Without it an admin can approve a «Nunca cerramos» / «Ya era mi
   * cliente» discard on the review board without ever seeing that the renter
   * said the opposite.
   *
   * ⚠️ NULL FOR EVERY NON-ADMIN VIEWER, and that is a security property, not a
   * data gap. `accrualPartnerCloses` is PARTNER-authed — a team member of any
   * role reads their own team's history — and §D3 routes the severity to the
   * admin digest / `AdminNoti` / Fer, never to the partner: `HIGH` is precisely
   * the disintermediation signal, so a partner who can read it learns which of
   * their own answers trips it. The server resolves the field only under
   * `adminView`. `ConflictChip` must therefore keep rendering nothing on null.
   * Also null for deals with no source lead and for leads with no conflict.
   */
  conflict?: Maybe<LeadConflictLevel>
  /** False when the deal no longer exists (discarded after a «nunca cerramos»). */
  dealExists: Scalars['Boolean']['output']
  dealId: Scalars['String']['output']
  /**
   * DISPUTE only: the partner's "algo no cuadra" note, verbatim as submitted
   * that month (recorded per-submit since 2026-07-13; older submits show null —
   * deal.accrualRoster.disputeNote only holds the CURRENT note and is cleared
   * when an admin resolves the dispute).
   */
  disputeNote?: Maybe<Scalars['String']['output']>
  /**
   * LIVE: the deal still carries an unresolved dispute right now — the admin
   * Cierres review board renders the pending chip + resolution actions off
   * this, and the partner view shows "en revisión".
   */
  disputePending: Scalars['Boolean']['output']
  /** EXITED only: the month the partner reported the client left. */
  exitMonth?: Maybe<Scalars['String']['output']>
  /** Monthly rent of the deal at read time (× quantity, via getDealGmvPerMo). Null when the deal was deleted. */
  monthlyRentMxn?: Maybe<Scalars['Float']['output']>
  /** LIVE: the deal still carries an unresolved 'ya era mi cliente' reject — the board renders confirm/reject actions off this. */
  notOriginatedPending: Scalars['Boolean']['output']
  /** LIVE: the deal's pending structured proposal (null once resolved / free-text). */
  proposal?: Maybe<IAccrualChangeProposal>
  /**
   * DISPUTE-with-proposal only: human-readable summary of the structured
   * correction ("Precio: $2,400 → $2,600 · Inicio: 15 mar → 1 abr"), built
   * server-side at submit time so history survives after resolution.
   */
  proposalSummary?: Maybe<Scalars['String']['output']>
  /**
   * LIVE: the RENTER has withdrawn the claim this deal was built on
   * (`accrualRoster.renterRetractedAt`). The board renders a distinct badge for
   * it next to the dispute chip, because it is a DIFFERENT decision: applying or
   * rejecting the partner's proposal does not lift it, and CONFIRM stays refused
   * until an admin explicitly resolves the dispute.
   *
   * Row-level twin of `ClosedDealAccrualRoster.renterRetractedAt` — this type is
   * what the board actually renders, resolved from the same live deal as
   * `disputePending` / `notOriginatedPending`.
   */
  renterRetracted: Scalars['Boolean']['output']
  /**
   * LIVE: the renter's own STRUCTURED statement on that lead ("Dice que rentó con
   * X desde junio a $2,400/mes — por WhatsApp, 8 sep"), built by the same pure
   * builder the partner's roster uses. Free text is never included (spec §D4).
   */
  renterStatement?: Maybe<Scalars['String']['output']>
  resolutionAt?: Maybe<Scalars['String']['output']>
  /** Partner-visible resolution note (rejection reason / manual-adjust context). */
  resolutionNote?: Maybe<Scalars['String']['output']>
  /**
   * How the admin review resolved this DISPUTE record: applied_verbatim |
   * applied_edited | rejected | cleared_freetext. Null = still pending (or a
   * non-dispute row). When EVERY dispute of a close resolves applied_verbatim,
   * the close auto-confirms + invoices (partner-proposed terms = partner
   * consent); any other outcome requires partner re-confirmation.
   */
  resolutionOutcome?: Maybe<Scalars['String']['output']>
  /** Summary of what was applied, echoed from the proposal at resolve time. */
  resolutionSummary?: Maybe<Scalars['String']['output']>
}

/**
 * One submit event within a close month: who, when, and the per-client
 * decisions taken (empty for closes submitted before action-logging shipped).
 */
export type IAccrualCloseSubmission = {
  __typename?: 'AccrualCloseSubmission'
  actions: Array<IAccrualCloseAction>
  at: Scalars['String']['output']
  by?: Maybe<Scalars['String']['output']>
}

/**
 * Which devengo ladder an ACCRUAL deal bills on (sales/commission-model.md —
 * "steepness pushback → stretch the ladder, never cut the cap"). Named
 * presets only — free-form milestones are deliberately NOT supported.
 * Null = STANDARD_6.
 *   - STANDARD_6: 0.25× @ 1st paid rent → 1× @ 3rd → 1.25× @ 5th → 2× cap @ 6th
 *   - STRETCH_8:  0.25× @ 1st paid rent → 1× @ 4th → 1.25× @ 6th → 2× cap @ 8th
 *   - LOGISTICS_6: 0.25× @ 1st paid rent → 0.5× @ 3rd → 0.75× @ 5th → 1× cap
 *     @ 6th — the Soluciones Logísticas (3PL) rate card; base = monthly FIXED
 *     SPACE commitment (services excluded). Default for serviceModel=LOGISTICS.
 */
export enum AccrualLadderPreset {
  Custom = 'CUSTOM',
  Logistics_6 = 'LOGISTICS_6',
  LogisticsFlat_9 = 'LOGISTICS_FLAT_9',
  Standard_6 = 'STANDARD_6',
  Stretch_8 = 'STRETCH_8'
}

/**
 * One step of an ACCRUAL devengo ladder: once the client's Nth rent is
 * actually paid, the cumulative fee earned is cumulativeMultiplier × one
 * month's rent. Mirrors IAccrualMilestone in accrualLadder.ts.
 */
export type IAccrualScheduleStep = {
  __typename?: 'AccrualScheduleStep'
  /** Total fee earned so far, as a multiple of one month's rent (strictly increasing; last step = the cap). */
  cumulativeMultiplier: Scalars['Float']['output']
  /** The client's Nth actually-paid monthly rent that triggers this step (≥ 1, strictly increasing). */
  paidRents: Scalars['Int']['output']
}

export type IAccrualScheduleStepInput = {
  cumulativeMultiplier: Scalars['Float']['input']
  paidRents: Scalars['Int']['input']
}

/**
 * One step of the devengo ladder rendered in MXN for the roster page.
 */
export type IAccrualLadderStep = {
  __typename?: 'AccrualLadderStep'
  /**
   * The fraction of ONE month's GMV this step charges cumulatively — the deal's
   * own ladder multiplier (`IAccrualMilestone.cumulativeMultiplier`), read from
   * the same preset that produced `cumulativeMxn`. Rate, not money: it lets a
   * client rebase the ladder onto a rent the recorded one cannot express (an
   * UNKNOWN-priced row bills at `monthlyRentMxn = 0`, so every `*Mxn` above is 0
   * and no ratio can recover the economics).
   */
  cumulativeMultiplier: Scalars['Float']['output']
  /** Cumulative fee earned once this rent is paid (subtotal, sin IVA). */
  cumulativeMxn: Scalars['Float']['output']
  /** Incremental charge at this step (cumulative − previous). */
  incrementalMxn: Scalars['Float']['output']
  /** The client's Nth actually-paid monthly rent that triggers this step. */
  paidRents: Scalars['Int']['output']
}

/**
 * One month-close record for the AUTHED host/team "Cierres" view — submission
 * attribution + per-client decisions + consolidated invoice payment state.
 * Unlike AccrualRosterPastClose (token-authorized roster page), this is served
 * to logged-in team members / individual partners / admins.
 */
export type IAccrualPartnerClose = {
  __typename?: 'AccrualPartnerClose'
  closeMonth: Scalars['String']['output']
  /** Pre-formatted Spanish label (e.g. "junio 2026"). */
  closeMonthLabel: Scalars['String']['output']
  invoices: Array<IAccrualRosterInvoice>
  /**
   * Signed magic-link URL to this month's roster page (/tratos/cierre/{token})
   * — the same link the roster emails carry. Safe to return here: the query is
   * already scoped to a partner the requester is authorized to read, and the
   * token grants exactly that partner's roster.
   */
  rosterUrl: Scalars['String']['output']
  /** Submit events, newest first. */
  submissions: Array<IAccrualCloseSubmission>
  /** Send-state closedAt (null = the month was never submitted). */
  submittedAt?: Maybe<Scalars['String']['output']>
  /** Attribution of the month's latest submission. */
  submittedBy?: Maybe<Scalars['String']['output']>
}

/**
 * Admin-only: one accrual partner's identity + its month-close history, so an
 * admin can browse EVERY partner's cierres in one view without picking a
 * partner in the dashboard switcher. `closes` is the same shape
 * accrualPartnerCloses returns for a single partner.
 */
export type IAccrualPartnerClosesGroup = {
  __typename?: 'AccrualPartnerClosesGroup'
  closes: Array<IAccrualPartnerClose>
  /** Opaque partner key (team:{id} | user:{id}) — stable list key. */
  partnerKey: Scalars['String']['output']
  /** Team name / host name for the section header (null when unresolved). */
  partnerLabel?: Maybe<Scalars['String']['output']>
  /** TEAM | INDIVIDUAL — lets the UI pick the right icon. */
  partnerType: Scalars['String']['output']
}

export type IAccrualProposalInput = {
  chargeStartDate?: InputMaybe<Scalars['String']['input']>
  configurationId?: InputMaybe<Scalars['String']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  kind: AccrualProposalKind
  monthlyPrice?: InputMaybe<Scalars['Float']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
}

/** What a structured roster proposal asks for. */
export enum AccrualProposalKind {
  /** Field corrections — price / unit / quantity / plazo / start date. */
  Correction = 'CORRECTION',
  /** 'Nunca cerramos con este cliente' — approving discards the deal. */
  Discard = 'DISCARD'
}

/**
 * Per-row action a partner takes on the month-close roster.
 *   - CONFIRM       new client → confirm the recorded terms
 *   - DISPUTE       new client → "algo no cuadra" (excluded + flags admin)
 *   - STILL_ACTIVE  active client → Sigue activo (advances confirmation)
 *   - EXITED        active client → Ya se fue (stops future milestones)
 */
export enum AccrualRosterAction {
  Confirm = 'CONFIRM',
  Dispute = 'DISPUTE',
  Exited = 'EXITED',
  NotOriginated = 'NOT_ORIGINATED',
  StillActive = 'STILL_ACTIVE'
}

export type IAccrualRosterActionInput = {
  action: AccrualRosterAction
  /**
   * CONFIRM only — the monthly rent (sin IVA) the PARTNER agrees to, in MXN.
   * REQUIRED on every renter-declared row and on any row whose priceSource is
   * UNKNOWN; the confirm is refused (see priceRequiredDealIds) without it.
   * Writes `monthlyPrice` + `priceSource: PARTNER` on the deal.
   */
  confirmPriceMxn?: InputMaybe<Scalars['Float']['input']>
  /**
   * CONFIRM only — the month the rental actually started (YYYY-MM). REQUIRED on
   * every renter-declared row: it seeds the accrual clock (chargeStartDate), so a
   * renter-stated "desde junio" confirmed in October would otherwise bill June
   * through September in one invoice. Clamped server-side at the source lead's
   * createdOn, and a clamp raises an admin conflict.
   */
  confirmStartMonth?: InputMaybe<Scalars['String']['input']>
  dealId: Scalars['String']['input']
  /** Free-text note when action = DISPUTE. */
  disputeNote?: InputMaybe<Scalars['String']['input']>
  /** Required when action = EXITED (YYYY-MM). */
  exitMonth?: InputMaybe<Scalars['String']['input']>
  /**
   * DISPUTE only — structured correction (changed fields) or a DISCARD
   * ('nunca cerramos'). Persisted on the deal for one-click admin resolution.
   */
  proposal?: InputMaybe<IAccrualProposalInput>
}

/**
 * A previously-confirmed accrual client — the "Clientes activos" roster section.
 * The partner reports continuity (Sigue activo) or an exit (Ya se fue).
 */
export type IAccrualRosterActiveClient = {
  __typename?: 'AccrualRosterActiveClient'
  /** Milestones that bill at THIS close if the partner confirms continuity. */
  billableNow: Array<IAccrualRosterBillableMilestone>
  /**
   * The deal's billing clock start (chargeStartDate ?? billing.startDate ??
   * closedAt — same fallback the invoice gate uses), so ladder labels always
   * have a date even when the raw chargeStartDate was never recorded.
   */
  chargeStartDate?: Maybe<Scalars['String']['output']>
  clientLabel: Scalars['String']['output']
  /** The deal's CURRENT unit (configuration) — prefill for the correction form's picker. */
  configurationId?: Maybe<Scalars['String']['output']>
  /** Other units at the same location the partner can propose instead. */
  configurationOptions: Array<IAccrualRosterConfigOption>
  /** Latest month the partner has confirmed this client through (YYYY-MM). */
  confirmedThrough?: Maybe<Scalars['String']['output']>
  dealId: Scalars['String']['output']
  /** True when the partner already flagged a correction — awaiting admin. */
  disputed: Scalars['Boolean']['output']
  /** The note sent with the dispute/correction, verbatim (revisit display). */
  disputeNote?: Maybe<Scalars['String']['output']>
  /** Registered stay in months (duration ?? expectedStayMonths) — an estimate, not a commitment. */
  expectedStayMonths?: Maybe<Scalars['Int']['output']>
  /** The devengo ladder in MXN, computed from this deal's monthly GMV. */
  ladder: Array<IAccrualLadderStep>
  listingLabel?: Maybe<Scalars['String']['output']>
  /** The deal's location — per-sucursal filter key (see IAccrualRosterNewClient.locationId). */
  locationId?: Maybe<Scalars['String']['output']>
  /** Ladder milestones already invoiced (of 4). */
  milestonesBilled: Scalars['Int']['output']
  monthlyRentMxn: Scalars['Float']['output']
  /** True when the partner flagged 'ya era mi cliente' and it's held for admin — display-only 'en revisión'. */
  notOriginated: Scalars['Boolean']['output']
  /** Deal notes, verbatim (ClosedDeal.notes — already host-visible on the deal detail page). */
  notes?: Maybe<Scalars['String']['output']>
  /** The pending structured proposal, echoed so revisits show WHAT was proposed. */
  proposal?: Maybe<IAccrualChangeProposal>
  /** Units rented (ClosedDeal.quantity) — prefill for the correction form. */
  quantity?: Maybe<Scalars['Int']['output']>
  renterEmail?: Maybe<Scalars['String']['output']>
  /**
   * Contact person on the deal (ClosedDeal.renterName). For BUSINESS deals this
   * is the person at the company (clientLabel carries the razón social); for
   * individuals it usually equals clientLabel — the UI dedupes. Same exposure as
   * the host deal-detail page, which already shows it to the same audience.
   */
  renterName?: Maybe<Scalars['String']['output']>
  renterPhone?: Maybe<Scalars['String']['output']>
  /** Per-unit monthly price (ClosedDeal.monthlyPrice) — prefill for the correction form. */
  unitPriceMxn?: Maybe<Scalars['Float']['output']>
}

/**
 * A milestone that WOULD bill at this close if the partner confirms the client
 * through the close month — powers the pre-submit "Tu factura de este cierre"
 * preview. Mirrors the invoice gate's math exactly (billableMilestoneIndexes
 * simulated with confirmedThrough = closeMonth).
 */
export type IAccrualRosterBillableMilestone = {
  __typename?: 'AccrualRosterBillableMilestone'
  /** Incremental fee at this milestone (subtotal, sin IVA). */
  amountMxn: Scalars['Float']['output']
  /** Presumed-rent month (YYYY-MM) — lets the page filter by a reported exit month. */
  month: Scalars['String']['output']
  /**
   * The fraction of ONE month's GMV this milestone charges — the incremental
   * ladder multiplier (`accrualMilestoneDelta`), the SAME factor that produced
   * `amountMxn` (`multiplier × feeBase`). Rate, not money: the invoice preview
   * multiplies it by a partner-typed rent so an UNKNOWN-priced row (recorded
   * base 0, `amountMxn` 0) previews what the submit will actually bill. NEVER
   * re-derive it as `amountMxn / monthlyRentMxn` — that is the zero it fixes.
   */
  multiplier: Scalars['Float']['output']
  /** The client's Nth actually-paid rent this milestone charges for. */
  paidRents: Scalars['Int']['output']
}

/**
 * A client whose devengo ladder is fully billed (2× cap collected). Shown in
 * the roster's passive "clientes completados" section — exit reports are
 * optional and purely informational (tenure data); they can never bill.
 */
export type IAccrualRosterCompletedClient = {
  __typename?: 'AccrualRosterCompletedClient'
  chargeStartDate?: Maybe<Scalars['String']['output']>
  clientLabel: Scalars['String']['output']
  dealId: Scalars['String']['output']
  listingLabel?: Maybe<Scalars['String']['output']>
  /** The deal's location — per-sucursal filter key (see IAccrualRosterNewClient.locationId). */
  locationId?: Maybe<Scalars['String']['output']>
  /** Total monthly rent (already × quantity). */
  monthlyRentMxn: Scalars['Float']['output']
  /** Approximate months as a client (billing-clock start → this close month). */
  monthsActive?: Maybe<Scalars['Int']['output']>
  /** Deal notes, verbatim (ClosedDeal.notes — already host-visible on the deal detail page). */
  notes?: Maybe<Scalars['String']['output']>
  renterEmail?: Maybe<Scalars['String']['output']>
  /** Contact person on the deal (ClosedDeal.renterName) — identification aid; the UI dedupes vs clientLabel. */
  renterName?: Maybe<Scalars['String']['output']>
  renterPhone?: Maybe<Scalars['String']['output']>
}

/** One selectable unit at the deal's location — powers the correction form's unit picker. */
export type IAccrualRosterConfigOption = {
  __typename?: 'AccrualRosterConfigOption'
  configurationId: Scalars['String']['output']
  label: Scalars['String']['output']
  /** Per-unit monthly price of this unit as listed (MXN). */
  priceMxn?: Maybe<Scalars['Float']['output']>
}

export enum AccrualRosterError {
  InvalidToken = 'INVALID_TOKEN',
  RateLimited = 'RATE_LIMITED',
  SubmitterRequired = 'SUBMITTER_REQUIRED'
}

/**
 * A consolidated month-close Stripe invoice's live payment state — powers the
 * roster page's "factura de este cierre" card and the past-closes history.
 * Voided/draft invoices are excluded server-side.
 */
export type IAccrualRosterInvoice = {
  __typename?: 'AccrualRosterInvoice'
  /** Stripe hosted invoice page — view + pay link. */
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>
  /** UTC string when the invoice was paid (null while open). */
  paidAt?: Maybe<Scalars['String']['output']>
  /** Stripe invoice status: paid | open | uncollectible. */
  status: Scalars['String']['output']
  stripeInvoiceId: Scalars['String']['output']
  /** Invoice total in MXN, IVA INCLUDED (the final charged amount). */
  totalMxn: Scalars['Float']['output']
}

/**
 * One line item on the consolidated month-close invoice — shown back to the
 * partner on submit so the invoice mirrors exactly what they confirmed.
 */
export type IAccrualRosterLineItem = {
  __typename?: 'AccrualRosterLineItem'
  amountMxn: Scalars['Float']['output']
  clientLabel: Scalars['String']['output']
  month: Scalars['String']['output']
  paidRents: Scalars['Int']['output']
}

/**
 * A newly-originated accrual client the partner has not confirmed yet — the
 * "Nuevos clientes del mes" roster section. Full terms visible so the partner
 * confirms exactly what SpotMe will bill.
 */
export type IAccrualRosterNewClient = {
  __typename?: 'AccrualRosterNewClient'
  /** Milestones that bill at THIS close if the partner confirms this client. */
  billableNow: Array<IAccrualRosterBillableMilestone>
  /**
   * The deal's billing clock start (chargeStartDate ?? billing.startDate ??
   * closedAt — same fallback the invoice gate uses), so ladder labels always
   * have a date even when the raw chargeStartDate was never recorded.
   */
  chargeStartDate?: Maybe<Scalars['String']['output']>
  clientLabel: Scalars['String']['output']
  /** The deal's CURRENT unit (configuration) — prefill for the correction form's picker. */
  configurationId?: Maybe<Scalars['String']['output']>
  /** Other units at the same location the partner can propose instead. */
  configurationOptions: Array<IAccrualRosterConfigOption>
  dealId: Scalars['String']['output']
  /** True when the partner already flagged 'algo no cuadra' — awaiting admin. */
  disputed: Scalars['Boolean']['output']
  /**
   * The note sent with the dispute, verbatim — rendered read-only on the roster
   * page so a revisit (partner or admin) sees WHAT was reported instead of an
   * empty textarea. Null when not disputed or no note was left.
   */
  disputeNote?: Maybe<Scalars['String']['output']>
  /** Registered stay in months (duration ?? expectedStayMonths) — an estimate, not a commitment. */
  expectedStayMonths?: Maybe<Scalars['Int']['output']>
  /** The devengo ladder in MXN, computed from this deal's monthly GMV. */
  ladder: Array<IAccrualLadderStep>
  listingLabel?: Maybe<Scalars['String']['output']>
  /** The deal's location — per-sucursal filter key (multi-branch teams; every roster row carries it so scoping never needs a migration). */
  locationId?: Maybe<Scalars['String']['output']>
  /** Total monthly rent (already × quantity). */
  monthlyRentMxn: Scalars['Float']['output']
  /** True when the partner flagged 'ya era mi cliente' and it's held for admin (our lead data contradicts) — display-only 'en revisión'. */
  notOriginated: Scalars['Boolean']['output']
  /** Deal notes, verbatim (ClosedDeal.notes — already host-visible on the deal detail page). */
  notes?: Maybe<Scalars['String']['output']>
  /**
   * True once a partner has confirmed this renter-declared deal
   * (`partnerConfirmedAt` is stamped). TERMS ARE CONSENTED ONCE: the terms
   * panel and the server's confirm guard both ask for a price + start month
   * only while this is false. A confirmed deal that returns to "Nuevos
   * clientes" (a held "ya era mi cliente", a material edit) re-confirms with
   * ONE tap on its original terms; a change of terms goes through Corregir →
   * propuesta → «Aplicar» in the admin, never through a second Confirmar that
   * would silently re-date the accrual clock.
   */
  partnerConfirmed: Scalars['Boolean']['output']
  partnerConfirmedAt?: Maybe<Scalars['String']['output']>
  partnerConfirmedBy?: Maybe<Scalars['String']['output']>
  partnerConfirmedInCloseMonth: Scalars['Boolean']['output']
  /**
   * Provenance of the rent shown on this row. RENTER ⇒ label it "según el
   * interesado"; UNKNOWN ⇒ there is no price at all and the partner must type
   * one; PARTNER/LISTING/null ⇒ today's plain "Renta:" line.
   */
  priceSource?: Maybe<ClosedDealPriceSource>
  /** The pending structured proposal, echoed so revisits show WHAT was proposed. */
  proposal?: Maybe<IAccrualChangeProposal>
  /** Units rented (ClosedDeal.quantity) — prefill for the correction form. */
  quantity?: Maybe<Scalars['Int']['output']>
  /** When the deal was recorded (ClosedDeal.createdOn, UTC string). */
  recordedAt?: Maybe<Scalars['String']['output']>
  /**
   * True when SpotMe staff recorded this client (admin panel, MCP, chatbot,
   * pre-dealSource legacy) — NOT the partner's own declaration and NOT a
   * renter's claim. Non-null on the server; optional here because the roster
   * query only selects it once the server field is deployed.
   */
  recordedBySpotme?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when the RENTER told us they rented here and SpotMe recorded the deal on
   * their word alone (dealSource = RENTER_DECLARED, still unconfirmed). The row
   * renders the "Reportado por el interesado" badge and is TERMS-REQUIRED on
   * Confirmar: the partner must supply their own price AND start month, which is
   * what R11 means by consent on the exact terms.
   */
  renterDeclared: Scalars['Boolean']['output']
  renterEmail?: Maybe<Scalars['String']['output']>
  /**
   * Contact person on the deal (ClosedDeal.renterName). For BUSINESS deals this
   * is the person at the company (clientLabel carries the razón social); for
   * individuals it usually equals clientLabel — the UI dedupes. Same exposure as
   * the host deal-detail page, which already shows it to the same audience.
   */
  renterName?: Maybe<Scalars['String']['output']>
  renterPhone?: Maybe<Scalars['String']['output']>
  /**
   * The RENTER WITHDREW the "sí, renté ahí" this deal was built on
   * (`accrualRoster.renterRetractedAt`) — a DISTINCT state from `disputed`,
   * because a partner can clear a dispute by re-confirming and a renter-side
   * retraction must not ride on something the other party can lift.
   *
   * The row renders a retraction chip instead of the "Reportado por el
   * interesado" badge, drops the explainer line and the terms panel, and HIDES
   * Confirmar; «Algo no cuadra» and «Ya era mi cliente» stay. The server refuses
   * a CONFIRM on it regardless (`confirmActionError` → RENTER_RETRACTED), and
   * only an admin resolution can clear the flag.
   */
  renterRetracted: Scalars['Boolean']['output']
  /**
   * The renter's statement, built server-side from STRUCTURED fields only —
   * operator, since, price, channel, answer date ("Dice que rentó con Kubox desde
   * agosto a $2,500/mes — por WhatsApp, 8 sep"). The renter's FREE TEXT is their
   * reply to SpotMe and never crosses to the partner (spec §D4). Null when the
   * deal is not renter-declared, when the source lead no longer says RENTED_HERE,
   * or when nothing structured was captured.
   */
  renterStatement?: Maybe<Scalars['String']['output']>
  /**
   * LISTING vs ON_DEMAND. Non-null on purpose (readers test `=== ON_DEMAND`), and
   * resolved with the same `serviceKind ?? (locationId ? LISTING : ON_DEMAND)`
   * fallback everywhere — existing deals carry no stored `serviceKind` until the
   * Task 14 backfill runs, and a null here would error the whole preview.
   */
  serviceKind: ClosedDealServiceKind
  /** Per-unit monthly price (ClosedDeal.monthlyPrice) — prefill for the correction form. */
  unitPriceMxn?: Maybe<Scalars['Float']['output']>
}

/**
 * One PREVIOUS month's close for this partner: when/who submitted + the
 * invoice(s) it cut and their payment state. Newest first on the preview.
 */
export type IAccrualRosterPastClose = {
  __typename?: 'AccrualRosterPastClose'
  closeMonth: Scalars['String']['output']
  invoices: Array<IAccrualRosterInvoice>
  /** Send-state closedAt of that month (null = never submitted). */
  submittedAt?: Maybe<Scalars['String']['output']>
  /** Attribution of that month's latest submission. */
  submittedBy?: Maybe<Scalars['String']['output']>
}

/**
 * PUBLIC (token-authorized) month-close roster preview. The token encodes the
 * partner + close month; NOTHING here is invoiceable until the partner submits.
 */
export type IAccrualRosterPreview = {
  __typename?: 'AccrualRosterPreview'
  activeClients: Array<IAccrualRosterActiveClient>
  /** The month being closed, a mes vencido (YYYY-MM). */
  closeMonth: Scalars['String']['output']
  /**
   * Cap-reached clients (all devengo milestones billed — SpotMe charges
   * nothing further, ever). PASSIVE data-hygiene section: the partner may
   * optionally report an exit for tenure analytics; no confirmation is
   * asked, nothing bills either way, and these never hold the roster open.
   */
  completedClients: Array<IAccrualRosterCompletedClient>
  /**
   * Soft deadline for the close (first send + 10 days, UTC string). Urgency
   * copy only — nothing auto-bills after it; unconfirmed clients carry to the
   * next month's roster and admins get flagged to chase.
   */
  deadline?: Maybe<Scalars['String']['output']>
  /** Listings the partner can declare a new closed deal against from this roster page. */
  declarableListings: Array<IDeclarableListing>
  /**
   * Live payment state of the invoice(s) cut by THIS close month's submits
   * (empty when nothing was invoiced yet). Best-effort — a Stripe hiccup
   * resolves to [] rather than failing the preview.
   */
  invoices: Array<IAccrualRosterInvoice>
  /**
   * True when SpotMe has never billed this partner an accrual milestone —
   * closing this month would cut their FIRST factura ("tu primera factura con
   * SpotMe" framing).
   */
  isFirstCycle: Scalars['Boolean']['output']
  /**
   * Masked recognition rows behind the "Ver los N interesados" toggle —
   * newest first, capped at 50; may be shorter than leadsSentThisMonth.
   */
  leadsSent: Array<IRosterLeadSent>
  /** Count of partner-declared leads submitted this close month (throttling context for the UI). */
  leadsSentThisMonth: Scalars['Int']['output']
  newClients: Array<IAccrualRosterNewClient>
  /** Team name / host name — reflected in the page header. */
  partnerLabel?: Maybe<Scalars['String']['output']>
  /**
   * Previous months' closes (submission attribution + invoice payment state),
   * newest first — the partner's month-by-month history on one page.
   */
  pastCloses: Array<IAccrualRosterPastClose>
  /** Submission history for this close month, newest first. */
  submissions: Array<IAccrualRosterSubmission>
  /**
   * Set when this month's roster was already submitted (send-state closedAt,
   * UTC string). The page renders a "ya cerraste este mes" banner and switches
   * the CTA to resubmit copy — re-submits are idempotent (billed milestones
   * never bill twice).
   */
  submittedAt?: Maybe<Scalars['String']['output']>
  /** Attribution of the LATEST submission (name typed on the page / logged-in user). */
  submittedBy?: Maybe<Scalars['String']['output']>
}

/**
 * One submission of the month-close roster — attribution + timestamp history
 * shown on the "ya cerraste este mes" banner ("enviado por {nombre} el {fecha}").
 */
export type IAccrualRosterSubmission = {
  __typename?: 'AccrualRosterSubmission'
  /** UTC timestamp of the submit. */
  at: Scalars['String']['output']
  /** Who confirmed — the optional name typed on the page, else the logged-in user. */
  by?: Maybe<Scalars['String']['output']>
}

export type IAccrualRosterSubmitResult = {
  __typename?: 'AccrualRosterSubmitResult'
  /**
   * Deals whose CONFIRM was refused because the same rental looks like it is
   * already on this partner's roster under another row (matching renter phone
   * variant / email / normalized name inside the deal-match window). Confirming
   * both would run two accrual ladders for one rental. Admins are notified;
   * nothing is merged automatically.
   */
  duplicateSuspectDealIds: Array<Scalars['String']['output']>
  error?: Maybe<AccrualRosterError>
  /** Stripe hosted invoice page for the invoice this submit cut — view + pay. */
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>
  /** True when a consolidated Stripe invoice was cut for this close. */
  invoiceIssued: Scalars['Boolean']['output']
  lineItems: Array<IAccrualRosterLineItem>
  /**
   * Deals whose CONFIRM was refused for missing terms — a renter-declared row
   * submitted without BOTH a price and a start month, or any row with
   * priceSource UNKNOWN and no price. NOTHING was written for these: they stay
   * in "Nuevos clientes" and the page keeps their row state so the partner can
   * fill the fields in and re-submit. The rest of the submit still applies
   * (`success` stays true) — one unpriced row must not block a whole month.
   */
  priceRequiredDealIds: Array<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
  totalMxn?: Maybe<Scalars['Float']['output']>
}

/**
 * Input for activating off-platform billing on a closed deal. The pricing
 * engine (derivePlanDefaults) produces this from the deal config — the admin
 * may override any field before submitting.
 */
export type IActivateClosedDealBillingInput = {
  amountMxn: Scalars['Float']['input']
  billedEntityType: BilledEntityType
  /** Required when billedEntityType = TEAM. Inferred from closedDeal when omitted. */
  billedTeamId?: InputMaybe<Scalars['String']['input']>
  /** Required when billedEntityType = USER. Inferred from closedDeal when omitted. */
  billedUserId?: InputMaybe<Scalars['String']['input']>
  closedDealId: Scalars['String']['input']
  endCondition: BillingEndCondition
  endDate?: InputMaybe<Scalars['String']['input']>
  ivaIncluded: Scalars['Boolean']['input']
  monthsRemaining?: InputMaybe<Scalars['Int']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  startDate: Scalars['String']['input']
  stripeFeePayer: BillingFeePayer
  type: BillingType
}

export type IAddress = {
  __typename?: 'Address'
  city?: Maybe<Scalars['String']['output']>
  colonia?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  neighborhood?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  street1?: Maybe<Scalars['String']['output']>
  street2?: Maybe<Scalars['String']['output']>
  zipcode?: Maybe<Scalars['String']['output']>
}

export type IAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  colonia?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  neighborhood?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street1?: InputMaybe<Scalars['String']['input']>
  street2?: InputMaybe<Scalars['String']['input']>
  zipcode?: InputMaybe<Scalars['String']['input']>
}

/** Billing-state filter for the admin closed-deals tab. */
export enum AdminClosedDealsBillingStatus {
  /** billing.isEnabled = true AND not cancelled. */
  Active = 'ACTIVE',
  /** No filter — every deal. */
  Any = 'ANY',
  /** billing.cancelledAt set. */
  Cancelled = 'CANCELLED',
  /** Deals with no billing record at all (Phase 1 backfill candidates). */
  None = 'NONE',
  /** billing.hasOverdueInvoice = true (and active). */
  Overdue = 'OVERDUE'
}

export type IAdminClosedDealsFilter = {
  billingStatus?: InputMaybe<AdminClosedDealsBillingStatus>
  dealType?: InputMaybe<DealType>
}

/**
 * Admin-only compact host identity for a search/map card — lets the sales
 * team recognize the landlord (team or individual) at a glance. Resolved by
 * `Query.adminLocationHostBadges`; never embedded in public card payloads
 * (hosts are ANONYMOUS on renter-facing listing surfaces).
 */
export type IAdminHostBadge = {
  __typename?: 'AdminHostBadge'
  isTeam: Scalars['Boolean']['output']
  locationId: Scalars['String']['output']
  /** Team name when the listing belongs to a team, else the host's full name. */
  name: Scalars['String']['output']
}

export type IAdminEdit = {
  /** Omitted preserves the branch contact; null clears its override. */
  leadContact?: InputMaybe<ILeadContactInput>
  leadContacts?: InputMaybe<Array<ILeadContactInput>>
  configurations?: InputMaybe<Array<IConfigurationInput>>
  defaultConfigurationId?: InputMaybe<Scalars['String']['input']>
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * Branch reference for the search card (see `ILocation.locationReference`).
   * Admin-only on purpose — it is NOT in `ISubmitLocationInput`, so hosts
   * cannot set it themselves. Pass an empty string to clear.
   */
  locationReference?: InputMaybe<Scalars['String']['input']>
  /**
   * Corrects or clears the host-set logistics-services claim (see
   * `ILocation.logisticsServices`). Hosts can already edit this themselves
   * via the wizard; this lets an admin fix it without the host's
   * cooperation. Pass an empty array to clear.
   */
  logisticsServices?: InputMaybe<Array<LogisticsService>>
  /** Branch free-closes promo (0–20, server-validated). 0 ends it. */
  promoFreeClosesRemaining?: InputMaybe<Scalars['Int']['input']>
  /** Promo window end; omit to default to 6 months after publication. */
  promoFreeClosesUntil?: InputMaybe<Scalars['String']['input']>
  reviewCount?: InputMaybe<Scalars['Int']['input']>
  reviewScore?: InputMaybe<Scalars['Float']['input']>
  setDraft?: InputMaybe<Scalars['Boolean']['input']>
  visualScore?: InputMaybe<Scalars['Int']['input']>
}

export type IAdminNotificationSetting = {
  __typename?: 'AdminNotificationSetting'
  enabled: Scalars['Boolean']['output']
  methods: Array<NotificationMethod>
  type: AdminNotificationType
}

export type IAdminNotificationSettingInput = {
  enabled: Scalars['Boolean']['input']
  methods: Array<NotificationMethod>
  type: AdminNotificationType
}

export enum AdminNotificationType {
  Approvals = 'APPROVALS',
  Business = 'BUSINESS',
  CheckoutCancellation = 'CHECKOUT_CANCELLATION',
  DemandLead = 'DEMAND_LEAD',
  DemandSales = 'DEMAND_SALES',
  Finance = 'FINANCE',
  GracePeriodCancellation = 'GRACE_PERIOD_CANCELLATION',
  HostOpsDigest = 'HOST_OPS_DIGEST',
  LocationVerification = 'LOCATION_VERIFICATION',
  NewChat = 'NEW_CHAT',
  NewCheckoutRequest = 'NEW_CHECKOUT_REQUEST',
  OperationsEscalation = 'OPERATIONS_ESCALATION',
  OwnerChange = 'OWNER_CHANGE',
  ProStaleDigest = 'PRO_STALE_DIGEST',
  RecoveryWaPause = 'RECOVERY_WA_PAUSE',
  ReferralRequest = 'REFERRAL_REQUEST',
  RetentionDigest = 'RETENTION_DIGEST',
  StripeDispute = 'STRIPE_DISPUTE',
  SupplyLead = 'SUPPLY_LEAD',
  SupplyOps = 'SUPPLY_OPS',
  Urgent = 'URGENT',
  UserVerification = 'USER_VERIFICATION',
  WhatsappEscalation = 'WHATSAPP_ESCALATION'
}

export enum AdminPermission {
  AccessReports = 'ACCESS_REPORTS',
  EditLocations = 'EDIT_LOCATIONS',
  EditUsers = 'EDIT_USERS',
  ManageAdmins = 'MANAGE_ADMINS',
  ManageCheckouts = 'MANAGE_CHECKOUTS',
  ManagePayments = 'MANAGE_PAYMENTS',
  ManageReferrals = 'MANAGE_REFERRALS',
  ManageTeams = 'MANAGE_TEAMS',
  VerifyLocations = 'VERIFY_LOCATIONS',
  VerifyUsers = 'VERIFY_USERS',
  ViewChats = 'VIEW_CHATS'
}

export enum AdminRegion {
  Aguascalientes = 'AGUASCALIENTES',
  All = 'ALL',
  Cancun = 'CANCUN',
  Cdmx = 'CDMX',
  Chihuahua = 'CHIHUAHUA',
  Guadalajara = 'GUADALAJARA',
  Hermosillo = 'HERMOSILLO',
  Leon = 'LEON',
  LosCabos = 'LOS_CABOS',
  Merida = 'MERIDA',
  Monterrey = 'MONTERREY',
  Puebla = 'PUEBLA',
  PuertoVallarta = 'PUERTO_VALLARTA',
  Queretaro = 'QUERETARO',
  Tijuana = 'TIJUANA',
  Toluca = 'TOLUCA'
}

export enum AdminRole {
  Admin = 'ADMIN',
  Operations = 'OPERATIONS',
  Sales = 'SALES',
  SuperAdmin = 'SUPER_ADMIN',
  Support = 'SUPPORT',
  Viewer = 'VIEWER'
}

export type IAdminUserEdit = {
  accountVerificationError?: InputMaybe<Scalars['String']['input']>
  actividadEmpresarial?: InputMaybe<Scalars['Boolean']['input']>
  address?: InputMaybe<IAddressInput>
  adminNotificationSettings?: InputMaybe<Array<IAdminNotificationSettingInput>>
  adminPermissions?: InputMaybe<Array<AdminPermission>>
  adminRegions?: InputMaybe<Array<AdminRegion>>
  adminRole?: InputMaybe<AdminRole>
  bankTransferOnly?: InputMaybe<Scalars['Boolean']['input']>
  birthdate?: InputMaybe<Scalars['String']['input']>
  cfdiFormaPago?: InputMaybe<CfdiFormaPago>
  cfdiMetodoPago?: InputMaybe<CfdiMetodoPago>
  civilStatus?: InputMaybe<CivilStatus>
  clabe?: InputMaybe<Scalars['String']['input']>
  constanciaFiscal?: InputMaybe<IPhotoInput>
  curp?: InputMaybe<Scalars['String']['input']>
  currentCity?: InputMaybe<Scalars['String']['input']>
  customerType?: InputMaybe<CustomerType>
  description?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  facebookUrl?: InputMaybe<Scalars['String']['input']>
  favoriteSong?: InputMaybe<Scalars['String']['input']>
  /**
   * Grants a read-only finance role, distinct from admin. See `FinanceAccessRole`
   * for what each value gates. Set to null to revoke. Editing this field
   * requires AdminPermission.ManageAdmins.
   */
  financeAccess?: InputMaybe<FinanceAccessRole>
  firstname?: InputMaybe<Scalars['String']['input']>
  hobbie?: InputMaybe<Scalars['String']['input']>
  hostType?: InputMaybe<HostType>
  hsOwnerId?: InputMaybe<Scalars['String']['input']>
  instagramUrl?: InputMaybe<Scalars['String']['input']>
  interest?: InputMaybe<Interest>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>
  isVerified?: InputMaybe<Scalars['Boolean']['input']>
  job?: InputMaybe<Scalars['String']['input']>
  languages?: InputMaybe<Array<Scalars['String']['input']>>
  lastname?: InputMaybe<Scalars['String']['input']>
  lastnameMaternal?: InputMaybe<Scalars['String']['input']>
  movieAsLife?: InputMaybe<Scalars['String']['input']>
  notiPreferences?: InputMaybe<Array<INotificationPreferenceInput>>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  preferedNotiMethod?: InputMaybe<NotificationMethod>
  profilePicture?: InputMaybe<IPhotoInput>
  referrer?: InputMaybe<Scalars['String']['input']>
  regimenFiscal?: InputMaybe<RegimenFiscal>
  requestedVerification?: InputMaybe<Scalars['Boolean']['input']>
  rfc?: InputMaybe<Scalars['String']['input']>
  salesReferrer?: InputMaybe<Scalars['String']['input']>
  twitterUrl?: InputMaybe<Scalars['String']['input']>
  usoCFDI?: InputMaybe<UsoCfdi>
  /** @deprecated Veriff integration removed Apr 2026. Server ignores this input. Retained so older admin clients don't fail validation. */
  veriffStatus?: InputMaybe<VeriffStatus>
}

/**
 * Suggested capitalization / accent corrections for the user-typed name
 * fields. The AI populates only the fields it's confident about; null
 * fields are left alone. Applied silently by the auto-approve gate; shown
 * to admin in the AI verification card otherwise.
 */
export type IAiNameCorrections = {
  __typename?: 'AiNameCorrections'
  firstname?: Maybe<Scalars['String']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  lastnameMaternal?: Maybe<Scalars['String']['output']>
}

/**
 * Output of the async vision-LLM review of a KYC submission. Fires once per
 * new verification request (see runVerificationSideEffects → KycAiReview SQS event).
 * Phase 1 is advisory-only — the human admin still makes the final approve/reject
 * call. Field is null until the worker writes its verdict.
 */
export type IAiVerificationResult = {
  __typename?: 'AiVerificationResult'
  /**
   * Auto-action applied by the KYC gate after this verdict was persisted.
   * Null when no tier matched (admin reviews manually) or when kill
   * switches suppressed the action.
   */
  autoAction?: Maybe<IKycAutoActionRecord>
  birthdateMatches?: Maybe<Scalars['Boolean']['output']>
  /**
   * Properly-cased / accented versions of the user-typed name fields, when
   * the AI determined the user-typed name was obviously miscapitalized
   * (ALL CAPS / all lowercase) and a confident correction is available
   * using the ID's canonical spelling. Only populated fields are applied
   * by the auto-approve path — null individual fields are left untouched.
   */
  correctedNames?: Maybe<IAiNameCorrections>
  /**
   * Date of birth read from the ID (YYYY-MM-DD), not the self-reported value.
   * Surfaced to the admin reviewer so a birthdate mismatch can be judged
   * typo-vs-fraud and corrected deliberately. Null when not legible / absent.
   */
  extractedBirthdate?: Maybe<Scalars['String']['output']>
  /** match | no_match | cannot_assess (null when no profilePicture) */
  faceMatches?: Maybe<Scalars['String']['output']>
  /**
   * Model's confidence in the idDocumentAuthentic verdict (0-1). Load-bearing
   * input to the auto-action gate predicate. Persisted so the evaluateKycAi
   * script can replay gate decisions with historical verdicts.
   */
  idAuthenticConfidence?: Maybe<Scalars['Float']['output']>
  /** likely_real | likely_fake | uncertain */
  idDocumentAuthentic?: Maybe<Scalars['String']['output']>
  /** e.g. INE, passport, driverLicense, cedula, other, not_an_id */
  idDocumentType?: Maybe<Scalars['String']['output']>
  /**
   * Model's confidence in the idDocumentType classification (0-1) — how sure it
   * is about WHAT the image is, including how sure it is that it is NOT an ID at
   * all. Distinct from idAuthenticConfidence (genuine-vs-forged). Load-bearing
   * input to the auto-action gate's not_an_id reject tier.
   */
  idDocumentTypeConfidence?: Maybe<Scalars['Float']['output']>
  idExpired?: Maybe<Scalars['Boolean']['output']>
  model: Scalars['String']['output']
  nameMatches?: Maybe<Scalars['Boolean']['output']>
  /** Bumped when the prompt template changes — for calibration analysis. */
  promptVersion: Scalars['Int']['output']
  ranAt: Scalars['String']['output']
  /** One-paragraph explanation written by the model. */
  reasoning: Scalars['String']['output']
  /** Short, human-readable bullet list of concerns (empty when verdict=approve). */
  reasons: Array<Scalars['String']['output']>
  /** 0-1, higher = more confident the submission is real/valid. */
  score: Scalars['Float']['output']
  /**
   * The SELF-REPORTED birthdate (YYYY-MM-DD) as it stood when this verdict ran.
   * The profile value can change afterwards (an admin fixing a typo), so this is
   * the only record of what the model compared against — the KYC eval uses it to
   * tell a correct AI catch from a model that echoed the form. Null before
   * 2026-09-30 and when the profile had no birthdate.
   */
  selfReportedBirthdate?: Maybe<Scalars['String']['output']>
  /** approve | review | reject — surfaced to admin as a verdict pill. */
  verdict: Scalars['String']['output']
}

export type IAssesVerificationInput = {
  accountVerificationError?: InputMaybe<Scalars['String']['input']>
  birthdate?: InputMaybe<Scalars['String']['input']>
  dismissed?: InputMaybe<Scalars['Boolean']['input']>
  isVerified: Scalars['Boolean']['input']
  userId: Scalars['String']['input']
}

export type IAssessCheckoutInput = {
  checkoutId: Scalars['String']['input']
  isLandlordApproved: Scalars['Boolean']['input']
  landlordNotes?: InputMaybe<Scalars['String']['input']>
  rejectionReason?: InputMaybe<Scalars['String']['input']>
}

export enum AuthEmailType {
  ResetPassword = 'RESET_PASSWORD',
  Verification = 'VERIFICATION'
}

export type IBankInfo = {
  __typename?: 'BankInfo'
  accountNumber?: Maybe<Scalars['String']['output']>
  bank?: Maybe<Scalars['String']['output']>
  cardNumber?: Maybe<Scalars['String']['output']>
  cardType?: Maybe<CardType>
  clabe?: Maybe<Scalars['String']['output']>
  fullName?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
}

export type IBankInfoInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>
  bank?: InputMaybe<Scalars['String']['input']>
  cardNumber?: InputMaybe<Scalars['String']['input']>
  cardType?: InputMaybe<CardType>
  clabe?: InputMaybe<Scalars['String']['input']>
  fullName?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
}

/** Which entity gets billed for the host commission. */
export enum BilledEntityType {
  Team = 'TEAM',
  User = 'USER'
}

export enum BillingCancellationMode {
  /** subscriptions.update({ cancel_at_period_end: true }) — finishes current period. */
  AtPeriodEnd = 'AT_PERIOD_END',
  /** subscriptions.cancel({ prorate: false }) — stops now, open invoices stay collectable. */
  Immediate = 'IMMEDIATE',
  /** Immediate + invoices.voidInvoice on any open invoice — no charge. */
  ImmediateAndVoid = 'IMMEDIATE_AND_VOID'
}

/** How long the recurring billing runs. */
export enum BillingEndCondition {
  /** Stripe sub gets cancel_at set to endDate at activation; ends automatically. */
  EndDate = 'END_DATE',
  /** No end date — host is billed every month until admin cancels. */
  Indefinite = 'INDEFINITE',
  /** Converted to absolute endDate at activation; otherwise same as END_DATE. */
  MonthsRemaining = 'MONTHS_REMAINING'
}

/** Who pays the Stripe processing fee on the host commission invoice. */
export enum BillingFeePayer {
  Host = 'HOST',
  Spotme = 'SPOTME'
}

export enum BillingStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Delinquent = 'DELINQUENT',
  Paused = 'PAUSED',
  Pending = 'PENDING'
}

/** How SpotMe bills the host for the commission on this off-platform deal. */
export enum BillingType {
  /**
   * Devengo ladder for CommissionSchedule.ACCRUAL deals. NO Stripe artifact at
   * activation — the daily accrual cron issues one-time milestone invoices as
   * the client's paid rents fall due (presumption of continuity). amountMxn
   * holds the deal's monthly GMV (the ladder base).
   */
  Accrual = 'ACCRUAL',
  /** Stripe SubscriptionSchedule with N fixed phases (e.g. 2-month installments). */
  FixedInstallments = 'FIXED_INSTALLMENTS',
  /** Single Stripe invoice, charged once. */
  OneTime = 'ONE_TIME',
  /** Stripe Subscription, billed monthly until cancelled. */
  Recurring = 'RECURRING'
}

export type IBusinessInput = {
  locationId?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type IBussiness = {
  __typename?: 'Bussiness'
  description?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  profilePicture?: Maybe<IPhoto>
}

export type IBussinessInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  profilePicture?: InputMaybe<IPhotoInput>
}

export type ICalcDraftInput = {
  arm?: InputMaybe<Scalars['String']['input']>
  coordinates?: InputMaybe<ICoordinatesInput>
  locationType?: InputMaybe<LocationType>
  quantity?: InputMaybe<Scalars['Int']['input']>
  size?: InputMaybe<ISizeInput>
  zipcode?: InputMaybe<Scalars['String']['input']>
}

export type ICalcDraftResult = {
  __typename?: 'CalcDraftResult'
  claimSecret?: Maybe<Scalars['String']['output']>
  location: ILocation
  pfSource: Scalars['String']['output']
  priced: Scalars['Boolean']['output']
}

export type ICalcUploadFileInput = {
  byteLength: Scalars['Int']['input']
  contentType: Scalars['String']['input']
}

export type ICalcUploadUrl = {
  __typename?: 'CalcUploadUrl'
  id: Scalars['String']['output']
  uploadUrl: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type ICalculatePriceInput = {
  canStoreVehicle: Scalars['Boolean']['input']
  features?: InputMaybe<Array<Features>>
  googlePlaceId?: InputMaybe<Scalars['String']['input']>
  locationType?: InputMaybe<LocationType>
  quantity: Scalars['Int']['input']
  size: ISizeInput
  zipcode?: InputMaybe<Scalars['String']['input']>
}

export type ICancelClosedDealBillingInput = {
  closedDealId: Scalars['String']['input']
  mode: BillingCancellationMode
  reason?: InputMaybe<Scalars['String']['input']>
}

export type ICancellationBreakdown = {
  __typename?: 'CancellationBreakdown'
  blockedReason?: Maybe<Scalars['String']['output']>
  canCancel: Scalars['Boolean']['output']
  daysUsed?: Maybe<Scalars['Int']['output']>
  /** Full monthly charge (what renter pays inc. IVA) */
  fullMonthTotal: Scalars['Float']['output']
  hostNotaDeCredito?: Maybe<ICancellationNotaDeCredito>
  /** Prorated charge for final partial month (if applicable) */
  proratedTotal?: Maybe<Scalars['Float']['output']>
  renterRefund: ICancellationRefund
  /** Is a CLABE required from the renter? */
  requiresClabe: Scalars['Boolean']['output']
  retention: ICancellationRetention
  scenario: CancellationScenario
  spotmeNotaDeCredito?: Maybe<ICancellationNotaDeCredito>
  /** What SpotMe refunds the host (grace period: commission returned) */
  spotmeRefundToHost: Scalars['Float']['output']
  totalDaysInMonth?: Maybe<Scalars['Int']['output']>
}

export type ICancellationNotaDeCredito = {
  __typename?: 'CancellationNotaDeCredito'
  amount: Scalars['Float']['output']
  concept?: Maybe<Scalars['String']['output']>
  /** Pre-drafted concepto for the CFDI line item. */
  conceptoSugerido?: Maybe<Scalars['String']['output']>
  /** Step-by-step Spanish instructions for the host. */
  instructions?: Maybe<Array<Scalars['String']['output']>>
  /** True when the CFDI must be issued to "Público en general". */
  isPublicoEnGeneral?: Maybe<Scalars['Boolean']['output']>
  /**
   * CFDI recipient name. "Público en general" when the renter did not request
   * a factura on the original CFDI — the nota de crédito must match.
   */
  recipientName?: Maybe<Scalars['String']['output']>
  /** RFC of the CFDI recipient (XAXX010101000 for público en general). */
  recipientRfc?: Maybe<Scalars['String']['output']>
  required: Scalars['Boolean']['output']
  /** SAT CFDI tipo (always "Egreso" for nota de crédito). */
  tipo?: Maybe<Scalars['String']['output']>
  /** SAT uso CFDI code (always "G02" — Devoluciones, descuentos o bonificaciones). */
  usoCFDICode?: Maybe<Scalars['String']['output']>
  /** Spanish label for the uso CFDI. */
  usoCFDILabel?: Maybe<Scalars['String']['output']>
}

export type ICancellationRefund = {
  __typename?: 'CancellationRefund'
  /** Amount host transfers to renter via CLABE */
  fromHost: Scalars['Float']['output']
  /** Amount SpotMe refunds via Stripe (reverse_transfer or refund) */
  fromSpotMe: Scalars['Float']['output']
  /** Stripe processing fee — non-refundable */
  stripeFeeAbsorbed: Scalars['Float']['output']
  /** Human-readable timeline explanation */
  timeline: Scalars['String']['output']
  total: Scalars['Float']['output']
}

export type ICancellationRetention = {
  __typename?: 'CancellationRetention'
  applies: Scalars['Boolean']['output']
  hostType: Scalars['String']['output']
  isrRetention: Scalars['Float']['output']
  ivaRetention: Scalars['Float']['output']
  totalRetention: Scalars['Float']['output']
}

export enum CancellationScenario {
  GracePeriod = 'GRACE_PERIOD',
  /**
   * Host terminates the operation with less than 30 days notice (Anexo A §5 special rule).
   * Host must refund renter: prorated Recursos + 100% prorated Tarifa de Servicios +
   * 100% prorated Tarifa de Procesamiento for the affected period, within 7 calendar days.
   */
  HostEarlyTermination = 'HOST_EARLY_TERMINATION',
  Immediate = 'IMMEDIATE',
  PreStart = 'PRE_START',
  ScheduledEnd = 'SCHEDULED_END'
}

export type ICard = {
  __typename?: 'Card'
  brand?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  expMonth?: Maybe<Scalars['Int']['output']>
  expYear?: Maybe<Scalars['Int']['output']>
  funding?: Maybe<Scalars['String']['output']>
  last4?: Maybe<Scalars['String']['output']>
}

export enum CardType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export enum CfdiFormaPago {
  Id_03 = 'Id_03',
  Id_04 = 'Id_04',
  Id_17 = 'Id_17',
  Id_27 = 'Id_27',
  Id_28 = 'Id_28',
  Id_99 = 'Id_99'
}

export enum CfdiMetodoPago {
  Ppd = 'PPD',
  Pue = 'PUE'
}

export type IChat = INode & {
  __typename?: 'Chat'
  checkout?: Maybe<ICheckout>
  createdAt: Scalars['String']['output']
  currentParticipant?: Maybe<IChatParticipant>
  id: Scalars['String']['output']
  lastMessage?: Maybe<ILastMessage>
  lastMessageTimestamp: Scalars['String']['output']
  lastUpdatedOn: Scalars['String']['output']
  location?: Maybe<ILocation>
  /**
   * Which space the thread is about, for inbox rows: the listing of the latest
   * inquiry or booking message. Label only — resolved through the batched
   * loaders, so a list page adds a constant 3 BatchGets (checkouts + locations),
   * not a read per thread. Null when the thread never referenced a listing or
   * the listing no longer exists.
   */
  locationLabel?: Maybe<IChatLocationLabel>
  memberIds: Array<Scalars['String']['output']>
  members?: Maybe<Array<IUser>>
  messages?: Maybe<IChatMessagesResponse>
  owner?: Maybe<IOwnerInfo>
  participants: Array<IChatParticipant>
  unreadMessages?: Maybe<Scalars['Int']['output']>
}

export type IChatLocationLabel = {
  __typename?: 'ChatLocationLabel'
  /** Neighborhood, else colonia, else city — never the street address. */
  area?: Maybe<Scalars['String']['output']>
  /**
   * The unit the thread anchors on (the booked or inquired configuration, else
   * the listing's default) — type/size for the fallback when the host left the
   * title empty.
   */
  configuration?: Maybe<IConfiguration>
  id: Scalars['String']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type IChatMessagesArgs = {
  pagination: IPaginationInput
}

export type IChatMessagesResponse = {
  __typename?: 'ChatMessagesResponse'
  messages: Array<IMessage>
  total: Scalars['Int']['output']
}

export type IChatParticipant = {
  __typename?: 'ChatParticipant'
  id: Scalars['String']['output']
  team?: Maybe<ITeam>
  type: ChatParticipantType
  user?: Maybe<IUser>
}

export type IChatParticipantInput = {
  id: Scalars['String']['input']
  type: ChatParticipantType
}

export enum ChatParticipantType {
  Team = 'TEAM',
  User = 'USER'
}

export type ICheckout = INode & {
  __typename?: 'Checkout'
  accessAvailability?: Maybe<AccessAvailability>
  accessFrequency?: Maybe<AccessFrequency>
  accessHours?: Maybe<AccessHours>
  accessPermission?: Maybe<AccessPermission>
  addressUrl?: Maybe<Scalars['String']['output']>
  /**
   * When the space was RELEASED FOR NON-PAYMENT (UTC string) — set by BOTH the
   * automatic release and a host's manual "Liberar el espacio". It means
   * "this reservation ended because the first month was never paid", not "a cron
   * did it": use it to select the non-payment copy, never to infer the actor.
   */
  autoReleasedAt?: Maybe<Scalars['String']['output']>
  /**
   * Cards selectable for THIS checkout — read off the checkout's resolved billing
   * customer, which for an eligible B2B checkout is the TEAM's Stripe customer,
   * not the renter's personal one. `User.paymentMethods` only ever sees the
   * renter's own customer, so on a team checkout it comes back empty even though
   * a card was just saved; the wizard must read this field instead.
   */
  billingPaymentMethods?: Maybe<Array<IPaymentMethod>>
  /** Who initiated the scheduled cancellation: HOST or RENT */
  cancellationInitiatedBy?: Maybe<Interest>
  /** When the cancellation was requested */
  cancellationRequestedAt?: Maybe<Scalars['String']['output']>
  cancelledAt?: Maybe<Scalars['String']['output']>
  cancelledBy?: Maybe<Interest>
  /** Resolved User object for cancelledByUserId */
  cancelledByUser?: Maybe<IUser>
  /** userId of who cancelled or requested cancellation */
  cancelledByUserId?: Maybe<Scalars['String']['output']>
  chatId?: Maybe<Scalars['String']['output']>
  /**
   * Admin-only: full commission breakdown showing percentages and amounts.
   * Null for non-admin viewers.
   */
  commissionBreakdown?: Maybe<ICommissionBreakdown>
  /**
   * Admin-only: override SpotMe commission percentage (0-100).
   * When set, replaces the bracket-based commission calculation.
   * Null means default bracket logic applies.
   */
  commissionOverride?: Maybe<Scalars['Float']['output']>
  /**
   * How rent is collected for THIS rental. Stamped from the host team at
   * ASSESSMENT time (not at creation) and then immutable — the money legs that
   * ran (or didn't) are a historical fact, so a later host-team flip must never
   * retroactively change how an existing rental is billed. Null = PLATFORM.
   */
  collectionMode?: Maybe<CollectionMode>
  completedAt?: Maybe<Scalars['String']['output']>
  configurationId?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  currency?: Maybe<Scalars['String']['output']>
  /**
   * HOST_DIRECT only: the informative payment notices SpotMe has sent for this
   * rental (the idempotency ledger, newest last). Participant-or-admin, same gate
   * as `directPaymentInstructions`.
   */
  directNotices?: Maybe<Array<IDirectNotice>>
  /**
   * HOST_DIRECT only: where the renter sends the rent. Resolved LIVE from the
   * host team (so a corrected CLABE propagates) and returned ONLY to a checkout
   * participant or a SpotMe admin. Null on every PLATFORM checkout.
   */
  directPaymentInstructions?: Maybe<IDirectPaymentInstructions>
  /**
   * HOST_DIRECT only: the FIRST period (`YYYY-MM`) whose rent the renter pays
   * the host directly. A rental migrated from platform billing is stamped with
   * the CUTOVER period, not the migration date — so between the two it is
   * already HOST_DIRECT while SpotMe still collects the current month.
   */
  directSince?: Maybe<Scalars['String']['output']>
  endedAt?: Maybe<Scalars['String']['output']>
  endedReason?: Maybe<Scalars['String']['output']>
  /** When a booking request lapsed unanswered for 48 h (automatic rejection, Anexo A §3). */
  expiredAt?: Maybe<Scalars['String']['output']>
  /** Prorated charge for the final month (calculated at scheduling time) */
  finalMonthProratedAmount?: Maybe<Scalars['Float']['output']>
  /** The SpotMe Now «50% primer mes» this rent actually received, plus the early-exit clawback state. Null when no first-month discount was applied. */
  firstMonthDiscount?: Maybe<IFirstMonthDiscount>
  /**
   * When the first rent invoice on this rental was ever paid (UTC string).
   * Stamped once, never cleared — and never backfilled, so an unset value on an
   * old rental does NOT mean the renter never paid. Read it through
   * `isNeverPaidEpisode`, never as a bare presence check.
   */
  firstRentPaidAt?: Maybe<Scalars['String']['output']>
  /** Total refund for grace period: SpotMe commission + landlord portion (excludes Stripe fee) */
  gracePeriodRefundTotal?: Maybe<Scalars['Float']['output']>
  /** What SpotMe refunds the host for its commission portion */
  gracePeriodSpotmeRefund?: Maybe<Scalars['Float']['output']>
  /** Stripe fee amount that is NOT refunded */
  gracePeriodStripeFee?: Maybe<Scalars['Float']['output']>
  hasEnded?: Maybe<Scalars['Boolean']['output']>
  /**
   * Persisted boolean shadow of `missingFacturaPeriods.length > 0`.
   * Updated on fiscal-doc upload/discard/delete, on Stripe `invoice.paid`,
   * and by the daily recompute cron. Cheap to read on list views.
   */
  hasMissingFactura?: Maybe<Scalars['Boolean']['output']>
  /**
   * Pre-resolved nota de crédito guidance for the host (Anexo A 5.2/5.3).
   * Returns null when no refund is owed. Recipient is público en general
   * (XAXX010101000) when the renter did not request a factura on the original
   * CFDI; otherwise the team or individual renter. Same shape as the
   * CancellationBreakdown.hostNotaDeCredito field.
   */
  hostNotaDeCredito?: Maybe<ICancellationNotaDeCredito>
  /**
   * Tax retention breakdown for the host. Only returned when viewer is host or admin.
   * Null when viewer is renter, or when retention doesn't apply (e.g. persona moral
   * invoice dated before MORAL_RETENTION_START_EPOCH = 2026-06-01).
   */
  hostRetentionInfo?: Maybe<IHostRetentionInfo>
  /** When the last host unpaid notice went out (UTC string). */
  hostUnpaidNotifiedAt?: Maybe<Scalars['String']['output']>
  /**
   * How far the HOST ladder has gone on this episode: 1 = N35 heads-up sent,
   * 2 = N36 final notice sent. Reset when the episode clears.
   */
  hostUnpaidNotifiedStep?: Maybe<Scalars['Int']['output']>
  hubspotId?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  /**
   * Per-unit monthly premium (MXN) locked at checkout completion from a real
   * Chubb quote — what the Chubb subscription actually bills. Absent on
   * checkouts completed before dynamic pricing shipped (those billed the
   * legacy retail constant).
   */
  insurancePremium?: Maybe<Scalars['Float']['output']>
  /** When the locked premium was quoted (UTC string). */
  insuranceQuotedAt?: Maybe<Scalars['String']['output']>
  insuranceReceipts?: Maybe<Array<IInsuranceReceipt>>
  insuranceType?: Maybe<InsuranceType>
  invoices?: Maybe<IInvoicesResponse>
  /** Whether this cancellation is a 24-hour grace period cancellation */
  isGracePeriodCancellation?: Maybe<Scalars['Boolean']['output']>
  isLandlordApproved?: Maybe<Scalars['Boolean']['output']>
  landlord?: Maybe<IUser>
  landlordAssessedAt?: Maybe<Scalars['String']['output']>
  landlordId?: Maybe<Scalars['String']['output']>
  landlordNotes?: Maybe<Scalars['String']['output']>
  landlordPhotos?: Maybe<Array<IPhoto>>
  landlordReview?: Maybe<IReview>
  landlordTeam?: Maybe<ITeam>
  landlordTeamId?: Maybe<Scalars['String']['output']>
  /**
   * SAT payment classification from the most recent successful payment.
   * Updated on each payment via Stripe charge details.
   */
  lastPaymentSatInfo?: Maybe<ISatPaymentInfo>
  lastUpdatedOn: Scalars['String']['output']
  location?: Maybe<ILocation>
  locationId?: Maybe<Scalars['String']['output']>
  minMonths?: Maybe<Scalars['Int']['output']>
  /**
   * Live per-period missing list. Computed on read (Stripe call).
   * Use for the detail page where the period breakdown matters.
   */
  missingFacturaPeriods?: Maybe<Array<Scalars['String']['output']>>
  /**
   * Live per-period missing list enriched with the paid amount + subtotal/IVA
   * breakdown for each period. Same source-of-truth as `missingFacturaPeriods`
   * — that field is kept as a convenience projection of `period` strings.
   * Use this on the host detail page so each row can show what to factura.
   */
  missingFacturas?: Maybe<Array<IMissingFactura>>
  missingRefundDocuments?: Maybe<Scalars['Boolean']['output']>
  needsInvoice?: Maybe<Scalars['Boolean']['output']>
  oneTimeFees?: Maybe<Array<IOneTimeFee>>
  owner?: Maybe<IOwnerInfo>
  paymentError?: Maybe<Scalars['Boolean']['output']>
  price?: Maybe<Scalars['Float']['output']>
  pricing?: Maybe<IPricing>
  quantity?: Maybe<Scalars['Int']['output']>
  /** Amount the host owes the renter as refund for unused days */
  refundAmount?: Maybe<Scalars['Float']['output']>
  /**
   * Structured refund obligations the host owes the renter. Replaces the
   * single-scalar `refundAmount` for surfaces that need per-obligation
   * detail (rent proration, grace-period, deposit return, one-time-fee
   * reversal). `refundAmount` is kept for back-compat and equals the sum of
   * RENT_PRORATION + GRACE_PERIOD obligations (deposit return is tracked
   * separately by oneTimeFees).
   */
  refundObligations?: Maybe<Array<IRefundObligation>>
  /**
   * When set, the refund obligation has been resolved out-of-band — either
   * the host paid off-platform, the renter waived it, or an admin discarded
   * it. Banners, cron reminders, and N10/N24/N26 refund blocks all hide
   * while this is non-null. Reversible via unresolveRefund (admin-only).
   */
  refundResolution?: Maybe<IRefundResolution>
  rejectionReason?: Maybe<Scalars['String']['output']>
  renter?: Maybe<IUser>
  /** Renter's CLABE for host-direct refund */
  renterClabe?: Maybe<Scalars['String']['output']>
  renterId?: Maybe<Scalars['String']['output']>
  renterReview?: Maybe<IReview>
  renterTeam?: Maybe<ITeam>
  renterTeamId?: Maybe<Scalars['String']['output']>
  requestedEndDate?: Maybe<Scalars['String']['output']>
  requestedStartDate?: Maybe<Scalars['String']['output']>
  /**
   * When a rescission was CURED by payment in full (UTC string). The rental
   * continues; the notice is void.
   */
  rescissionCuredAt?: Maybe<Scalars['String']['output']>
  /**
   * When the rescission takes effect (UTC string) — notice + the §18 term. The
   * renter can still cure by paying in full before this instant.
   */
  rescissionEffectiveAt?: Maybe<Scalars['String']['output']>
  /** userId of the host / team member / admin who sent the rescission notice. */
  rescissionNoticeByUserId?: Maybe<Scalars['String']['output']>
  /**
   * When the Anexo A §18 rescission notice was sent (UTC string). Its presence
   * means a rescission is in flight or already effective.
   */
  rescissionNoticeSentAt?: Maybe<Scalars['String']['output']>
  /** Scheduled end date for flexible cancellation */
  scheduledEndDate?: Maybe<Scalars['String']['output']>
  specialDiscountId?: Maybe<Scalars['String']['output']>
  startedAt?: Maybe<Scalars['String']['output']>
  storageItems?: Maybe<Scalars['String']['output']>
  storageItemsPhotos?: Maybe<Array<IPhoto>>
  storageNeeds?: Maybe<Scalars['String']['output']>
  storageTime?: Maybe<StorageTime>
  stripeBankTransfer?: Maybe<Scalars['Boolean']['output']>
  stripeCheckoutSessionUrl?: Maybe<Scalars['String']['output']>
  stripeChubbSubId?: Maybe<Scalars['String']['output']>
  stripeDepositInvoiceId?: Maybe<Scalars['String']['output']>
  stripeFirstMonthInvoiceId?: Maybe<Scalars['String']['output']>
  stripePaymentMethod?: Maybe<IPaymentMethod>
  stripePaymentMethodCompletedAt?: Maybe<Scalars['String']['output']>
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>
  stripePriceId?: Maybe<Scalars['String']['output']>
  /** Replaced (older) Chubb subscription IDs from past plan-switches; kept for invoice history. */
  stripeReplacedChubbSubIds?: Maybe<Array<Scalars['String']['output']>>
  stripeSessionCreatedAt?: Maybe<Scalars['String']['output']>
  stripeSessionId?: Maybe<Scalars['String']['output']>
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>
  /**
   * Rent owed across open invoices (MXN). RENT ONLY — deposits and one-time fees
   * are in `unpaidDepositAmount`, and Chubb premiums are never counted.
   */
  unpaidAmount?: Maybe<Scalars['Float']['output']>
  /**
   * Open deposit / one-time-fee debt (MXN). Shown to the host, never summed into
   * rent, and never a reason to release or rescind.
   */
  unpaidDepositAmount?: Maybe<Scalars['Float']['output']>
  /** The security deposit alone, out of `unpaidDepositAmount`. Null = unknown (legacy untagged one-time invoices). */
  unpaidSecurityDepositAmount?: Maybe<Scalars['Float']['output']>
  /**
   * True when an open invoice carries the first-month charge — i.e. the renter
   * has not paid to start. Combined with `firstRentPaidAt` it decides release
   * (never paid) vs rescission (stopped paying).
   */
  unpaidIncludesFirstMonth?: Maybe<Scalars['Boolean']['output']>
  /** How many open rent invoices make up `unpaidAmount`. */
  unpaidInvoiceCount?: Maybe<Scalars['Int']['output']>
  /**
   * What the RENTER has already received on this episode: 1 = N17 reminder,
   * 2 = N18 warning, 3+ = N19 final. 0/null = nothing sent yet.
   */
  unpaidLadderStep?: Maybe<Scalars['Int']['output']>
  /**
   * Host pressed "Mantener la reserva": no automatic release before this instant
   * (UTC string). Belongs to the episode that granted it and is cleared with it.
   */
  unpaidReleaseHoldUntil?: Maybe<Scalars['String']['output']>
  /** When the host was warned that the space is about to be released (UTC string). */
  unpaidReleaseWarnedAt?: Maybe<Scalars['String']['output']>
  /**
   * `created` of the oldest open RENT invoice (UTC string). The clock every day
   * count in this feature is measured from.
   */
  unpaidSince?: Maybe<Scalars['String']['output']>
  vehicles?: Maybe<Array<IVehicle>>
  verifiedBy?: Maybe<Scalars['String']['output']>
  verifiedByUser?: Maybe<IUser>
}

export type ICheckoutResponse = {
  __typename?: 'CheckoutResponse'
  checkout: ICheckout
}

export type ICheckoutTabCounts = {
  __typename?: 'CheckoutTabCounts'
  active: Scalars['Int']['output']
  expired: Scalars['Int']['output']
  past: Scalars['Int']['output']
  pending: Scalars['Int']['output']
  /**
   * Rentals with an OPEN unpaid episode (`unpaidSince` set, not ended) in the
   * same scope as the other counts. Drives the badge on the host's Activas tab.
   * Always 0 on the renter-side `rentCounts` — a renter has no unpaid tab.
   */
  unpaid: Scalars['Int']['output']
  upcoming: Scalars['Int']['output']
}

export enum CheckoutType {
  Active = 'ACTIVE',
  /**
   * Requests that fell out of every other tab: never assessed before the
   * approval window lapsed (completedAt older than 2 days), or rejected.
   * Admins can still approve the lapsed ones within their 14-day window.
   */
  Expired = 'EXPIRED',
  Past = 'PAST',
  Pending = 'PENDING',
  UpComing = 'UP_COMING'
}

/**
 * How rent is COLLECTED for this team's SpotMe Now rentals. Orthogonal to
 * `TeamSegment` (commission economics) and to `bankTransferOnly` (which rail
 * SpotMe collects on).
 * - PLATFORM (default; null is treated as PLATFORM): SpotMe collects the full
 *   rent via Stripe, retains commission + fees + retenciones, transfers the rest.
 * - HOST_DIRECT: "SpotMe Now, cobro directo" — the renter pays the host team's
 *   own CLABE directly. SpotMe creates NO Stripe rent artifacts, sends the renter
 *   an informative payment notice per event, is BLIND to whether payment happened
 *   (zero reminders/dunning), and bills the host's Anexo A commission separately.
 */
export enum CollectionMode {
  HostDirect = 'HOST_DIRECT',
  Platform = 'PLATFORM'
}

export type ICheckoutsResponse = {
  __typename?: 'CheckoutsResponse'
  hits: Array<ICheckout>
  total: Scalars['Int']['output']
}

export enum CivilStatus {
  Divorced = 'DIVORCED',
  LivingTogether = 'LIVING_TOGETHER',
  Married = 'MARRIED',
  NotApplicable = 'NOT_APPLICABLE',
  Seperated = 'SEPERATED',
  Single = 'SINGLE',
  Widowed = 'WIDOWED'
}

/**
 * Off-platform deal manually recorded by a host or admin.
 * Tracks Broker and Traditional deals that close outside the SpotMe checkout flow.
 */
export type IClosedDeal = INode & {
  __typename?: 'ClosedDeal'
  /**
   * ACCRUAL only: which devengo ladder this deal bills on. Null = STANDARD_6.
   * Set per deal at close when the operator negotiated the stretched ladder
   * (see AccrualLadderPreset enum doc). Ignored for UPFRONT deals.
   */
  accrualLadderPreset?: Maybe<AccrualLadderPreset>
  /** Month-close roster state (ACCRUAL deals only). Read-only admin visibility. */
  accrualRoster?: Maybe<IClosedDealAccrualRoster>
  /** Off-platform billing config (host commission). Null when billing has not been activated. */
  billing?: Maybe<IClosedDealBilling>
  /** When the deal's billing/commission charging should begin. Defaults to closedAt when unset. */
  chargeStartDate?: Maybe<Scalars['String']['output']>
  closedAt: Scalars['String']['output']
  /**
   * Number of installments for non-recurring commissions (1, 2, or 3).
   *   - 1 → BillingType.ONE_TIME
   *   - 2 or 3 → BillingType.FIXED_INSTALLMENTS
   * Null/ignored when commissionType is PERCENTAGE_MONTHLY (always recurring).
   */
  commissionInstallments?: Maybe<Scalars['Int']['output']>
  /**
   * ACCRUAL (devengo on actually-paid rents — default for new Traditional
   * deals since 2026-07-08) vs UPFRONT (legacy fixed fee). Null = UPFRONT.
   */
  commissionSchedule?: Maybe<CommissionSchedule>
  /** See CommissionType enum doc — drives BillingType + lifetime calc. */
  commissionType?: Maybe<CommissionType>
  /**
   * Commission multiplier:
   *   - PERCENTAGE_TCV / PERCENTAGE_MONTHLY: decimal (0.05 = 5%)
   *   - MONTHS_OF_RENT: number of months (e.g. 1.5)
   */
  commissionValue?: Maybe<Scalars['Float']['output']>
  /** Configuration + location context, with public listing + dashboard URLs. */
  configuration?: Maybe<IClosedDealConfiguration>
  /**
   * The rented unit. NULL only on ON_DEMAND deals (no listing exists) — guard
   * every read; a label map keyed on it must fall back to
   * "Almacenamiento a domicilio · {onDemandCity}".
   */
  configurationId?: Maybe<Scalars['String']['output']>
  /** Fixed-term vs open-ended/month-to-month — open-ended resolves to the long-stay tier. */
  contractType?: Maybe<StorageContractType>
  createdOn: Scalars['String']['output']
  /**
   * ACCRUAL + accrualLadderPreset=CUSTOM only: the Jules-approved per-deal
   * devengo schedule the billing engine actually bills (see AccrualLadderPreset
   * enum doc). Null for every named preset.
   */
  customAccrualSchedule?: Maybe<Array<IAccrualScheduleStep>>
  /** Origin of this deal record. Null = legacy admin-recorded (pre-dates this field). */
  dealSource?: Maybe<DealSource>
  dealType: DealType
  /** Duration in months (optional) */
  duration?: Maybe<Scalars['Int']['output']>
  /** Customer's expected length of stay (months) — drives the Traditional/on-demand success-fee tier. */
  expectedStayMonths?: Maybe<Scalars['Int']['output']>
  /**
   * Active CFDI fiscal documents SpotMe has issued to the host for this
   * deal's commission (FACTURA) and any related notas de crédito if the
   * deal was partially refunded.
   *
   * Distinct from `billing.invoices` — those are the live Stripe invoices
   * SpotMe sends the host to COLLECT the commission. These are the Mexican
   * fiscal CFDIs SpotMe issues AFTER the commission is paid. The two
   * surfaces complement each other on the deal-detail view.
   *
   * Sorted by `uploadedAt` descending. Discarded documents are filtered
   * out. Visible to admin OR the deal's host (location owner / team
   * member) — same access gate as the rest of the deal. The list itself
   * is nullable (rather than empty-by-default) to match the lazy-resolver
   * pattern of the sibling fields (`billing`, `host`, `configuration`,
   * `landlordTeam`) — Query resolvers return the internal shape without
   * this field, the field resolver fills it on read.
   */
  fiscalDocuments?: Maybe<Array<IFiscalDocument>>
  /** Host that owns the deal's location (individual or team). Resolved from location. */
  host?: Maybe<IClosedDealHost>
  /** Host confirmation state for the HostConfirmN0 magic-link flow. Null until the request has been sent. */
  hostConfirmation?: Maybe<IClosedDealHostConfirmation>
  id: Scalars['String']['output']
  /** The deal's owning team, when the location is team-owned. Null otherwise. */
  landlordTeam?: Maybe<ITeam>
  /** The deal's individual host, when the location is user-owned. Null otherwise. */
  landlordUser?: Maybe<IUser>
  lastUpdatedOn: Scalars['String']['output']
  /** Declared reason for a missing source lead. Mutually exclusive with sourceLeadId. */
  leadAttribution?: Maybe<ClosedDealLeadAttribution>
  /**
   * The deal's location — full Location object. Gated by deal access
   * (admin / location owner / team member). Field-level auth on Location
   * is enforced by Location's own resolvers.
   */
  location?: Maybe<ILocation>
  /** The unit's listing. NULL only on ON_DEMAND deals — guard, never coerce. */
  locationId?: Maybe<Scalars['String']['output']>
  /** ON_DEMAND only: the canonical metro slug the close happened in. */
  onDemandCity?: Maybe<Scalars['String']['output']>
  partnerConfirmation?: Maybe<IPartnerConfirmation>
  /**
   * When the partner confirmed a RENTER_DECLARED deal on their roster. Until
   * it is set the deal never bills and is excluded from every revenue number.
   */
  partnerConfirmedAt?: Maybe<Scalars['String']['output']>
  /**
   * Direct partner anchor, independent of any listing. Takes precedence over
   * the listing owner; on a LISTING deal it equals the location's teamId.
   */
  partnerTeamId?: Maybe<Scalars['String']['output']>
  /** Provenance of monthlyPrice — see ClosedDealPriceSource. */
  priceSource?: Maybe<ClosedDealPriceSource>
  /** When the renter declared this close (RENTER_DECLARED only). */
  renterDeclaredAt?: Maybe<Scalars['String']['output']>
  /** LISTING (a unit) vs ON_DEMAND (a market close with no listing). Null = LISTING. */
  serviceKind?: Maybe<ClosedDealServiceKind>
  /** Unconfirmed months an admin can confirm onto the manual billing ledger (legacy closed deals only). */
  manualBillingCandidates?: Maybe<Array<IManualBillingCandidate>>
  /** Admin-recorded manual billing ledger for legacy closed deals (pre-dates automated billing). Null/empty on deals with no legacy history. */
  manualBillingLedger?: Maybe<Array<IManualBillingEntry>>
  /** Total monthly rent for the deal (already multiplied by quantity). */
  monthlyPrice: Scalars['Float']['output']
  notes?: Maybe<Scalars['String']['output']>
  /**
   * Number of units in this deal — relevant for parking, multi-bodega, or
   * warehouse fleet deals. Null/missing = 1 (legacy default).
   * monthlyPrice is the total across all units, NOT per-unit.
   */
  quantity?: Maybe<Scalars['Int']['output']>
  /** User ID of whoever recorded this deal */
  recordedBy: Scalars['String']['output']
  recordedByUser?: Maybe<IUser>
  renterEmail?: Maybe<Scalars['String']['output']>
  /** Renter contact name. For BUSINESS deals this is the contact person at the company. */
  renterName?: Maybe<Scalars['String']['output']>
  renterPhone?: Maybe<Scalars['String']['output']>
  /** When BUSINESS: legal company name (razón social). */
  renterRazonSocial?: Maybe<Scalars['String']['output']>
  /**
   * The renter's own rating of this off-platform rental, left on the public
   * /interesado/[token] page. Null until they submit one; ONE per deal, ever.
   * Unioned into `User.reviews` / `Team.reviews` by ReviewService — where the
   * row stays ANONYMOUS on the renter-facing side. Never written by an admin,
   * and never fed into `Location.reviewScore` / `reviewCount`.
   */
  renterReview?: Maybe<IClosedDealRenterReview>
  /** When BUSINESS: optional fiscal ID (RFC). */
  renterRfc?: Maybe<Scalars['String']['output']>
  /** Whether the renter is an individual or a business. Null/missing = INDIVIDUAL (legacy default). */
  renterType?: Maybe<RenterType>
  /** HubSpot owner ID of the sales rep who closed this deal */
  salesOwnerId?: Maybe<Scalars['String']['output']>
  /**
   * Vertical marker — LOGISTICS for Soluciones Logísticas (3PL) deals. Null =
   * regular space-only deal. For LOGISTICS deals, monthlyPrice records the
   * monthly FIXED SPACE commitment (services excluded — the 3PL fee base).
   */
  serviceModel?: Maybe<ClosedDealServiceModel>
  /** Present when the deal has been marked settled (paid off-platform / won't bill / other). Null otherwise. */
  settlement?: Maybe<IClosedDealSettlement>
  /** ID of the lead this deal was declared from (PARTNER_DECLARED dealSource only). */
  sourceLeadId?: Maybe<Scalars['String']['output']>
  /**
   * Per-period commission charge, ALWAYS WITHOUT IVA (subtotal).
   *   - PERCENTAGE_MONTHLY → one month's commission = monthlyPrice × commissionValue
   *   - PERCENTAGE_TCV / MONTHS_OF_RENT → same as spotmeRevenueLifetime (one-time
   *     or installment fee — there's no monthly equivalent)
   * Display IVA = subtotal × 0.16; total = subtotal × 1.16.
   */
  spotmeRevenue?: Maybe<Scalars['Float']['output']>
  /**
   * Total commission SpotMe expects to earn over the deal's full life, ALWAYS
   * WITHOUT IVA (subtotal).
   *   - PERCENTAGE_TCV     → monthlyPrice × duration × quantity × commissionValue
   *   - PERCENTAGE_MONTHLY → monthlyPrice × commissionValue × duration  (null if no duration)
   *   - MONTHS_OF_RENT     → monthlyPrice × commissionValue × quantity
   * Display IVA = subtotal × 0.16; total = subtotal × 1.16.
   */
  spotmeRevenueLifetime?: Maybe<Scalars['Float']['output']>
  /**
   * Amount charged per installment / per recurring period, ALWAYS WITHOUT IVA
   * (subtotal).
   *   - PERCENTAGE_TCV / MONTHS_OF_RENT → spotmeRevenueLifetime / commissionInstallments
   *   - PERCENTAGE_MONTHLY              → spotmeRevenue (one month)
   * Display IVA = subtotal × 0.16; total = subtotal × 1.16.
   */
  spotmeRevenuePerInstallment?: Maybe<Scalars['Float']['output']>
  /**
   * Lifecycle status of the deal (Upcoming / Open / Paid / Overdue / Settled).
   * Nullable on the type to satisfy no-mapper resolver typing, but the server
   * field resolver always populates it — treat as present (default to Open
   * if ever null).
   */
  status?: Maybe<ClosedDealStatus>
}

/**
 * Off-platform host billing configuration. Lives on ClosedDeal. Stripe holds
 * the source of truth for invoice/payment state — only configuration + Stripe
 * pointers + audit timestamps + a single ES-filter cache flag are stored here.
 *
 * Computed fields (status, lastPaymentAt, nextChargeAt, delinquentSince,
 * upcomingInvoiceAmountMxn) are resolved live from Stripe at read time so we
 * never have to keep them in sync.
 */
/**
 * What a ClosedDeal is anchored to. LISTING = a specific unit
 * (`configurationId`/`locationId` set). ON_DEMAND = an "almacenamiento a
 * domicilio" close with NO listing at all, anchored on `partnerTeamId` +
 * `onDemandCity`. Null = LISTING, and PERMANENTLY so for deals whose listing is
 * individually owned or purged — not un-backfilled data. Every reader tests
 * `=== ON_DEMAND`, never `=== LISTING`.
 */
export enum ClosedDealServiceKind {
  Listing = 'LISTING',
  OnDemand = 'ON_DEMAND'
}

/**
 * Where `monthlyPrice` came from. PARTNER is the only provenance that counts
 * as consent to terms — the roster's Confirmar writes it.
 */
export enum ClosedDealPriceSource {
  Listing = 'LISTING',
  Partner = 'PARTNER',
  Renter = 'RENTER',
  Unknown = 'UNKNOWN'
}

export type IClosedDealAccrualRoster = {
  __typename?: 'ClosedDealAccrualRoster'
  /** Latest month (YYYY-MM) the partner confirmed this client through. */
  confirmedThrough?: Maybe<Scalars['String']['output']>
  disputeNote?: Maybe<Scalars['String']['output']>
  /** When the partner flagged 'algo no cuadra'. Present ⇒ disputed. */
  disputedAt?: Maybe<Scalars['String']['output']>
  exitReportedAt?: Maybe<Scalars['String']['output']>
  firstConfirmedAt?: Maybe<Scalars['String']['output']>
  lastConfirmedAt?: Maybe<Scalars['String']['output']>
  /** Pending structured correction proposal — resolved via resolveAccrualRosterProposal. */
  proposal?: Maybe<IAccrualChangeProposal>
  /**
   * When the RENTER withdrew the "sí, renté ahí" this deal was built on (spec
   * §B5/§D3). A DISTINCT state from `disputedAt`: a partner can clear a dispute
   * by re-confirming, so a renter-side retraction cannot ride on it —
   * `confirmActionError` refuses CONFIRM outright while this is set, before it
   * looks at terms.
   *
   * ONLY «Resolver disputa» (`clearAccrualRosterDispute`) lifts it. Applying or
   * rejecting a PROPOSAL does not: an admin accepting the partner's numbers says
   * nothing about a claim the renter has withdrawn, and the row stays held and
   * un-confirmable while SpotMe is still talking to the renter.
   */
  renterRetractedAt?: Maybe<Scalars['String']['output']>
  /** Month (YYYY-MM) the partner reported the client left. Milestones past it never bill. */
  reportedExitMonth?: Maybe<Scalars['String']['output']>
}

export type IClosedDealBilling = {
  __typename?: 'ClosedDealBilling'
  /**
   * ACCRUAL only: ladder milestones (of 4 — 1st/3rd/5th/6th paid rent)
   * already invoiced. 4 = cap reached, billing complete.
   */
  accrualMilestonesBilled?: Maybe<Scalars['Int']['output']>
  /** Admin-only Stripe dashboard deep links. Null for non-admins. */
  adminLinks?: Maybe<IClosedDealBillingAdminLinks>
  amountMxn: Scalars['Float']['output']
  /** USER or TEAM. Drives which Stripe customer, RFC, and notification recipients are used. */
  billedEntityType: BilledEntityType
  billedTeamId?: Maybe<Scalars['String']['output']>
  billedUserId?: Maybe<Scalars['String']['output']>
  cancelledAt?: Maybe<Scalars['String']['output']>
  cancelledReason?: Maybe<Scalars['String']['output']>
  /** Oldest unpaid invoice's due_date, when delinquent. */
  delinquentSince?: Maybe<Scalars['String']['output']>
  endCondition: BillingEndCondition
  /** Absolute end date — set directly for END_DATE or derived from MONTHS_REMAINING + startDate. */
  endDate?: Maybe<Scalars['String']['output']>
  /**
   * Cache flag: the deal has at least one OPEN (unpaid, non-void) invoice —
   * whether or not it has passed its due date. Superset of hasOverdueInvoice.
   * Same dual maintainers (webhooks fast-path, dunning-cron sweep
   * authoritative). Drives the host notification trail: sidebar badge,
   * profile dot, list-row pill, detail-page banner, and
   * Query.pendingClosedDealCount.
   */
  hasOpenInvoice?: Maybe<Scalars['Boolean']['output']>
  /**
   * Cache flag with TWO maintainers — never trust as the live source of truth
   * for delinquency (that comes from Stripe):
   *
   * 1. Webhooks (fast path): invoice.payment_failed sets it, the next
   *    invoice.payment_succeeded clears it. NOTE: payment_failed only fires on
   *    a failed payment ATTEMPT — send_invoice invoices (all host-commission
   *    invoices) that simply pass their due_date unpaid fire NOTHING.
   * 2. The host-billing-dunning cron (authoritative, 2x daily): sweeps every
   *    active billing deal, checks the oldest open invoice's due_date against
   *    now via Stripe, and self-heals the flag in both directions.
   *
   * Drives the dunning cron's overdue-tier escalation (HB02/HB03) and the red
   * "Vencido" styling on host surfaces.
   */
  hasOverdueInvoice?: Maybe<Scalars['Boolean']['output']>
  /**
   * Stripe invoices attached to this billing plan. For RECURRING / FIXED_INSTALLMENTS,
   * pulled from the subscription. For ONE_TIME, looked up via stripeInvoiceIds.
   * Visible to admin OR the deal's host (location owner / team member).
   */
  invoices?: Maybe<Array<IClosedDealInvoice>>
  isEnabled: Scalars['Boolean']['output']
  ivaIncluded: Scalars['Boolean']['output']
  /** Latest paid invoice timestamp. */
  lastPaymentAt?: Maybe<Scalars['String']['output']>
  monthsRemaining?: Maybe<Scalars['Int']['output']>
  /** Next scheduled charge — sub.current_period_end for RECURRING. */
  nextChargeAt?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  startDate: Scalars['String']['output']
  /** Mapped from stripe.subscription.status (or invoice.status for ONE_TIME). */
  status?: Maybe<BillingStatus>
  /** Stripe customer for the billed entity. Reused from existing host customer — never duplicated. */
  stripeCustomerId: Scalars['String']['output']
  stripeFeePayer: BillingFeePayer
  /** For ONE_TIME, or a small cache of recent invoice IDs for dashboard render. */
  stripeInvoiceIds?: Maybe<Array<Scalars['String']['output']>>
  /** For FIXED_INSTALLMENTS only. */
  stripeScheduleId?: Maybe<Scalars['String']['output']>
  /** For RECURRING and FIXED_INSTALLMENTS. */
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>
  /** One-time, fixed installments, or open-ended monthly. */
  type: BillingType
  /** Stripe upcoming-invoice preview total. */
  upcomingInvoiceAmountMxn?: Maybe<Scalars['Float']['output']>
}

/** Admin-only quick links to the Stripe dashboard for this billing plan. */
export type IClosedDealBillingAdminLinks = {
  __typename?: 'ClosedDealBillingAdminLinks'
  stripeCustomerUrl?: Maybe<Scalars['String']['output']>
  stripeSubscriptionUrl?: Maybe<Scalars['String']['output']>
}

/**
 * Configuration + location context for a closed deal — narrow display shape
 * with ready-built navigation URLs (public listing + host dashboard).
 */
export type IClosedDealConfiguration = {
  __typename?: 'ClosedDealConfiguration'
  city?: Maybe<Scalars['String']['output']>
  /** Cover photo URL for the listing, if any. */
  coverPhotoUrl?: Maybe<Scalars['String']['output']>
  /** Host dashboard route — /dashboard/host/listings/{locationId}. */
  dashboardUrl: Scalars['String']['output']
  id: Scalars['String']['output']
  locationId: Scalars['String']['output']
  locationType?: Maybe<LocationType>
  nanoId?: Maybe<Scalars['String']['output']>
  neighborhood?: Maybe<Scalars['String']['output']>
  /** Public listing short URL (spotme.mx/c/{nanoId}). Null when nanoId is missing. */
  publicUrl?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

/**
 * Host of a closed deal — the owner of the deal's location. Derived from
 * location.teamId (TEAM) or location.submittedBy (INDIVIDUAL). Returns a
 * narrow shape: display name + an id to link to the relevant dashboard.
 */
export type IClosedDealHost = {
  __typename?: 'ClosedDealHost'
  /** Display name — team.name OR firstname+lastname. */
  name?: Maybe<Scalars['String']['output']>
  /** Profile picture / team icon, if any. */
  photoUrl?: Maybe<Scalars['String']['output']>
  /** When type=TEAM — the team id (links to /dashboard/host/team/[id]). */
  teamId?: Maybe<Scalars['String']['output']>
  type: ClosedDealHostType
  /** When type=INDIVIDUAL — the user id. */
  userId?: Maybe<Scalars['String']['output']>
}

export enum ClosedDealHostType {
  Individual = 'INDIVIDUAL',
  Team = 'TEAM'
}

/**
 * Why a closed deal carries NO source lead — the admin's declared answer.
 * Exactly one of sourceLeadId / leadAttribution is set on admin-created deals.
 * NOT_FOUND is the picker's own failure signal, distinct from the two
 * business reasons.
 */
export enum ClosedDealLeadAttribution {
  HostOwnCustomer = 'HOST_OWN_CUSTOMER',
  NotFound = 'NOT_FOUND',
  OtherChannel = 'OTHER_CHANNEL'
}

export enum ClosedDealSettlementReason {
  /**
   * VOID — the same client was already recorded on another deal
   * (`ClosedDealSettlement.duplicateOfClosedDealId`). Kept as the audit record;
   * every revenue / KPI / rep-commission reader treats it as never existing.
   */
  Duplicate = 'DUPLICATE',
  /** VOID — the close never happened (wrong partner, not a close, test). */
  EnteredInError = 'ENTERED_IN_ERROR',
  NotOriginated = 'NOT_ORIGINATED',
  Other = 'OTHER',
  PaidOffPlatform = 'PAID_OFF_PLATFORM',
  PromoFreeClose = 'PROMO_FREE_CLOSE',
  WontBill = 'WONT_BILL'
}

export enum ClosedDealStatus {
  Open = 'OPEN',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Settled = 'SETTLED',
  Upcoming = 'UPCOMING'
}

/**
 * A Stripe invoice attached to a closed deal's billing plan. Visible to the
 * deal's host (individual landlord or team member) and admins. Pulled live
 * from Stripe at read time — never persisted.
 */
export type IClosedDealInvoice = {
  __typename?: 'ClosedDealInvoice'
  amountMxn: Scalars['Float']['output']
  createdAt: Scalars['String']['output']
  currency: Scalars['String']['output']
  dueDate?: Maybe<Scalars['String']['output']>
  /** Renter-facing hosted invoice page (paying surface). */
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  /** Direct PDF download for the invoice. */
  invoicePdfUrl?: Maybe<Scalars['String']['output']>
  /** True when status=open AND now > dueDate. */
  isOverdue: Scalars['Boolean']['output']
  number?: Maybe<Scalars['String']['output']>
  paidAt?: Maybe<Scalars['String']['output']>
  periodEnd?: Maybe<Scalars['String']['output']>
  periodStart?: Maybe<Scalars['String']['output']>
  /** Stripe invoice status: draft, open, paid, void, uncollectible. */
  status: Scalars['String']['output']
}

export type IClosedDealSettlement = {
  __typename?: 'ClosedDealSettlement'
  /** DUPLICATE only: the surviving deal this one duplicates. */
  duplicateOfClosedDealId?: Maybe<Scalars['String']['output']>
  note?: Maybe<Scalars['String']['output']>
  reason: ClosedDealSettlementReason
  /** VOID only: the rep's already-paid commission was NOT clawed back. */
  repClawbackWaived?: Maybe<Scalars['Boolean']['output']>
  settledAt: Scalars['String']['output']
  settledBy: Scalars['String']['output']
  settledByUser?: Maybe<IUser>
  /** VOID only: frozen copy of the deal at void time (mistake log). */
  voidSnapshot?: Maybe<IClosedDealVoidSnapshot>
}

/** Frozen copy of a voided deal's key facts at void time (mistake log). */
export type IClosedDealVoidSnapshot = {
  __typename?: 'ClosedDealVoidSnapshot'
  closedAt: Scalars['String']['output']
  commissionOneTimeMxn: Scalars['Float']['output']
  commissionRecurringPerMoMxn: Scalars['Float']['output']
  createdOn?: Maybe<Scalars['String']['output']>
  dealSource?: Maybe<DealSource>
  dealType?: Maybe<DealType>
  locationId?: Maybe<Scalars['String']['output']>
  partnerTeamId?: Maybe<Scalars['String']['output']>
  recordedBy?: Maybe<Scalars['String']['output']>
  salesOwnerId?: Maybe<Scalars['String']['output']>
}

export type IClosedDealsResponse = {
  __typename?: 'ClosedDealsResponse'
  hits: Array<IClosedDeal>
  total: Scalars['Int']['output']
}

/**
 * Admin-only commission breakdown showing how the rent is split between SpotMe, Stripe, and the host.
 * All amounts are in MXN (subtotal, before IVA) unless noted.
 */
export type ICommissionBreakdown = {
  __typename?: 'CommissionBreakdown'
  /** Effective SpotMe commission percentage (override or bracket-computed) */
  commissionPercent: Scalars['Float']['output']
  /** Host receives per unit (subtotal, before retention) */
  hostAmount: Scalars['Float']['output']
  /** Host receives total (subtotal × quantity, before retention) */
  hostAmountTotal: Scalars['Float']['output']
  /** Whether a manual override is active */
  isOverride: Scalars['Boolean']['output']
  /** What the renter pays total (inc. IVA) */
  renterTotal: Scalars['Float']['output']
  /** SpotMe tarifa de servicios per unit (subtotal) */
  spotmeAmount: Scalars['Float']['output']
  /** SpotMe tarifa de servicios total (subtotal × quantity) */
  spotmeAmountTotal: Scalars['Float']['output']
  /** Stripe processing fee per unit (subtotal) */
  stripeFeeAmount: Scalars['Float']['output']
  /** Stripe processing fee total (subtotal × quantity) */
  stripeFeeAmountTotal: Scalars['Float']['output']
  /** Stripe transfer_data.amount_percent on the subscription */
  transferPercent: Scalars['Float']['output']
}

/**
 * How SpotMe's commission on a closed deal is calculated AND when it's billed.
 * The commission type implies a valid BillingType — admins do not pick BillingType
 * independently. See `derivePlanDefaults` and `BillingService.activate`.
 *
 *   - PERCENTAGE_TCV     → % of total contract value (monthlyPrice × duration × quantity)
 *                          billed once OR split into 2-3 fixed installments
 *   - PERCENTAGE_MONTHLY → % of each monthly rent, billed recurringly while active.
 *                          Can run indefinitely, until a fixed end date, or for N months.
 *   - MONTHS_OF_RENT     → N months of rent as flat commission,
 *                          billed once OR split into 2-3 fixed installments
 */
export enum CommissionType {
  MonthsOfRent = 'MONTHS_OF_RENT',
  PercentageMonthly = 'PERCENTAGE_MONTHLY',
  PercentageTcv = 'PERCENTAGE_TCV'
}

/**
 * How the Traditional / on-demand success fee is EARNED over time:
 * UPFRONT = legacy fixed fee from expected stay (null on old records);
 * ACCRUAL = devengo on the client's actually-paid rents (0.25× @1st →
 * 1× @3rd → 1.25× @5th → 2× cap @6th) — default for new Traditional deals
 * since 2026-07-08. See src/utils/accrualLadder.ts + sales/commission-model.md.
 */
export enum CommissionSchedule {
  Accrual = 'ACCRUAL',
  Upfront = 'UPFRONT'
}

/** Fixed-term vs open-ended/month-to-month — open-ended resolves to the long-stay (top) fee tier. */
export enum StorageContractType {
  FixedTerm = 'FIXED_TERM',
  MonthToMonth = 'MONTH_TO_MONTH'
}

/** PER_DEAL: one billing plan per closed deal (built). MONTHLY_CONSOLIDATED: reserved (not yet implemented). */
export enum ClosedDealInvoicingMode {
  MonthlyConsolidated = 'MONTHLY_CONSOLIDATED',
  PerDeal = 'PER_DEAL'
}

/**
 * A renter-declared review of an off-platform close. Written only by
 * `setRenterLeadReviewByToken` — see ClosedDeal.renterReview.
 */
export type IClosedDealRenterReview = {
  __typename?: 'ClosedDealRenterReview'
  createdAt: Scalars['String']['output']
  /** 1-5. Float (not Int) to match the ES mapping and the on-platform `Review.rating`. */
  rating: Scalars['Float']['output']
  /** Optional free text. Stored but never indexed. */
  review?: Maybe<Scalars['String']['output']>
}

/** Corrected terms for an AMEND repair. Every field optional — omitted = unchanged. */
export type IClosedDealRepairEditsInput = {
  /** Corrected per-invoice billing amount (MXN, sin-IVA subtotal). Drives void+reissue. */
  amountMxn?: InputMaybe<Scalars['Float']['input']>
  commissionInstallments?: InputMaybe<Scalars['Int']['input']>
  commissionType?: InputMaybe<CommissionType>
  commissionValue?: InputMaybe<Scalars['Float']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  monthlyPrice?: InputMaybe<Scalars['Float']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
}

/**
 * Repair mode for `closedDealRepairPreview` / `repairClosedDeal`.
 * DISCARD = the client never actually closed (SAT-cancel facturas motive 03,
 * void open invoices, delete the deal). AMEND = the deal closed at different
 * terms (update terms + billing amount, void+reissue open invoices; the old
 * factura's motive-01 cancellation is a deferred follow-up).
 */
export enum ClosedDealRepairMode {
  Amend = 'AMEND',
  Discard = 'DISCARD'
}

/**
 * Commercial vertical marker for a closed deal when it isn't derivable from
 * dealType. LOGISTICS = Soluciones Logísticas (3PL) matching — space PLUS
 * operator services. Null = regular space-only deal. Widens ACCRUAL
 * eligibility beyond Traditional and defaults the ladder to LOGISTICS_6.
 */
export enum ClosedDealServiceModel {
  Logistics = 'LOGISTICS'
}

/**
 * Read-only repair plan. `refusals` non-empty = the repair will NOT execute
 * (money already moved, nothing to do). Strings are pre-formatted for display.
 */
export type IClosedDealRepairPlan = {
  __typename?: 'ClosedDealRepairPlan'
  /** Ordered actions, human-readable. Execute top to bottom. */
  actions: Array<Scalars['String']['output']>
  /** ACTIVE facturas on the deal (id · periodo · facturapi/manual). */
  facturasSummary: Array<Scalars['String']['output']>
  /** Deferred manual steps to run AFTER the sync actions (amend's motive-01 cancel-cfdi). */
  followUps: Array<Scalars['String']['output']>
  /** Every Stripe invoice on the deal (id · status · amount · periodo). */
  invoicesSummary: Array<Scalars['String']['output']>
  /** Hard blocks — non-empty means the mutation would refuse. */
  refusals: Array<Scalars['String']['output']>
  warnings: Array<Scalars['String']['output']>
}

export type IClosedDealRepairResult = {
  __typename?: 'ClosedDealRepairResult'
  executedActions: Array<Scalars['String']['output']>
  followUps: Array<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** One tier of a Traditional/on-demand success-fee scheme. Fee = multiplier × one month's rent. */
export type ICommissionTier = {
  __typename?: 'CommissionTier'
  /** Inclusive upper bound on the customer's expected stay (months). Null = open-ended top tier. */
  maxStayMonths?: Maybe<Scalars['Int']['output']>
  /** Commission as a multiple of one month's rent. */
  multiplier: Scalars['Float']['output']
}

/** A team's Traditional/on-demand success-fee scheme. Null on a team → the global standard applies. */
export type ICommissionScheme = {
  __typename?: 'CommissionScheme'
  monthToMonthMultiplier: Scalars['Float']['output']
  tiers: Array<ICommissionTier>
}

export type ICommissionTierInput = {
  maxStayMonths?: InputMaybe<Scalars['Int']['input']>
  multiplier: Scalars['Float']['input']
}

export type ICommissionSchemeInput = {
  monthToMonthMultiplier: Scalars['Float']['input']
  tiers: Array<ICommissionTierInput>
}

/** Per-team off-platform commission invoicing configuration. */
export type IClosedDealInvoicingConfig = {
  __typename?: 'ClosedDealInvoicingConfig'
  mode: ClosedDealInvoicingMode
  /** Pay-as-you-collect cap: max fraction of each month's rent collected toward the fee until covered. Null → no spread. */
  paymentSpreadPercent?: Maybe<Scalars['Float']['output']>
}

export type IClosedDealInvoicingConfigInput = {
  mode: ClosedDealInvoicingMode
  paymentSpreadPercent?: InputMaybe<Scalars['Float']['input']>
}

export enum ClosedDealConfirmationError {
  AlreadyConfirmed = 'ALREADY_CONFIRMED',
  InvalidToken = 'INVALID_TOKEN',
  RateLimited = 'RATE_LIMITED'
}

export enum HostConfirmationStatus {
  Confirmed = 'CONFIRMED',
  Disputed = 'DISPUTED',
  Overridden = 'OVERRIDDEN',
  Pending = 'PENDING'
}

export enum HostDisputeReason {
  DealFellThrough = 'DEAL_FELL_THROUGH',
  Other = 'OTHER',
  WrongDuration = 'WRONG_DURATION',
  WrongPrice = 'WRONG_PRICE'
}

/** Host confirmation state for a closed deal — see `ClosedDeal.hostConfirmation`. */
export type IClosedDealHostConfirmation = {
  __typename?: 'ClosedDealHostConfirmation'
  disputeDetails?: Maybe<Scalars['String']['output']>
  disputeReason?: Maybe<HostDisputeReason>
  overriddenBy?: Maybe<Scalars['String']['output']>
  overrideNote?: Maybe<Scalars['String']['output']>
  remindersSent?: Maybe<Scalars['Int']['output']>
  requestedAt: Scalars['String']['output']
  respondedAt?: Maybe<Scalars['String']['output']>
  status: HostConfirmationStatus
}

/** Preview shown on the public host-confirmation page (resolved from the magic-link token). */
export type IClosedDealConfirmationPreview = {
  __typename?: 'ClosedDealConfirmationPreview'
  /**
   * ACCRUAL deals only: the deal's OWN paid-rent ladder (ladderFor(deal) × the
   * deal's monthly GMV) — the rows the confirmation email renders. Null for
   * UPFRONT deals.
   */
  accrualMilestones?: Maybe<Array<IAccrualLadderStep>>
  chargeStartDate?: Maybe<Scalars['String']['output']>
  commissionInstallments?: Maybe<Scalars['Int']['output']>
  /** ACCRUAL → confirm page renders the devengo ladder instead of a fixed fee. */
  commissionSchedule?: Maybe<CommissionSchedule>
  commissionType?: Maybe<CommissionType>
  commissionValue?: Maybe<Scalars['Float']['output']>
  dealType: DealType
  duration?: Maybe<Scalars['Int']['output']>
  expectedStayMonths?: Maybe<Scalars['Int']['output']>
  listingCity?: Maybe<Scalars['String']['output']>
  listingTitle?: Maybe<Scalars['String']['output']>
  monthlyPrice: Scalars['Float']['output']
  oneTimeCommissionMxn?: Maybe<Scalars['Float']['output']>
  quantity?: Maybe<Scalars['Int']['output']>
  recurringCommissionPerMoMxn?: Maybe<Scalars['Float']['output']>
  renterLabel?: Maybe<Scalars['String']['output']>
  status: HostConfirmationStatus
}

/** Result of a host confirm/dispute action from the public magic-link page. */
export type IClosedDealConfirmationResult = {
  __typename?: 'ClosedDealConfirmationResult'
  error?: Maybe<ClosedDealConfirmationError>
  status?: Maybe<HostConfirmationStatus>
  success: Scalars['Boolean']['output']
}

/**
 * One dirty-field patch for a single configuration. The client sends ONLY the
 * fields the host actually changed (dirty-only send — Task 13) so an untouched
 * field is never present and therefore never overwrites a concurrent change.
 */
export type IConfigInventoryUpdateInput = {
  availability?: InputMaybe<Scalars['Int']['input']>
  configurationId: Scalars['String']['input']
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>
  locationId: Scalars['String']['input']
  price?: InputMaybe<Scalars['Float']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  /** TRADITIONAL only: true removes the unit's promotion. */
  clearOperatorPromo?: InputMaybe<Scalars['Boolean']['input']>
  /** SpotMe Now (MONTHLY) only: the host's 50%-first-month opt-in (host-funded). */
  discountEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** TRADITIONAL only: the operator's own promotion, live immediately. */
  operatorPromo?: InputMaybe<IOperatorPromoInput>
}

export type IConfiguration = INode & {
  __typename?: 'Configuration'
  availability?: Maybe<Scalars['Int']['output']>
  canStoreVehicle?: Maybe<Scalars['Boolean']['output']>
  coverPhotoId?: Maybe<Scalars['String']['output']>
  createdOn: Scalars['String']['output']
  dealType?: Maybe<DealType>
  discountEnabled?: Maybe<Scalars['Boolean']['output']>
  dynamicPricing?: Maybe<Scalars['Boolean']['output']>
  features?: Maybe<Array<Features>>
  id: Scalars['String']['output']
  isDeactivated?: Maybe<Scalars['Boolean']['output']>
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  lastUpdatedOn: Scalars['String']['output']
  locationType?: Maybe<LocationType>
  metrics?: Maybe<IConfigurationMetrics>
  minMonths?: Maybe<Scalars['Int']['output']>
  minPrice?: Maybe<Scalars['Float']['output']>
  nanoId?: Maybe<Scalars['String']['output']>
  oneTimeFees?: Maybe<Array<IOneTimeFee>>
  /**
   * The Traditional operator's OWN current promotion (server-gated:
   * Traditional only, re-verified within 45 days, not expired). Mirrored from
   * `graphql/operatorPromo.graphql` by hand. Read-only — NOT on
   * ConfigurationInput; strip it before any save.
   */
  operatorPromo?: Maybe<IOperatorPromo>
  pillarPage?: Maybe<Scalars['String']['output']>
  price?: Maybe<Scalars['Float']['output']>
  pricing?: Maybe<IPricing>
  quantity?: Maybe<Scalars['Int']['output']>
  reservations?: Maybe<ICheckoutsResponse>
  /**
   * Computed deal type — uses `dealType` when set (explicit admin/host
   * override wins), otherwise infers from price + pillar promotion. Always
   * resolves to one of Monthly / Broker / Traditional; never null when a
   * real configuration is returned. Read-only — input types do NOT accept
   * this field. Mutations write `dealType`; reads should prefer
   * `resolvedDealType`. Source of truth: `resolveDealType` in
   * `src/api/location/prices.ts`. Mirrors `getEffectiveDealType` in the
   * frontend's `src/utils/pricing.ts` — both MUST stay in sync.
   */
  resolvedDealType?: Maybe<DealType>
  size?: Maybe<ISize>
  specialDiscount?: Maybe<IDiscount>
  specialDiscountId?: Maybe<Scalars['String']['output']>
  suggestedPrice?: Maybe<Scalars['Float']['output']>
  urlRoute?: Maybe<Scalars['String']['output']>
  watchingCount?: Maybe<Scalars['Int']['output']>
}

export type IConfigSummary = {
  __typename?: 'ConfigSummary'
  /** Count of active (non-deactivated, non-deleted, available) configurations. */
  activeCount: Scalars['Int']['output']
  /** Price of the config with the lowest price-per-m² (broker/per-m² cards). */
  cheapestPerSqmPrice?: Maybe<Scalars['Float']['output']>
  /** Area in m² of the cheapest-per-m² config. */
  cheapestPerSqmSizeM2?: Maybe<Scalars['Float']['output']>
  /** Lowest absolute price across active priced configs (the 'Desde $X' value). */
  cheapestPrice?: Maybe<Scalars['Float']['output']>
  /** Area in m² of the cheapest-by-absolute-price config. */
  cheapestSizeM2?: Maybe<Scalars['Float']['output']>
  /** Largest active config area in m² (null when 0/1 active config). */
  maxSizeM2?: Maybe<Scalars['Float']['output']>
  /** Smallest active config area in m² (null when 0/1 active config). */
  minSizeM2?: Maybe<Scalars['Float']['output']>
  /**
   * Sum of `availability` across the active configurations this summary was
   * computed over. The resolver pre-filters via
   * `filterConfigurations({active:true})`, which excludes configs with UNSET
   * availability — so those contribute nothing here. Powers the parking
   * card's "N disponibles" pill. Computed for ANY active count — including
   * 0/1 — unlike the value fields.
   */
  totalAvailability: Scalars['Int']['output']
}

export type IConfigurationReservationsArgs = {
  pagination: IPaginationInput
}

export type IConfigurationInput = {
  availability?: InputMaybe<Scalars['Int']['input']>
  canStoreVehicle?: InputMaybe<Scalars['Boolean']['input']>
  coverPhotoId?: InputMaybe<Scalars['String']['input']>
  dealType?: InputMaybe<DealType>
  discountEnabled?: InputMaybe<Scalars['Boolean']['input']>
  dynamicPricing?: InputMaybe<Scalars['Boolean']['input']>
  features?: InputMaybe<Array<Features>>
  id?: InputMaybe<Scalars['String']['input']>
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>
  locationType?: InputMaybe<LocationType>
  minMonths?: InputMaybe<Scalars['Int']['input']>
  minPrice?: InputMaybe<Scalars['Float']['input']>
  nanoId?: InputMaybe<Scalars['String']['input']>
  oneTimeFees?: InputMaybe<Array<IOneTimeFeeInput>>
  price?: InputMaybe<Scalars['Float']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  size?: InputMaybe<ISizeInput>
  specialDiscountId?: InputMaybe<Scalars['String']['input']>
  suggestedPrice?: InputMaybe<Scalars['Float']['input']>
}

export type IConfigurationMetrics = {
  __typename?: 'ConfigurationMetrics'
  computedAt?: Maybe<Scalars['String']['output']>
  current?: Maybe<IMetricsPeriod>
  previous?: Maybe<IMetricsPeriod>
}

export type IConfigurationStats = {
  __typename?: 'ConfigurationStats'
  availableUnits: Scalars['Int']['output']
  totalConfigurations: Scalars['Int']['output']
  totalUnits: Scalars['Int']['output']
}

export type IConfirmInmuebleByInventoryTokenInput = {
  fields: Array<IInmuebleFieldInput>
  locationId: Scalars['String']['input']
  token: Scalars['String']['input']
}

export type IConfirmInmuebleByTokenInput = {
  /** Fields the host changed. Omitted fields are confirmed as shown. */
  fields: Array<IInmuebleFieldInput>
  token: Scalars['String']['input']
}

export type IConfirmInmuebleInput = {
  /** Fields the host changed. Omitted fields are confirmed as shown. */
  fields: Array<IInmuebleFieldInput>
  locationId: Scalars['String']['input']
}

export enum ConstanciaFiscalPersonType {
  Fisica = 'FISICA',
  Moral = 'MORAL'
}

export type IConstanciaFiscalReading = {
  __typename?: 'ConstanciaFiscalReading'
  city?: Maybe<Scalars['String']['output']>
  colonia?: Maybe<Scalars['String']['output']>
  curp?: Maybe<Scalars['String']['output']>
  firstname?: Maybe<Scalars['String']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  lastnameMaternal?: Maybe<Scalars['String']['output']>
  legalName?: Maybe<Scalars['String']['output']>
  personType?: Maybe<ConstanciaFiscalPersonType>
  regimenesFiscales: Array<RegimenFiscal>
  rfc?: Maybe<Scalars['String']['output']>
  source: ConstanciaFiscalSource
  state?: Maybe<Scalars['String']['output']>
  street1?: Maybe<Scalars['String']['output']>
  street2?: Maybe<Scalars['String']['output']>
  warnings: Array<Scalars['String']['output']>
  zipcode?: Maybe<Scalars['String']['output']>
}

export enum ConstanciaFiscalSource {
  Image = 'IMAGE',
  PdfText = 'PDF_TEXT'
}

export type ICoordinates = {
  __typename?: 'Coordinates'
  lat: Scalars['Float']['output']
  lng: Scalars['Float']['output']
}

export type ICoordinatesInput = {
  lat: Scalars['Float']['input']
  lng: Scalars['Float']['input']
}

export type ICreateClosedDealInput = {
  /**
   * ACCRUAL only — which devengo ladder the deal bills on. Omit for the
   * standard ladder (LOGISTICS deals default to LOGISTICS_6); set STRETCH_8
   * only when the operator's contract carries the stretched ladder,
   * LOGISTICS_FLAT_9 only on serviceModel=LOGISTICS deals whose contract
   * carries the flat 11.11% schedule, CUSTOM only with a Jules-approved
   * customAccrualSchedule. Ignored (stored null) for UPFRONT deals.
   */
  accrualLadderPreset?: InputMaybe<AccrualLadderPreset>
  /** When billing/commission charging should begin. Defaults to closedAt when unset. */
  chargeStartDate?: InputMaybe<Scalars['String']['input']>
  closedAt: Scalars['String']['input']
  /** 1, 2, or 3. Required when commissionType is PERCENTAGE_TCV or MONTHS_OF_RENT; rejected for PERCENTAGE_MONTHLY. */
  commissionInstallments?: InputMaybe<Scalars['Int']['input']>
  /** Omit to default: Traditional → ACCRUAL, everything else → UPFRONT. */
  commissionSchedule?: InputMaybe<CommissionSchedule>
  commissionType?: InputMaybe<CommissionType>
  commissionValue?: InputMaybe<Scalars['Float']['input']>
  /**
   * The rented unit. Omit ONLY for an on-demand close, which must then carry
   * `partnerTeamId`.
   */
  configurationId?: InputMaybe<Scalars['String']['input']>
  /** Fixed-term vs open-ended; MONTH_TO_MONTH → long-stay (top) tier on auto-resolve. */
  contractType?: InputMaybe<StorageContractType>
  /**
   * Required when accrualLadderPreset=CUSTOM (rejected otherwise): the
   * Jules-approved per-deal devengo schedule. Validated server-side —
   * strictly increasing paidRents + cumulativeMultiplier, cap ≤ 2× for
   * Traditional/on-demand, ≤ 1× for serviceModel=LOGISTICS.
   */
  customAccrualSchedule?: InputMaybe<Array<IAccrualScheduleStepInput>>
  dealType: DealType
  duration?: InputMaybe<Scalars['Int']['input']>
  /** Customer's expected stay (months); with contractType, auto-resolves the Traditional/on-demand fee when commissionValue is omitted. */
  expectedStayMonths?: InputMaybe<Scalars['Int']['input']>
  /** Declared reason for a missing source lead. Exactly one of this / sourceLeadId on admin creates. */
  leadAttribution?: InputMaybe<ClosedDealLeadAttribution>
  monthlyPrice: Scalars['Float']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  renterEmail?: InputMaybe<Scalars['String']['input']>
  renterName?: InputMaybe<Scalars['String']['input']>
  renterPhone?: InputMaybe<Scalars['String']['input']>
  renterRazonSocial?: InputMaybe<Scalars['String']['input']>
  renterRfc?: InputMaybe<Scalars['String']['input']>
  renterType?: InputMaybe<RenterType>
  salesOwnerId?: InputMaybe<Scalars['String']['input']>
  /**
   * Set LOGISTICS when recording a Soluciones Logísticas (3PL) close. Widens
   * ACCRUAL eligibility beyond Traditional and defaults the ladder to
   * LOGISTICS_6. monthlyPrice MUST then be the monthly fixed SPACE
   * commitment (services excluded).
   */
  serviceModel?: InputMaybe<ClosedDealServiceModel>
  /**
   * The admin's explicit source-lead pick — may reference a lead sent to a
   * different host/listing (sales moves renters between locations). Admin
   * creates must send exactly one of this or leadAttribution.
   */
  sourceLeadId?: InputMaybe<Scalars['String']['input']>
  /** ON_DEMAND only: canonical metro slug. */
  onDemandCity?: InputMaybe<Scalars['String']['input']>
  /**
   * Direct partner anchor. Required when `configurationId` is omitted. On a
   * listing deal it must equal the location's teamId — a mismatch is rejected.
   */
  partnerTeamId?: InputMaybe<Scalars['String']['input']>
  /** Provenance of monthlyPrice — see ClosedDealPriceSource. */
  priceSource?: InputMaybe<ClosedDealPriceSource>
  /** Defaults to LISTING when a configuration is given, ON_DEMAND otherwise. */
  serviceKind?: InputMaybe<ClosedDealServiceKind>
}

export enum Currency {
  Mxn = 'MXN',
  Usd = 'USD'
}

export type ICustomerInfoInput = {
  /**
   * Vercel BotID verdict collected client-side pre-submit (soft-flag bot
   * defense). When true, the lead still reaches HubSpot + the admin email
   * (sales triages), but the host/partner notification is skipped.
   */
  botIdFlagged?: InputMaybe<Scalars['Boolean']['input']>
  company?: InputMaybe<Scalars['String']['input']>
  configId?: InputMaybe<Scalars['String']['input']>
  customerType?: InputMaybe<CustomerType>
  email: Scalars['String']['input']
  interest?: InputMaybe<Interest>
  lastname?: InputMaybe<Scalars['String']['input']>
  leadSource?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
  locationType?: InputMaybe<LocationType>
  message?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  nearestCity?: InputMaybe<Scalars['String']['input']>
  phone: Scalars['String']['input']
  quantity?: InputMaybe<Scalars['Int']['input']>
  referrer?: InputMaybe<Scalars['String']['input']>
  services?: InputMaybe<Array<Scalars['String']['input']>>
  storageTime?: InputMaybe<StorageTime>
}

export enum CustomerType {
  HostBroker = 'HOST_BROKER',
  HostCorporate = 'HOST_CORPORATE',
  HostIndividual = 'HOST_INDIVIDUAL',
  RentBroker = 'RENT_BROKER',
  RentIndividual = 'RENT_INDIVIDUAL'
}

/**
 * Origin of a ClosedDeal record — who/what declared it. Null = legacy
 * admin-recorded deal (pre-dates this field).
 */
export type IDashboardContext = {
  __typename?: 'DashboardContext'
  renter: IDashboardRenterContext
  /** USER scope first, then teams in the viewer's `teams` order. */
  scopes: Array<IDashboardScope>
}

export type IDashboardRenterContext = {
  __typename?: 'DashboardRenterContext'
  /** Viewer is renterId on at least one non-deleted checkout (own or team). */
  hasRents: Scalars['Boolean']['output']
  /** A team the viewer belongs to that is renterTeamId on one of their rents; else null. */
  team?: Maybe<IDashboardRenterTeam>
}

export type IDashboardRenterTeam = {
  __typename?: 'DashboardRenterTeam'
  iconUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
}

export type IDashboardScope = {
  __typename?: 'DashboardScope'
  /** Any non-deleted, non-directory listing, drafts and pending included. */
  anyListings: Scalars['Int']['output']
  hasClosedDeals: Scalars['Boolean']['output']
  hasLeads: Scalars['Boolean']['output']
  /** At least one checkout in Pending | UpComing | Active on this scope's listings. */
  hasOnPlatformRents: Scalars['Boolean']['output']
  iconUrl?: Maybe<Scalars['String']['output']>
  /** User id (USER) or team id (TEAM). */
  id: Scalars['String']['output']
  inventoryPending: Scalars['Int']['output']
  isLogistics: Scalars['Boolean']['output']
  isOnDemand: Scalars['Boolean']['output']
  isPartner: Scalars['Boolean']['output']
  kind: DashboardScopeKind
  /** Verified, not deactivated, not draft, not deleted, not a directory ficha. */
  liveListings: Scalars['Int']['output']
  name?: Maybe<Scalars['String']['output']>
  /** NONE for USER. A null team segment reads as NONE. */
  segment: TeamSegment
  viewerCanEdit: Scalars['Boolean']['output']
}

export enum DashboardScopeKind {
  Team = 'TEAM',
  User = 'USER'
}

export enum DealSource {
  Admin = 'ADMIN',
  Chatbot = 'CHATBOT',
  PartnerDeclared = 'PARTNER_DECLARED',
  RenterDeclared = 'RENTER_DECLARED'
}

export enum DealType {
  Broker = 'BROKER',
  Monthly = 'MONTHLY',
  Traditional = 'TRADITIONAL'
}

/** A configuration a partner can declare a new closed deal against. */
export type IDeclarableConfiguration = {
  __typename?: 'DeclarableConfiguration'
  configurationId: Scalars['String']['output']
  label: Scalars['String']['output']
  listedPriceMxn: Scalars['Float']['output']
}

/** A listing a partner can declare a new closed deal against, with its declarable configurations. */
export type IDeclarableListing = {
  __typename?: 'DeclarableListing'
  configurations: Array<IDeclarableConfiguration>
  label: Scalars['String']['output']
  locationId: Scalars['String']['output']
}

/** Input for declareClosedDeal — a partner-declared closed deal from the month-close roster. */
export type IDeclareClosedDealInput = {
  closedAt: Scalars['String']['input']
  /**
   * The rented unit. Omit ONLY for an on-demand close, which must then carry
   * `partnerTeamId` + `onDemandCity`.
   */
  configurationId?: InputMaybe<Scalars['String']['input']>
  expectedStayMonths?: InputMaybe<Scalars['Int']['input']>
  monthlyPriceMxn: Scalars['Float']['input']
  note?: InputMaybe<Scalars['String']['input']>
  /** On-demand declares only: canonical metro slug the close happened in. */
  onDemandCity?: InputMaybe<Scalars['String']['input']>
  /**
   * On-demand declares only: the partner team the close belongs to. The caller
   * must be a member (or an admin) and the team must service on-demand markets.
   */
  partnerTeamId?: InputMaybe<Scalars['String']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  renterEmail?: InputMaybe<Scalars['String']['input']>
  renterName?: InputMaybe<Scalars['String']['input']>
  renterPhone?: InputMaybe<Scalars['String']['input']>
  sourceLeadId?: InputMaybe<Scalars['String']['input']>
}

export type IDeleteItemResponse = {
  __typename?: 'DeleteItemResponse'
  success: Scalars['Boolean']['output']
}

/*
 * Directory CLAIM & REMOVAL (plan §3.1/§3.2/§3.6) — hand-mirrored from
 * spotme-server `graphql/directoryClaim.graphql`. `yarn generate` must NEVER be
 * run in this repo (it only clobbers `hygraph.ts`); mirror by hand, keeping
 * enum members alphabetized like the rest of this file.
 */
/**
 * Admin projection of a claim — the review queue's row AND its detail panel.
 * Carries claimant PII and the append-only audit trail; admin-only by resolver.
 */
export type IAdminDirectoryClaim = {
  __typename?: 'AdminDirectoryClaim'
  audit: Array<IDirectoryClaimAuditEntry>
  claimantEmail: Scalars['String']['output']
  claimantName: Scalars['String']['output']
  claimantPhone?: Maybe<Scalars['String']['output']>
  claimantRole?: Maybe<Scalars['String']['output']>
  claimantUserId: Scalars['String']['output']
  createdOn: Scalars['String']['output']
  decidedAt?: Maybe<Scalars['String']['output']>
  decidedByUserId?: Maybe<Scalars['String']['output']>
  decisionNote?: Maybe<Scalars['String']['output']>
  documents: Array<IDirectoryClaimDocument>
  evidence: Array<IDirectoryClaimEvidence>
  facilityKey: Scalars['String']['output']
  id: Scalars['String']['output']
  lastUpdatedOn: Scalars['String']['output']
  /** Facility title + address, so the queue reads without a second round trip. */
  locationAddress?: Maybe<Scalars['String']['output']>
  locationId: Scalars['String']['output']
  locationTitle?: Maybe<Scalars['String']['output']>
  /** Free-text context the claimant left when starting the claim. */
  message?: Maybe<Scalars['String']['output']>
  status: DirectoryClaimStatus
  strength: DirectoryClaimStrength
  submittedAt?: Maybe<Scalars['String']['output']>
  teamId?: Maybe<Scalars['String']['output']>
}

export type IAdminDirectoryClaimResponse = {
  __typename?: 'AdminDirectoryClaimResponse'
  hits: Array<IAdminDirectoryClaim>
  total: Scalars['Int']['output']
}

export type IAdminDirectoryDuplicatesResponse = {
  __typename?: 'AdminDirectoryDuplicatesResponse'
  hits: Array<IDirectoryDuplicateCandidate>
  total: Scalars['Int']['output']
  /** True when the scan hit its cap — the list is not the whole story. */
  truncated: Scalars['Boolean']['output']
}

export type IAdminDirectoryDispositionResult = {
  __typename?: 'AdminDirectoryDispositionResult'
  /** True when this call is what stamped the row (false = it already was). */
  changed: Scalars['Boolean']['output']
  locationId: Scalars['String']['output']
}

export type IAdminDispositionDirectoryRowInput = {
  disposition: DirectoryConvergenceDisposition
  locationId: Scalars['String']['input']
  note?: InputMaybe<Scalars['String']['input']>
  /**
   * Required when `disposition` is PENDING_SUPERSEDE — the listing that wins
   * once it publishes.
   */
  supersededByLocationId?: InputMaybe<Scalars['String']['input']>
}

export type IAdminRetireDirectoryRowInput = {
  locationId: Scalars['String']['input']
  note?: InputMaybe<Scalars['String']['input']>
  reason: DirectoryOptOutReason
  /** Required when `reason` is SUPERSEDED_BY_LISTING — the real listing that wins. */
  supersededByLocationId?: InputMaybe<Scalars['String']['input']>
}

export type IDirectoryClaimAuditEntry = {
  __typename?: 'DirectoryClaimAuditEntry'
  action: Scalars['String']['output']
  actorName?: Maybe<Scalars['String']['output']>
  actorUserId?: Maybe<Scalars['String']['output']>
  at: Scalars['String']['output']
  note?: Maybe<Scalars['String']['output']>
}

export type IDirectoryClaimCodeResult = {
  __typename?: 'DirectoryClaimCodeResult'
  expiresAt: Scalars['String']['output']
  /**
   * Masked destination the code went to, so the claimant can tell which of their
   * numbers/inboxes to check without us disclosing it.
   */
  sentTo: Scalars['String']['output']
}

export type IDirectoryClaimDemand = {
  __typename?: 'DirectoryClaimDemand'
  /** Reveal attempts past the monthly cap — renters who could NOT reach it. */
  cappedAttemptsThisMonth: Scalars['Int']['output']
  /** Amplified nearby search sessions (90d, category-filtered, HostCTA parity). */
  nearbySearches: Scalars['Int']['output']
  /** 1|2 = near radius; 3 = widened 75 km fallback — render with a "+". */
  nearbySearchesTier: Scalars['Int']['output']
  /** Distinct contacts revealed for THIS facility in the current month (exact). */
  revealsThisMonth: Scalars['Int']['output']
}

export type IDirectoryClaimDocument = {
  __typename?: 'DirectoryClaimDocument'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  uploadedAt: Scalars['String']['output']
  /**
   * Short-lived signed URL — the documents live in the PRIVATE bucket, which has
   * no public policy and is deliberately excluded from the orphan sweep.
   */
  url?: Maybe<Scalars['String']['output']>
}

export type IDirectoryClaimEvidence = {
  __typename?: 'DirectoryClaimEvidence'
  /**
   * Masked destination or domain — e.g. "•••• ••89", "ad•••@acme.mx", "acme.mx".
   * NEVER the full on-record contact: the claim flow must not become a way to
   * read the contact bundle around the reveal cap.
   */
  detail?: Maybe<Scalars['String']['output']>
  kind: DirectoryClaimEvidenceKind
  verifiedAt: Scalars['String']['output']
}

export type IDirectoryClaimOptions = {
  __typename?: 'DirectoryClaimOptions'
  /** The facility's on-record web/email domain, when we hold one. */
  domain?: Maybe<Scalars['String']['output']>
  /**
   * True when the signed-in user's VERIFIED account email sits at `domain`.
   * Unverified account emails never count — that would make the rung free.
   */
  domainMatches: Scalars['Boolean']['output']
  /** Masked on-record email; null when the facility has none on record. */
  emailMasked?: Maybe<Scalars['String']['output']>
  /** Masked on-record phone; null when the facility has none on record. */
  phoneMasked?: Maybe<Scalars['String']['output']>
}

/**
 * What the CLAIMANT may see about their own claim. Deliberately a different type
 * from `AdminDirectoryClaim` — the admin audit trail, internal notes and the
 * document URLs are absent here by construction, not by a field-level gate.
 */
export type IDirectoryClaimGuestStart = {
  __typename?: 'DirectoryClaimGuestStart'
  claim: IDirectoryClaimSelf
  guestToken: Scalars['String']['output']
}

export type IDirectoryClaimSelf = {
  __typename?: 'DirectoryClaimSelf'
  decidedAt?: Maybe<Scalars['String']['output']>
  documentCount: Scalars['Int']['output']
  evidence: Array<IDirectoryClaimEvidence>
  id: Scalars['String']['output']
  locationId: Scalars['String']['output']
  /** Which rungs this facility actually offers, all masked. */
  options: IDirectoryClaimOptions
  /** Written by the reviewing admin, shown verbatim to the claimant. */
  rejectionReason?: Maybe<Scalars['String']['output']>
  status: DirectoryClaimStatus
  strength: DirectoryClaimStrength
  submittedAt?: Maybe<Scalars['String']['output']>
}

/**
 * One likely duplicate: a REAL listing that looks like an existing directory row
 * (plan §3.4). Produced by the nightly convergence job and recomputed on demand
 * for the admin panel.
 */
export type IDirectoryDuplicateCandidate = {
  __typename?: 'DirectoryDuplicateCandidate'
  directoryLocationId: Scalars['String']['output']
  directoryTitle?: Maybe<Scalars['String']['output']>
  /** Metres between the two coordinates; null when either lacks coordinates. */
  distanceM?: Maybe<Scalars['Int']['output']>
  facilityKey?: Maybe<Scalars['String']['output']>
  listingLocationId: Scalars['String']['output']
  /**
   * Is the colliding listing actually in front of renters right now (verified,
   * not a draft, not deactivated, not deleted)? FALSE means retiring the
   * directory row would remove the facility's only public presence and replace
   * it with something no renter can see — the panel must say so before offering
   * the merge.
   */
  listingRenterVisible: Scalars['Boolean']['output']
  listingTeamId?: Maybe<Scalars['String']['output']>
  listingTitle?: Maybe<Scalars['String']['output']>
  /**
   * How the two were matched — `phone` (normalized, exact) or `name_geo`
   * (shared name token within `distanceM`).
   */
  matchedBy: Scalars['String']['output']
}

/**
 * What the one-click removal link resolves to. PUBLIC, but only reachable with a
 * valid signed token, so it discloses nothing a token holder cannot already see
 * on the (public) ficha.
 */
export type IDirectoryOptOutPreview = {
  __typename?: 'DirectoryOptOutPreview'
  address?: Maybe<Scalars['String']['output']>
  /** True when the row is already retired — the page says so instead of re-doing it. */
  alreadyRemoved: Scalars['Boolean']['output']
  locationId: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type IDirectoryOptOutResult = {
  __typename?: 'DirectoryOptOutResult'
  ok: Scalars['Boolean']['output']
  /** True when this call is what retired it (false = it already was). */
  removed: Scalars['Boolean']['output']
}

export type IDirectoryRemovalRequestResult = {
  __typename?: 'DirectoryRemovalRequestResult'
  fallbackEmail?: Maybe<Scalars['String']['output']>
  /**
   * Masked destination the removal link was sent to. Null when the facility has
   * no on-record contact, in which case `fallbackEmail` carries the manual route.
   */
  sentTo?: Maybe<Scalars['String']['output']>
}

export type IReviewDirectoryClaimInput = {
  approve: Scalars['Boolean']['input']
  claimId: Scalars['String']['input']
  /**
   * Required on a rejection — it is shown verbatim to the claimant. Optional on
   * an approval, where it lands in the audit trail only.
   */
  note?: InputMaybe<Scalars['String']['input']>
}

export type IStartDirectoryClaimInput = {
  /** Who is claiming — the person, not the business. */
  contactName: Scalars['String']['input']
  contactPhone?: InputMaybe<Scalars['String']['input']>
  locationId: Scalars['String']['input']
  /** Optional context for the reviewing admin. */
  message?: InputMaybe<Scalars['String']['input']>
  /** Their role at the facility, free text (e.g. 'Gerente'). */
  role?: InputMaybe<Scalars['String']['input']>
}

export type IQueryAdminDirectoryClaimsArgs = {
  pagination: IPaginationInput
  status?: InputMaybe<DirectoryClaimStatus>
}

export type IQueryAdminDirectoryDuplicatesArgs = {
  days?: InputMaybe<Scalars['Int']['input']>
  pagination: IPaginationInput
}

export type IQueryDirectoryOptOutPreviewArgs = {
  token: Scalars['String']['input']
}

export type IQueryMyPayoutActivationStatusArgs = {
  teamId?: InputMaybe<Scalars['String']['input']>
}

export type IQueryPayoutActivationStatusArgs = {
  token: Scalars['String']['input']
}

export type IQueryMyDirectoryClaimArgs = {
  locationId: Scalars['String']['input']
}

export type IMutationAdminDispositionDirectoryRowArgs = {
  input: IAdminDispositionDirectoryRowInput
}

export type IMutationAdminRetireDirectoryRowArgs = {
  input: IAdminRetireDirectoryRowInput
}

export type IMutationAttachDirectoryClaimDocumentArgs = {
  claimId: Scalars['String']['input']
  document: IPhotoInput
}

export type IMutationOptOutDirectoryFacilityArgs = {
  token: Scalars['String']['input']
}

export type IMutationRequestDirectoryRemovalArgs = {
  channel?: InputMaybe<DirectoryClaimCodeChannel>
  locationId: Scalars['String']['input']
}

export type IMutationReviewDirectoryClaimArgs = {
  input: IReviewDirectoryClaimInput
}

export type IMutationSendDirectoryClaimCodeArgs = {
  channel: DirectoryClaimCodeChannel
  claimId: Scalars['String']['input']
}

export type IMutationHoldUnpaidReleaseArgs = {
  checkoutId: Scalars['ID']['input']
}

export type IMutationLinkDirectoryClaimArgs = {
  guestToken: Scalars['String']['input']
}

export type IMutationStartMyPayoutActivationArgs = {
  returnPath?: InputMaybe<Scalars['String']['input']>
  teamId?: InputMaybe<Scalars['String']['input']>
}

export type IMutationStartPayoutActivationArgs = {
  token: Scalars['String']['input']
}

export type IMutationStartDirectoryClaimGuestArgs = {
  input: IStartDirectoryClaimInput
}

export type IMutationStartDirectoryClaimArgs = {
  input: IStartDirectoryClaimInput
}

export type IMutationSubmitDirectoryClaimArgs = {
  claimId: Scalars['String']['input']
}

export type IMutationVerifyDirectoryClaimCodeArgs = {
  claimId: Scalars['String']['input']
  code: Scalars['String']['input']
}

export enum DirectoryClaimCodeChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

/**
 * The evidence ladder, strongest first (plan §3.1). Every rung is a SIGNAL for a
 * human reviewer — none of them auto-approves anything.
 */
export enum DirectoryClaimEvidenceKind {
  /** A document the claimant uploaded. Manual review; strength depends on the doc. */
  Document = 'DOCUMENT',
  /**
   * Passive: the claimant's VERIFIED account email is at the facility's
   * on-record web/email domain. Costs the claimant nothing, so it ranks below a
   * code they had to receive.
   */
  DomainMatch = 'DOMAIN_MATCH',
  /** A code we mailed to the facility's on-record email address, typed back. */
  EmailCode = 'EMAIL_CODE',
  /** A code we texted to the facility's on-record phone, typed back. */
  PhoneCode = 'PHONE_CODE'
}

/**
 * Directory CLAIM & REMOVAL (plan §3.1/§3.2/§3.6) — how an unclaimed directory
 * facility becomes a real SpotMe listing, and how its owner gets out.
 *
 * The claim converts the facility IN PLACE: on approval the owner is invited to
 * the placeholder Team through the EXISTING team-invite flow, edits the SAME
 * `Location` through the EXISTING wizard, and the admin's normal
 * `verifyLocation` approval flips `isDirectoryListing: false` +
 * `isVerified: true`. There is no second object, no migration and no URL change,
 * so one facility can never have two faces.
 *
 * AUTHENTICATION: submitting a claim requires a signed-in account. That is a
 * deliberate call made during the build — the claimant needs an account anyway to
 * accept the team invite and open the wizard, document upload requires an
 * authenticated signed-URL, and tying every claim to a real identity is the same
 * posture as the manual, no-vendor KYC review this mirrors. The reveal
 * (`revealDirectoryContact`) stays public; only claiming is gated.
 *
 * REMOVAL is the other half and is deliberately NOT self-service from the public
 * ficha: anyone could otherwise delist a competitor. `requestDirectoryRemoval`
 * sends a signed one-click link to the facility's OWN on-record email/phone, and
 * only that link (plus an admin) can retire the row. `optOutAt` is permanent —
 * the importer never re-imports it.
 */
export enum DirectoryClaimStatus {
  /** Approved by an admin; the team invite is out. */
  Approved = 'APPROVED',
  /** Created; the claimant is still working the evidence ladder. */
  Draft = 'DRAFT',
  Rejected = 'REJECTED',
  /** Awaiting admin review — the Location also carries `requestedVerification`. */
  Submitted = 'SUBMITTED',
  /** The claimant withdrew before a decision. */
  Withdrawn = 'WITHDRAWN'
}

/**
 * The single ordering of the ladder, computed server-side so the admin panel and
 * any future report rank claims the same way.
 */
export enum DirectoryClaimStrength {
  /** Nothing but the claimant's word. */
  Asserted = 'ASSERTED',
  /** A document only — a human must actually read it. */
  DocumentOnly = 'DOCUMENT_ONLY',
  /** Their verified account email is at the facility's domain. */
  Domain = 'DOMAIN',
  /** They received a code at an address/number we already held for the facility. */
  VerifiedCode = 'VERIFIED_CODE'
}

/**
 * Why a directory row was retired. `optOutAt` is one switch with a typed reason
 * so "the business asked" is never confused with "we merged it into a real
 * listing" — both stop the importer, only one is a privacy request.
 */
/**
 * §3.4 verdicts that are NOT a retire. Both silence the nightly sweep for that
 * row; only PENDING_SUPERSEDE can later remove it.
 */
export enum DirectoryConvergenceDisposition {
  /** Genuinely different facilities — exempt this row from future sweeps. */
  Distinct = 'DISTINCT',
  /**
   * Same facility, but the listing is not renter-visible yet. The row stays
   * published and retires by itself the night the listing goes live.
   */
  PendingSupersede = 'PENDING_SUPERSEDE'
}

export enum DirectoryOptOutReason {
  /** An admin retired the row for a reason that isn't the other two. */
  Admin = 'ADMIN',
  /** The facility itself asked to be removed (one-click link or admin request). */
  OwnerRequest = 'OWNER_REQUEST',
  /** A real SpotMe listing for the same facility exists — §3.4 convergence. */
  SupersededByListing = 'SUPERSEDED_BY_LISTING'
}

export type IDirectoryContact = {
  __typename?: 'DirectoryContact'
  email?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  website?: Maybe<Scalars['String']['output']>
  whatsapp?: Maybe<Scalars['String']['output']>
}

export type IDirectoryMeta = {
  __typename?: 'DirectoryMeta'
  brandColor?: Maybe<Scalars['String']['output']>
  chain?: Maybe<Scalars['String']['output']>
  glyph?: Maybe<Scalars['String']['output']>
  hours?: Maybe<Scalars['String']['output']>
  logoUrl?: Maybe<Scalars['String']['output']>
  monogram?: Maybe<Scalars['String']['output']>
  priceExcludesIva?: Maybe<Scalars['Boolean']['output']>
  priceFromMxn?: Maybe<Scalars['Int']['output']>
  sizes?: Maybe<Scalars['String']['output']>
}

export enum DirectoryRevealChannel {
  Email = 'EMAIL',
  Whatsapp = 'WHATSAPP'
}

export type IDirectoryRevealInput = {
  channel?: InputMaybe<DirectoryRevealChannel>
  contact?: InputMaybe<Scalars['String']['input']>
  locationId: Scalars['String']['input']
}

export type IDirectoryRevealResult = {
  __typename?: 'DirectoryRevealResult'
  contact?: Maybe<IDirectoryContact>
  revealsRemaining: Scalars['Int']['output']
  status: DirectoryRevealStatus
}

export enum DirectoryRevealStatus {
  Capped = 'CAPPED',
  Revealed = 'REVEALED'
}

export type IDiscount = {
  __typename?: 'Discount'
  description?: Maybe<Scalars['String']['output']>
  discountMonths?: Maybe<Scalars['Int']['output']>
  expiresAt?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  minMonths?: Maybe<Scalars['Int']['output']>
}

/**
 * One informative payment notice SpotMe sent to a HOST_DIRECT renter. Doubles as
 * the notice cron's idempotency ledger: `(kind, period)` is unique per checkout.
 */
export type IDirectNotice = {
  __typename?: 'DirectNotice'
  /** Renter total the notice quoted (subtotal + IVA), for later variance checks. */
  amount?: Maybe<Scalars['Float']['output']>
  kind: DirectNoticeKind
  /** Billing period this notice covers, `YYYY-MM`. Absent for TRANSITION. */
  period?: Maybe<Scalars['String']['output']>
  sentAt: Scalars['String']['output']
}

/**
 * Kinds of HOST_DIRECT renter notice.
 * - TRANSITION: one-shot heads-up to an already-active renter being migrated off
 *   platform billing.
 * - START: first payment at approval — prorated when the rent starts mid-month.
 * - MONTHLY: the renewal notice, sent on the 1st of each month.
 * - FEES: one-time charges (depósito en garantía, tarjeta de acceso) at approval.
 */
export enum DirectNoticeKind {
  Fees = 'FEES',
  Monthly = 'MONTHLY',
  Start = 'START',
  Transition = 'TRANSITION'
}

/**
 * A HOST_DIRECT commission month-close. Billing runs month-in-arrears on
 * COLLECTIONS: the close for month M covers rents actually collected during M.
 */
export type IDirectClose = {
  __typename?: 'DirectClose'
  commissionSubtotal: Scalars['Float']['output']
  confirmedAt?: Maybe<Scalars['String']['output']>
  /** Who confirmed — a team member's label, or 'system:continuity' for PRESUMED. */
  confirmedBy?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['String']['output']
  /** Payment due date — confirmation + 10 dias naturales. */
  dueAt?: Maybe<Scalars['String']['output']>
  invoicedAt?: Maybe<Scalars['String']['output']>
  lines: Array<IDirectCloseLine>
  /** `YYYY-MM` — the month whose collections this close covers. */
  period: Scalars['String']['output']
  /** When the corte prompt was last sent (initial send or a reminder). */
  promptedAt?: Maybe<Scalars['String']['output']>
  /** How many reminders have gone out (max 2 — +3d and +7d). */
  reminderCount?: Maybe<Scalars['Int']['output']>
  status: DirectCloseStatus
  /** Consolidated Stripe invoice for the whole month (one line per client). */
  stripeInvoiceId?: Maybe<Scalars['String']['output']>
}

/**
 * One client line in a month-close roster. `expected*` is what SpotMe computed;
 * `collected*` is what the host says actually landed. Commission bills on
 * COLLECTED rent only (cartera-vencida rule).
 */
export type IDirectCloseLine = {
  __typename?: 'DirectCloseLine'
  checkoutId: Scalars['String']['output']
  /** Renter label (name / razon social) as of the close. */
  clientLabel?: Maybe<Scalars['String']['output']>
  /** Commission on `collectedRent`. Null until confirmation. */
  collectedCommission?: Maybe<Scalars['Float']['output']>
  /** Rent the host confirms they collected. Null until confirmation. */
  collectedRent?: Maybe<Scalars['Float']['output']>
  /** Commission percent applied (Anexo A bracket, or the checkout override). */
  commissionPercent: Scalars['Float']['output']
  /** SpotMe commission on the expected rent, at this unit's Anexo A bracket. */
  expectedCommission: Scalars['Float']['output']
  /** Rent SpotMe recorded for the period (subtotal, before IVA). */
  expectedRent: Scalars['Float']['output']
  /** Listing + unit label, so the host can reconcile line-by-line. */
  unitLabel?: Maybe<Scalars['String']['output']>
  /** True when the host reported materially less than expected on an active renter. */
  variance?: Maybe<Scalars['Boolean']['output']>
}

export type IDirectCloseLineInput = {
  checkoutId: Scalars['String']['input']
  /** Rent actually collected this month, before IVA. 0 = not collected. */
  collectedRent: Scalars['Float']['input']
}

/**
 * Token-resolved month-close plus the identity context the confirmation page
 * needs. Deliberately does NOT expose the team's clabe/RFC.
 */
export type IDirectCloseResponse = {
  __typename?: 'DirectCloseResponse'
  close: IDirectClose
  teamId: Scalars['String']['output']
  teamName?: Maybe<Scalars['String']['output']>
}

/**
 * State of one HOST_DIRECT commission month-close.
 * - OPEN: roster built, corte sent, waiting on the host's confirmation.
 * - CONFIRMED: the host told us what they collected; the CFDI can cut.
 * - PRESUMED: reminders went unanswered, so the close defaulted to the LAST
 *   CONFIRMED roster and billed anyway (presumption of continuity).
 * - INVOICED: the consolidated Stripe invoice exists.
 */
export enum DirectCloseStatus {
  Confirmed = 'CONFIRMED',
  Invoiced = 'INVOICED',
  Open = 'OPEN',
  Presumed = 'PRESUMED'
}

/**
 * Where a HOST_DIRECT renter sends the rent. Never rendered on a public surface —
 * the authenticity anchor is the authenticated dashboard.
 */
export type IDirectPaymentInstructions = {
  __typename?: 'DirectPaymentInstructions'
  /**
   * Beneficiary exactly as registered with the bank (the team's legalName).
   * SPEI bounces on a mismatch, so this is displayed verbatim.
   */
  beneficiary: Scalars['String']['output']
  /**
   * Beneficiary's street address (calle, número, colonia), when on file.
   * Several Mexican banks require the beneficiary's address before they will
   * register a new SPEI destination — without it the renter cannot complete
   * the transfer. Host team's FISCAL address, never the listing address.
   */
  beneficiaryAddress?: Maybe<Scalars['String']['output']>
  /** Beneficiary's city, as registered with their bank. */
  beneficiaryCity?: Maybe<Scalars['String']['output']>
  /** Beneficiary's state, as registered with their bank. */
  beneficiaryState?: Maybe<Scalars['String']['output']>
  /** Beneficiary's postal code, as registered with their bank. */
  beneficiaryZipcode?: Maybe<Scalars['String']['output']>
  /** 18-digit CLABE of the host team's own bank account. */
  clabe: Scalars['String']['output']
  /** Host team's RFC, when present — lets the renter's contador match the payment. */
  rfc?: Maybe<Scalars['String']['output']>
}

export type IDisputeEvidenceResponse = {
  __typename?: 'DisputeEvidenceResponse'
  disputeId: Scalars['String']['output']
  disputeStatus: Scalars['String']['output']
  success: Scalars['Boolean']['output']
}

/**
 * Whether SpotMe can currently deliver email to this user.
 *
 * DERIVED, per request, from the address-keyed `spotme-email-suppression` table.
 * Nothing here is stored on the user record and nothing is projected into
 * OpenSearch — the DynamoDB row keyed on the ADDRESS is the only source of truth,
 * because several recipient classes (shared inboxes, `meta.email` overrides,
 * recipients with no account) have no user record at all.
 */
export type IEmailDeliverability = {
  __typename?: 'EmailDeliverability'
  /**
   * The address this describes — exactly what the send gate resolves
   * (`userChanges.email ?? email`), lowercased, so the badge can never contradict
   * what `mailData` actually does. Null when `status` is `hidden`.
   */
  address?: Maybe<Scalars['String']['output']>
  failureCount: Scalars['Int']['output']
  /**
   * Convenience for `status == "undeliverable"`. DERIVED for display only —
   * never use it as a send gate; the send gate reads the store directly.
   */
  isUndeliverable: Scalars['Boolean']['output']
  /**
   * Raw SMTP/vendor text, max 200 chars. ADMIN VIEWERS ONLY — null for the user
   * themself. Never render it as user-facing copy.
   */
  lastReason?: Maybe<Scalars['String']['output']>
  /**
   * `Date.toUTCString()` (e.g. 'Fri, 22 Aug 2026 11:47:00 GMT'), NOT ISO-8601.
   * Parse with `Date.parse`; never sort it lexicographically.
   */
  lastSeenAt?: Maybe<Scalars['String']['output']>
  /** UTC string of the last WhatsApp notice about this address. Admin-only. */
  notifiedAt?: Maybe<Scalars['String']['output']>
  /** `hard_bounce` | `block` | `spam_report` | `invalid`. Null unless undeliverable. */
  reason?: Maybe<Scalars['String']['output']>
  /**
   * `ok` = mailbox healthy · `undeliverable` = we will refuse to send ·
   * `unknown` = the suppression store could not be READ, which is NOT a clean
   * bill of health · `hidden` = the viewer is not permitted to see this.
   *
   * Four values rather than a nullable boolean on purpose: this whole feature
   * exists because a discarded signal was indistinguishable from health, and
   * collapsing "we don't know" into "fine" would reproduce that at the UI layer.
   */
  status: Scalars['String']['output']
}

export type IEnableBankTransferResponse = {
  __typename?: 'EnableBankTransferResponse'
  checkout: ICheckout
  /** Pending (draft/open) invoices that had SPEI added to their payment options */
  invoicesUpdated: Scalars['Int']['output']
  /** Rent + insurance subscriptions flipped to send_invoice with SPEI enabled */
  subscriptionsUpdated: Scalars['Int']['output']
  /** Non-fatal per-object skips/failures (e.g. canceled insurance sub) */
  warnings: Array<Scalars['String']['output']>
}

export enum EventAction {
  AddToCart = 'ADD_TO_CART',
  BrokerSignup = 'BROKER_SIGNUP',
  Contact = 'CONTACT',
  KycComplete = 'KYC_COMPLETE',
  LandingView = 'LANDING_VIEW',
  LeadSubmit = 'LEAD_SUBMIT',
  Register = 'REGISTER',
  Reserve = 'RESERVE',
  Search = 'SEARCH',
  SearchImpression = 'SEARCH_IMPRESSION',
  SupplyLead = 'SUPPLY_LEAD',
  SupplyLeadStart = 'SUPPLY_LEAD_START',
  SupplyListingPosted = 'SUPPLY_LISTING_POSTED',
  Visit = 'VISIT',
  WaCtwaReferral = 'WA_CTWA_REFERRAL'
}

/**
 * Three-way split of an IVA-inclusive amount. Convention across SpotMe:
 * subtotal = total / 1.16, iva = total - subtotal. Mirrors the breakdown the
 * host writes on the CFDI line item.
 */
export type IFacturaAmount = {
  __typename?: 'FacturaAmount'
  iva: Scalars['Float']['output']
  subtotal: Scalars['Float']['output']
  total: Scalars['Float']['output']
}

export enum Features {
  AirConditioner = 'AIR_CONDITIONER',
  AlarmSystem = 'ALARM_SYSTEM',
  AntiFireSystem = 'ANTI_FIRE_SYSTEM',
  ArmoredSpace = 'ARMORED_SPACE',
  Bathrooms = 'BATHROOMS',
  Cafeteria = 'CAFETERIA',
  ClassificationYard = 'CLASSIFICATION_YARD',
  ClimateControl = 'CLIMATE_CONTROL',
  CodeAccess = 'CODE_ACCESS',
  ElectricalInstallation = 'ELECTRICAL_INSTALLATION',
  Elevator = 'ELEVATOR',
  FloorLevel = 'FLOOR_LEVEL',
  Fumigated = 'FUMIGATED',
  Gas = 'GAS',
  IndependentEntrance = 'INDEPENDENT_ENTRANCE',
  KeyAccess = 'KEY_ACCESS',
  Light = 'LIGHT',
  LockedArea = 'LOCKED_AREA',
  MeetingRooms = 'MEETING_ROOMS',
  Mezzanine = 'MEZZANINE',
  Offices = 'OFFICES',
  PestControl = 'PEST_CONTROL',
  PetFree = 'PET_FREE',
  Platform = 'PLATFORM',
  PrivateEntrance = 'PRIVATE_ENTRANCE',
  PrivateSpace = 'PRIVATE_SPACE',
  Railyard = 'RAILYARD',
  Reception = 'RECEPTION',
  SecurityCamera = 'SECURITY_CAMERA',
  Shelves = 'SHELVES',
  ShieldedSpace = 'SHIELDED_SPACE',
  SmokeDetectors = 'SMOKE_DETECTORS',
  Stairs = 'STAIRS',
  Surveillance = 'SURVEILLANCE',
  Tank = 'TANK',
  Tinaco = 'TINACO',
  Toilets = 'TOILETS',
  TruckOrTrailerAccess = 'TRUCK_OR_TRAILER_ACCESS',
  VehicleAccess = 'VEHICLE_ACCESS',
  Water = 'WATER',
  Waterproofed = 'WATERPROOFED'
}

export type IFile = {
  __typename?: 'File'
  /**
   * Presigned GET with `Content-Disposition: attachment` baked into the
   * signature - a plain `<a href>` triggers a real browser download named
   * after `fileName` (vs `url`, which previews inline / navigates). Same
   * 1h expiry as `url`. Null only when signing failed.
   */
  downloadUrl?: Maybe<Scalars['String']['output']>
  fileName: Scalars['String']['output']
  fileSize?: Maybe<Scalars['Int']['output']>
  fileType: Scalars['String']['output']
  uploadedAt: Scalars['String']['output']
  uploadedBy?: Maybe<Scalars['String']['output']>
  url: Scalars['String']['output']
}

export type IFileInput = {
  fileName: Scalars['String']['input']
  fileSize?: InputMaybe<Scalars['Int']['input']>
  fileType: Scalars['String']['input']
  url: Scalars['String']['input']
}

/**
 * Read-only finance role hierarchy. NOT an admin permission tier.
 *
 * `SAT_AUDITOR` is the most restrictive: can ONLY see the SAT compliance portal
 * (/sat-portal). `ACCOUNTANT` and `FINANCE_LEAD` see the SAT view AND the
 * internal finance explorer (future). `FINANCE_LEAD` adds full-dataset export.
 *
 * Hosts viewing their own data do NOT need a `FinanceAccessRole` — they get
 * that view via their normal authenticated identity.
 *
 * Mutually exclusive with `isAdmin`: a user with `isAdmin === true` does not
 * need this flag (admins can preview every finance view by default). The
 * `provisionFinanceAccess` script refuses to grant a `FinanceAccessRole` to a
 * user who is also an admin, and vice versa.
 */
export enum FinanceAccessRole {
  /** Internal accountant — read-only, all finance explorer views. */
  Accountant = 'ACCOUNTANT',
  /** Finance team lead — accountant access + full-dataset export. */
  FinanceLead = 'FINANCE_LEAD',
  /** SAT (Mexican tax authority) auditor — read-only, /sat-portal only. */
  SatAuditor = 'SAT_AUDITOR'
}

/** A rent's first-month discount record. */
export type IFirstMonthDiscount = {
  __typename?: 'FirstMonthDiscount'
  /** Discount received, MXN, before IVA. */
  amountMxn?: Maybe<Scalars['Float']['output']>
  /** When the discounted invoice was paid. */
  appliedAt?: Maybe<Scalars['String']['output']>
  /** When a clawback invoice was issued for an early exit. */
  clawbackIssuedAt?: Maybe<Scalars['String']['output']>
  /** When the renter accepted the early-exit terms (null = not subject to them). */
  clawbackTermsAcceptedAt?: Maybe<Scalars['String']['output']>
  /** Whether the discounted invoice carried IVA. */
  withTax?: Maybe<Scalars['Boolean']['output']>
}

/** SpotMe Now's first-month discount rule, served from the server so the client never hardcodes it. */
export type IFirstMonthDiscountPolicy = {
  __typename?: 'FirstMonthDiscountPolicy'
  /** Whether a rent that ends before minMonths repays the discount received. */
  clawbackEnabled: Scalars['Boolean']['output']
  /** Minimum stay in months, counted from the start date (6). */
  minMonths: Scalars['Int']['output']
  /** Percent off the first month (50). */
  percent: Scalars['Int']['output']
}

export type IFiscalCompliance = {
  __typename?: 'FiscalCompliance'
  completeProfileUrl: Scalars['String']['output']
  highRetention: Scalars['Boolean']['output']
  hostType: Scalars['String']['output']
  isComplete: Scalars['Boolean']['output']
  isOffPlatform: Scalars['Boolean']['output']
  isTeam: Scalars['Boolean']['output']
  missingFields: Array<Scalars['String']['output']>
  retentionIsrRate: Scalars['String']['output']
  retentionIvaRate: Scalars['String']['output']
  /**
   * True when the fiscal warning pin should be shown (e.g. in admin User Search).
   * Only for individual hosts (not team members) with verified listings and incomplete fiscal.
   */
  shouldShowFiscalWarning: Scalars['Boolean']['output']
  /**
   * True when SpotMe has a commission CFDI it cannot stamp because the host's
   * fiscal data is present but INVALID (SAT padrón mismatch). Independent of
   * isComplete (TRUE for these hosts) — drives the red "SAT rechazó tu factura"
   * banner even when the profile looks complete.
   */
  stampRejected: Scalars['Boolean']['output']
  stampRejectedAt?: Maybe<Scalars['String']['output']>
  /**
   * Raw SAT / Facturapi message behind the rejection. Admin-facing detail; host
   * surfaces should prefer stampRejectedFields.
   */
  stampRejectedDetail?: Maybe<Scalars['String']['output']>
  /**
   * The SPECIFIC receptor fields SAT disagreed with, already in Spanish and safe
   * to render verbatim (e.g. ["Nombre o razón social"]). Empty when the rejection
   * reported no field paths — render the generic "check all four against your
   * Constancia" copy then.
   */
  stampRejectedFields: Array<Scalars['String']['output']>
}

export type IFiscalDocument = INode & {
  __typename?: 'FiscalDocument'
  /**
   * The CFDI Folio Fiscal (TimbreFiscalDigital UUID) parsed from the
   * uploaded XML. Null when the document hasn't been parsed yet (legacy
   * uploads pre-2026-05) or when the upload is a PDF-only / scanned image
   * with no XML component. Populated automatically on upload when an XML
   * file is present; legacy rows are backfilled via `backfillCfdiUuids`.
   * Surfaced to SAT auditors as the Folio Fiscal del CFDI column in the
   * /sat-portal Fracción I view.
   */
  /**
   * SAT-cancellation audit trail — set only when `status = CANCELLED`.
   * `cancelledAt` = when SpotMe requested the cancellation at Facturapi.
   * `cancellationMotive` = SAT motive code (01 con relación / 02 sin
   * relación / 03 no se concretó / 04 global). `substitutionCfdiUuid` =
   * folio fiscal of the REPLACEMENT CFDI (motive 01).
   */
  cancellationMotive?: Maybe<Scalars['String']['output']>
  cancelledAt?: Maybe<Scalars['String']['output']>
  cfdiUuid?: Maybe<Scalars['String']['output']>
  checkoutId?: Maybe<Scalars['String']['output']>
  closedDealId?: Maybe<Scalars['String']['output']>
  /**
   * Human-readable reason why the document is no longer ACTIVE. Shared by
   * DISCARDED and CANCELLED — host dashboards render it verbatim.
   */
  discardedReason?: Maybe<Scalars['String']['output']>
  files: Array<IFile>
  flow: FiscalDocumentFlow
  id: Scalars['String']['output']
  lastUpdatedOn: Scalars['String']['output']
  period: Scalars['String']['output']
  previousClosedDealId?: Maybe<Scalars['String']['output']>
  previousPeriod?: Maybe<Scalars['String']['output']>
  previousRecipientTeamId?: Maybe<Scalars['String']['output']>
  previousRecipientUserId?: Maybe<Scalars['String']['output']>
  previousStripeInvoiceId?: Maybe<Scalars['String']['output']>
  previousType?: Maybe<FiscalDocumentType>
  recipientTeam?: Maybe<ITeam>
  recipientTeamId?: Maybe<Scalars['String']['output']>
  recipientUser?: Maybe<IUser>
  recipientUserId?: Maybe<Scalars['String']['output']>
  relatedDocumentId?: Maybe<Scalars['String']['output']>
  /**
   * Audit trail for `relinkFiscalDocument`. Set the first time an admin
   * re-points an already-uploaded CFDI to a different `closedDealId` or
   * `stripeInvoiceId`. `previous*` columns hold the values that were on
   * the document IMMEDIATELY before the most recent relink (one-step
   * history — older relinks are not preserved). The current `closedDealId`
   * / `stripeInvoiceId` fields above always reflect the latest state.
   * Surfaced in admin UIs only; never exposed to host/renter dashboards.
   */
  relinkedAt?: Maybe<Scalars['String']['output']>
  relinkedBy?: Maybe<Scalars['String']['output']>
  senderTeam?: Maybe<ITeam>
  senderTeamId?: Maybe<Scalars['String']['output']>
  senderUser?: Maybe<IUser>
  senderUserId?: Maybe<Scalars['String']['output']>
  status: FiscalDocumentStatus
  stripeInvoiceId?: Maybe<Scalars['String']['output']>
  substitutionCfdiUuid?: Maybe<Scalars['String']['output']>
  type: FiscalDocumentType
  uploadedAt: Scalars['String']['output']
  uploadedBy: Scalars['String']['output']
}

export enum FiscalDocumentFlow {
  HostToRenter = 'HOST_TO_RENTER',
  PlatformToHost = 'PLATFORM_TO_HOST'
}

export type IFiscalDocumentSearchInput = {
  checkoutId?: InputMaybe<Scalars['String']['input']>
  closedDealId?: InputMaybe<Scalars['String']['input']>
  flow?: InputMaybe<FiscalDocumentFlow>
  period?: InputMaybe<Scalars['String']['input']>
  recipientTeamId?: InputMaybe<Scalars['String']['input']>
  /** When provided alongside recipientUserId, returns docs matching the user OR any of these teams (OR logic). */
  recipientTeamIds?: InputMaybe<Array<Scalars['String']['input']>>
  recipientUserId?: InputMaybe<Scalars['String']['input']>
  senderTeamId?: InputMaybe<Scalars['String']['input']>
  senderUserId?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<FiscalDocumentStatus>
  type?: InputMaybe<FiscalDocumentType>
}

export enum FiscalDocumentStatus {
  Active = 'ACTIVE',
  /**
   * Cancelled at the SAT (via Facturapi) — a live stamped CFDI that SpotMe
   * formally cancelled, usually substituted (motive 01). Distinct from
   * DISCARDED (removed from our books only).
   */
  Cancelled = 'CANCELLED',
  Discarded = 'DISCARDED'
}

export enum FiscalDocumentType {
  ComplementoDePago = 'COMPLEMENTO_DE_PAGO',
  Factura = 'FACTURA',
  NotaDeCredito = 'NOTA_DE_CREDITO',
  Other = 'OTHER',
  PaymentReceipt = 'PAYMENT_RECEIPT',
  RefundProof = 'REFUND_PROOF',
  Retenciones = 'RETENCIONES'
}

export type IFiscalDocumentsResponse = {
  __typename?: 'FiscalDocumentsResponse'
  hits: Array<IFiscalDocument>
  total: Scalars['Int']['output']
}

export type IGoogleAutocompleteSuggestion = {
  __typename?: 'GoogleAutocompleteSuggestion'
  description: Scalars['String']['output']
  friendlyDisplay: Scalars['String']['output']
  placeId: Scalars['String']['output']
}

/**
 * Which Google profile a renter's review ask points at, and therefore WHICH
 * QUESTION may honestly be asked. Derived server-side from the lead's listing
 * — never chosen by the client, and never inferred from the URL string.
 *
 * SERVICE = the SpotMe brand profile: the renter rented from a PARTNER and can
 * only speak to the search that found it. VENUE = a SpotMe-operated venue's
 * own profile: they were actually in the space, so the ask is about the space.
 */
export enum GoogleReviewKind {
  Service = 'SERVICE',
  Venue = 'VENUE'
}

export type IGooglePlaceDetails = {
  __typename?: 'GooglePlaceDetails'
  address?: Maybe<Scalars['String']['output']>
  addressDetails?: Maybe<IAddress>
  lat: Scalars['Float']['output']
  lng: Scalars['Float']['output']
  placeId: Scalars['String']['output']
  zoom?: Maybe<Scalars['Int']['output']>
}

export type IHostAccountingResponse = {
  __typename?: 'HostAccountingResponse'
  message: Scalars['String']['output']
  status: HostAccountingStatus
}

export enum HostAccountingStatus {
  Generating = 'GENERATING',
  NoData = 'NO_DATA'
}

export type IHostLead = {
  hostContactedAt?: Maybe<Scalars['String']['output']>
  __typename?: 'HostLead'
  city?: Maybe<Scalars['String']['output']>
  configurationId?: Maybe<Scalars['String']['output']>
  createdOn: Scalars['String']['output']
  /** Host-facing label, e.g. "Renta mensual" / "Renta gestionada". */
  dealTypeLabel?: Maybe<Scalars['String']['output']>
  /** Human folio for this lead (e.g. "SM-AB3KQ") — deterministic, safe to say aloud or print. */
  folio: Scalars['String']['output']
  /**
   * Host-reported outcome overlay. Null = no report yet — the card falls back
   * to the system status. Reporting-only; never affects billing.
   */
  hostOutcome?: Maybe<HostLeadOutcome>
  id: Scalars['String']['output']
  listingTitle?: Maybe<Scalars['String']['output']>
  /** Relative listing route (e.g. renta-mini-bodegas/monterrey/centro/abc). */
  listingUrl?: Maybe<Scalars['String']['output']>
  locationId?: Maybe<Scalars['String']['output']>
  /** Set for market-level Almacenamiento a Domicilio leads (no listing). */
  onDemandCity?: Maybe<Scalars['String']['output']>
  /** Partner-tier only: on-demand pickup address. */
  pickupAddress?: Maybe<Scalars['String']['output']>
  /** Admin all-hosts view only: the id of the host/team this lead belongs to. */
  recipientId?: Maybe<Scalars['String']['output']>
  /** Admin all-hosts view only: the host or team display name, for the UI pin. */
  recipientName?: Maybe<Scalars['String']['output']>
  /** Admin all-hosts view only: whether recipientId is a host or a team. */
  recipientType?: Maybe<HostLeadRecipientType>
  renter: IHostLeadRenter
  /**
   * Admin-only (null for hosts/partners): the renter's HubSpot contact id —
   * captured at dispatch time or resolved from the matched user record.
   */
  renterHubspotId?: Maybe<Scalars['String']['output']>
  /**
   * Renter-sourced outcome (spec §B1) — set by the verification ladder
   * (WhatsApp reply, email one-click) or an admin. Null = no renter answer yet.
   */
  renterOutcome?: Maybe<RenterLeadOutcome>
  /** ISO timestamp when renterOutcome was last set. Null when renterOutcome is null. */
  renterOutcomeAt?: Maybe<Scalars['String']['output']>
  /**
   * ADMIN-ONLY (null for hosts/partners, always). The monthly price in MXN the
   * renter themselves stated, if any — the editable default the admin
   * lead→closed-deal conversion prefills.
   */
  renterStatedPriceMxn?: Maybe<Scalars['Float']['output']>
  /**
   * ADMIN-ONLY (null for hosts/partners, always). The start date the renter
   * themselves stated (`YYYY-MM-DD`). Prefills the conversion's `closedAt` as
   * an EDITABLE default; it is a claim, never an observation.
   */
  renterStatedStartDate?: Maybe<Scalars['String']['output']>
  /**
   * ADMIN-ONLY (null for hosts/partners, always). One-line Spanish rendering
   * of what the renter told us, built from the STRUCTURED outcome fields only
   * — the renter's free text is never part of it (spec §B1).
   */
  renterStatement?: Maybe<Scalars['String']['output']>
  /**
   * Admin-only (null for hosts/partners): the renter's Stripe customer id,
   * resolved from the matched user record. Off-platform leads have none.
   */
  renterStripeCustomerId?: Maybe<Scalars['String']['output']>
  /**
   * Admin-only (null for hosts/partners): the renter's SpotMe user id when
   * the lead matched a registered user. Anonymous form leads have none.
   */
  renterUserId?: Maybe<Scalars['String']['output']>
  /** Host-facing space label, e.g. "Mini Bodega". */
  spaceLabel?: Maybe<Scalars['String']['output']>
  /**
   * Days this lead stays "Nuevo" before it reads as stale — VERTICAL-AWARE,
   * derived from the measured sales cycle (30 parking / 90 storage). Exposed
   * so clients never mirror the window as a constant: a storage lead is still
   * inside its normal cycle at 60 days. Staleness means "no movement
   * reported", never "lost".
   */
  staleDays: Scalars['Int']['output']
  status: HostLeadStatus
  /** ` · `-joined non-PII demand signal (deal · duration · units · size). */
  summary?: Maybe<Scalars['String']['output']>
  /**
   * Visit-request state (Part C) for the dashboard card. Null when the
   * renter never asked to visit. Non-PII — no gate needed.
   */
  visit?: Maybe<IHostLeadVisit>
}

export type IHostLeadRenter = {
  __typename?: 'HostLeadRenter'
  /** First name only for nudge-tier viewers; full name for partners. */
  displayName?: Maybe<Scalars['String']['output']>
  /** Partner-tier only; null otherwise. */
  email?: Maybe<Scalars['String']['output']>
  /** True when this record was disclosed at the partner (full) tier. */
  fullDisclosure: Scalars['Boolean']['output']
  /** Masked (+52 ••• ••• ••82) for nudge-tier viewers; full E.164 for partners. */
  phone?: Maybe<Scalars['String']['output']>
}

/**
 * Visit-request sub-object on a lead (Part C) — the dashboard card's view of
 * the same state VisitRequestPreview exposes publicly. Narrower than the
 * internal record: no token, no notification timestamps, no respondedBy.
 */
export type IHostLeadVisit = {
  __typename?: 'HostLeadVisit'
  /** The window on the table — set once the host confirms or proposes, finalized when the renter accepts a proposal. */
  confirmedWindow?: Maybe<Scalars['String']['output']>
  /** Host-facing free text (max 200 chars). */
  hostNote?: Maybe<Scalars['String']['output']>
  requestedAt: Scalars['String']['output']
  status: HostLeadVisitStatus
  /** Renter-proposed windows (max 2), free text. */
  windows: Array<Scalars['String']['output']>
}

/**
 * Which entity a lead was dispatched to. Populated only in the admin
 * all-hosts view so the UI can pin the recipient's name onto each card.
 */
export enum HostLeadRecipientType {
  Host = 'HOST',
  Team = 'TEAM'
}

/**
 * Visit-request state (Part C) — see IHostLeadVisit. Terminal states
 * (CANCELLED / DECLINED / EXPIRED) are not dead ends: a fresh request from
 * the renter restarts the cycle.
 */
export enum HostLeadVisitStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  HostProposed = 'HOST_PROPOSED',
  Requested = 'REQUESTED'
}

/**
 * The host's response to an open visit request, from either
 * respondVisitByToken (public) or respondVisit (logged-in). CONFIRM_1 /
 * CONFIRM_2 accept the renter's first / second proposed window (index into
 * the CURRENT HostLeadVisit.windows — window is ignored for these two);
 * PROPOSE requires window (the host's own counter-offer text); DECLINE
 * ignores both window and needs no note.
 */
export enum VisitResponseAction {
  Confirm_1 = 'CONFIRM_1',
  Confirm_2 = 'CONFIRM_2',
  Decline = 'DECLINE',
  Propose = 'PROPOSE'
}

/**
 * What respondVisitByToken ACTUALLY did with a host's response (task-16 fix
 * round 1) — mirrors RenterReviewSubmissionStatus's reason for existing.
 *
 * The client used to INFER success by comparing the returned status to what
 * the fired action should have produced. That inference breaks on a race:
 * the renter offered windows A and B; a teammate confirms A on the
 * dashboard; a host with the token page open in a stale tab taps CONFIRM_2
 * (window B) a moment later. applyVisitEvent refuses the stale transition
 * (the visit is already CONFIRMED), so respondVisitByToken returns the
 * UNCHANGED preview — whose status is CONFIRMED. That happens to equal what
 * CONFIRM_2 itself would have produced, so status-comparison alone reads it
 * as success and the stale tab renders "Listo" for a write that never
 * happened. The server knows the difference; the client no longer has to
 * guess.
 *
 * Set ONLY by respondVisitByToken; null on the plain preview query, which
 * submits no response.
 */
export enum VisitResponseVerdict {
  /**
   * The transition was refused — the returned preview reflects whatever the
   * visit's CURRENT state actually is, never what this response attempted.
   * Covers both VisitService.respond's own refusal and a business refusal
   * caught earlier (an out-of-range window index, a PROPOSE with no window).
   */
  Refused = 'REFUSED',
  /** The response was written — this preview reflects it. */
  Written = 'WRITTEN'
}

/**
 * Who wrote a Line 1 WhatsApp message (`api/metaWa/threadStore.ts` `WaMessageRole`).
 * CUSTOMER = the person on WhatsApp, BOT = the chatbot or any API/MCP send, AGENT =
 * a SpotMe staff member, SYSTEM = platform automation.
 */
export enum WaMessageRole {
  Agent = 'AGENT',
  Bot = 'BOT',
  Customer = 'CUSTOMER',
  System = 'SYSTEM'
}

/**
 * Host-reported outcome overlay on a lead (Contacté / Cerré / No cerró) — a
 * REPORTING-ONLY signal, never affects billing. Null = no report yet.
 */
export enum HostLeadOutcome {
  Closed = 'CLOSED',
  Contacted = 'CONTACTED',
  Lost = 'LOST'
}

/**
 * Host lead inbox ("Interesados") — masked per the record's FROZEN disclosure
 * tier (what the notification actually said), never per the viewer's flags.
 */
export enum HostLeadStatus {
  /** Host reported CONTACTED, not yet closed by SpotMe. Computed at read. */
  Contacted = 'CONTACTED',
  /** NEW older than 21 days (or host-reported LOST) — "No concretado". Computed at read. */
  Expired = 'EXPIRED',
  New = 'NEW',
  /** The renter told us they rented here; the host has not confirmed — "Cerrado (según el interesado)". */
  RentedByRenter = 'RENTED_BY_RENTER',
  /** Checkout approval / ClosedDeal matched, OR host reported CLOSED — "Cerrado". */
  Reserved = 'RESERVED'
}

/** Page order for `hostLeads`. OLDEST_FIRST is the work-queue view. */
export enum HostLeadsOrder {
  NewestFirst = 'NEWEST_FIRST',
  OldestFirst = 'OLDEST_FIRST'
}

/**
 * What `setRenterLeadReviewByToken` ACTUALLY did with a submitted review.
 *
 * Exists because the page must not thank a renter for a review that was never
 * stored. `listingReviewOpen` alone cannot say: it comes back false for a
 * review that landed AND for one that never could (no deal, or a deal the
 * partner disputed / the renter retracted). STORED is the only value that
 * means "it is saved".
 *
 * Set ONLY by `setRenterLeadReviewByToken`; null on the preview query and on
 * `setRenterLeadOutcomeByToken`.
 */
export enum RenterReviewSubmissionStatus {
  /** A review from this renter is already on record; nothing was overwritten. */
  AlreadyReviewed = 'ALREADY_REVIEWED',
  /**
   * The deal exists but is disputed / retracted / not-originated / settled, so
   * a review may not be collected on it. Nothing was stored.
   */
  NotCollectable = 'NOT_COLLECTABLE',
  /** The lead never produced a closed deal (a candidate row) — nothing to review. */
  NoDeal = 'NO_DEAL',
  /** The review was written onto the deal. */
  Stored = 'STORED',
  /**
   * The write itself failed (datasource error). The ONLY status the renter can
   * fix by submitting again — the form stays open.
   */
  WriteFailed = 'WRITE_FAILED'
}

/**
 * Renter-sourced outcome — the independent close signal (verification ladder
 * reply or email one-click). Never bills; feeds the renter-declared deal (§C).
 */
export enum RenterLeadOutcome {
  NoLongerNeeded = 'NO_LONGER_NEEDED',
  RentedElsewhere = 'RENTED_ELSEWHERE',
  RentedHere = 'RENTED_HERE',
  StillLooking = 'STILL_LOOKING'
}

/**
 * PUBLIC preview for the /interesado/[token] renter-verification page — the
 * token is the only credential. Never carries anything beyond the renter's
 * OWN first name and the operator's label, never the other party's contact
 * details. `googleReviewUrl` / `listingReviewOpen` are Part-3 placeholders
 * (Task 19 wires the real listing-review flow).
 */
export type ILeadVerificationPreview = {
  leadContact?: Maybe<IRevealedLeadContact>
  __typename?: 'LeadVerificationPreview'
  /** The renter's own first name, for a personal greeting. Null when unknown. */
  firstName?: Maybe<Scalars['String']['output']>
  /** Human folio for this lead (e.g. "SM-AB3KQ") — safe to show on a public page. */
  folio: Scalars['String']['output']
  /**
   * Which of those two `googleReviewUrl` is, so the page's copy matches what
   * the renter can honestly review. Read this, never the URL.
   */
  googleReviewKind: GoogleReviewKind
  /**
   * Where to send this renter for a Google review — the venue's own profile
   * when SpotMe operates the space, the SpotMe brand profile otherwise.
   */
  googleReviewUrl: Scalars['String']['output']
  /**
   * Whether the in-app LISTING review form should be offered: the lead produced
   * a renter-declared closed deal, that deal is still collectable (not
   * disputed, retracted, not-originated or settled) AND it carries no review
   * yet. False for a candidate row (no deal), for a deal an approved DISCARD
   * deleted, and for a deal already reviewed — one review per deal, ever.
   */
  listingReviewOpen: Scalars['Boolean']['output']
  /**
   * True for a MARKET (on-demand) lead — no listing, the renter got a pickup
   * service, not a space. The page asks "¿Cómo calificarías el servicio?"
   * instead of "…el espacio?".
   */
  isOnDemand: Scalars['Boolean']['output']
  /**
   * Host/team display name the renter was sent to, e.g. "Kubox".
   *
   * 🛑 NULL when no name resolves (a market lead with no single operator, a
   * blank team/host name, a lookup blip) — deliberately NOT the server's
   * Spanish `'el operador'` fallback, which this field used to return to every
   * consumer and which rendered verbatim on the ENGLISH page ("Did you rent
   * with el operador?"). The client owns the localized fallback
   * (`OPERATOR_FALLBACK` in `lead_verify.json`, es + en). The WhatsApp and
   * email copy is Spanish-only and keeps the server-side fallback.
   */
  operatorLabel?: Maybe<Scalars['String']['output']>
  /** The renter's recorded answer, if any. Null before they answer. */
  renterOutcome?: Maybe<RenterLeadOutcome>
  /**
   * What the review submit did, on the response to `setRenterLeadReviewByToken`
   * ONLY. Null everywhere else. Read this — never `listingReviewOpen` — to
   * decide whether to thank the renter.
   */
  reviewSubmission?: Maybe<RenterReviewSubmissionStatus>
  /**
   * Host-facing space noun ("bodega" / "cajón" / ...) matching the
   * verification ladder's own copy so every renter surface agrees.
   */
  spaceNoun: Scalars['String']['output']
}

/**
 * PUBLIC, token-authorized view of a visit request for the /visita/[token]
 * host page — same convention as ILeadVerificationPreview: the token is the
 * only credential, and this is reachable by anyone holding the link.
 * PII-FREE BY DESIGN — no renter name, phone, or email.
 */
export type IVisitRequestPreview = {
  __typename?: 'VisitRequestPreview'
  /** City (or on-demand market) the visit concerns. Null when neither resolved. */
  city?: Maybe<Scalars['String']['output']>
  /** The window on the table — set once the host confirms or proposes. */
  confirmedWindow?: Maybe<Scalars['String']['output']>
  /** Human folio for this lead (e.g. "SM-AB3KQ") — safe to show on a public page. */
  folio: Scalars['String']['output']
  /** Host-facing free text (max 200 chars) attached to the last response. */
  hostNote?: Maybe<Scalars['String']['output']>
  /** Whether the RECIPIENT (team or individual host) is a partner right now — drives copy on the token page. Never PII. */
  isPartner: Scalars['Boolean']['output']
  /** Relative listing route, for a "ver anuncio" link. Null for on-demand market leads with no single listing. */
  listingUrl?: Maybe<Scalars['String']['output']>
  /**
   * What the response mutation ACTUALLY did, on the response to
   * respondVisitByToken ONLY. Null everywhere else. Read this — never infer
   * success from status — to decide whether to render "Listo" or the
   * already-answered card. See VisitResponseVerdict's own doc comment.
   */
  respondVerdict?: Maybe<VisitResponseVerdict>
  /** Host-facing space label, e.g. "Mini Bodega". Null when not resolved. */
  spaceLabel?: Maybe<Scalars['String']['output']>
  status: HostLeadVisitStatus
  /** Renter-proposed windows (max 2), free text. */
  windows: Array<Scalars['String']['output']>
}

/**
 * Renter-supplied details on the public /interesado/[token] page. Sanitized
 * server-side — a stray/out-of-range value is DROPPED, never clamped,
 * because Task 16 seeds closedAt/chargeStartDate straight from startDate.
 */
export type IRenterLeadOutcomeDetailsInput = {
  freeText?: InputMaybe<Scalars['String']['input']>
  monthlyPriceMxn?: InputMaybe<Scalars['Float']['input']>
  /**
   * Accepted but not yet persisted anywhere — a future confirmation-echo
   * field, parity placeholder with the WA path's schema shape.
   */
  operatorConfirmed?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
}

export type IHostLeadsInput = {
  /**
   * Admin-only. Return leads across ALL hosts/teams (recipient name pinned per
   * record). Takes precedence over teamId / hostUserId. Forbidden for non-admins.
   */
  allRecipients?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * Admin-only. Narrow to leads for ONE configuration (rentable unit) — "who
   * was interested in this listing?". Forbidden for non-admins.
   */
  configurationId?: InputMaybe<Scalars['String']['input']>
  /**
   * Admin-only. Scope to one individual host's leads (dashboard host switcher).
   * Forbidden for non-admins. Ignored when a narrowing filter is also supplied.
   */
  hostUserId?: InputMaybe<Scalars['String']['input']>
  /**
   * Admin-only. Narrow to leads for ONE location (all its configurations).
   * Forbidden for non-admins.
   */
  locationId?: InputMaybe<Scalars['String']['input']>
  /**
   * Admin-only. "Interesados por atender" — the lead→closed-deal work queue.
   * Selects leads matching ANY of: the renter answered RENTED_HERE and no
   * renter-declared deal exists yet; the lead carries a reconciliation
   * conflict; the renter's yes named no operator while several partner leads
   * were open. Implies the cross-recipient view; Forbidden for non-admins.
   */
  needsAttention?: InputMaybe<Scalars['Boolean']['input']>
  order?: InputMaybe<HostLeadsOrder>
  pagination: IPaginationInput
  /**
   * Admin-only. Narrow to ONE renter's threads across every host. Accepts any
   * common phone format; the server resolves it to every matching user
   * internally, so no phone reaches the search index. Returns an empty result
   * (not an error) when no user matches. Forbidden for non-admins.
   */
  renterPhone?: InputMaybe<Scalars['String']['input']>
  /**
   * Narrow to one display status (NEW / RESERVED / EXPIRED). EXPIRED selects
   * NEW records aged past 21 days. Omit for all statuses.
   */
  status?: InputMaybe<HostLeadStatus>
  /** Scope to one of the requester's teams; omit for individual-host leads. */
  teamId?: InputMaybe<Scalars['String']['input']>
}

export type IHostLeadStatusCounts = {
  __typename?: 'HostLeadStatusCounts'
  /** NEW, inside the 21-day window, no host outcome ("Nuevos") — same population as activeCount. */
  active: Scalars['Int']['output']
  /** Host-reported CONTACTED, not yet closed by SpotMe ("Contactados"). */
  contacted: Scalars['Int']['output']
  /** Host-reported LOST, or NEW aged past 21 days with no outcome ("No concretados"). */
  expired: Scalars['Int']['output']
  /** System RESERVED OR host-reported CLOSED ("Cerrados"). */
  reserved: Scalars['Int']['output']
  /** All leads in scope, any status. */
  total: Scalars['Int']['output']
}

export type IHostLeadsResponse = {
  __typename?: 'HostLeadsResponse'
  /** Leads still in NEW and inside the 21-day window. */
  activeCount: Scalars['Int']['output']
  hits: Array<IHostLead>
  /** Unfiltered per-status breakdown for the CRM header (scope-aware, chip-agnostic). */
  statusCounts: IHostLeadStatusCounts
  total: Scalars['Int']['output']
}

/**
 * Every SpotMe money field is nullable because OFF_PLATFORM (Broker /
 * Traditional) returns null for all of them by design.
 */
export type IHostPayoutEstimate = {
  __typename?: 'HostPayoutEstimate'
  key: Scalars['String']['output']
  settlement: PayoutSettlement
  dealType: DealType
  price: Scalars['Float']['output']
  pricePerSqm?: Maybe<Scalars['Float']['output']>
  renterPays?: Maybe<Scalars['Float']['output']>
  commissionPercent?: Maybe<Scalars['Float']['output']>
  commission?: Maybe<Scalars['Float']['output']>
  processingFeeCard?: Maybe<Scalars['Float']['output']>
  processingFeeSpei?: Maybe<Scalars['Float']['output']>
  depositBeforeRetention?: Maybe<Scalars['Float']['output']>
  depositBeforeRetentionSpei?: Maybe<Scalars['Float']['output']>
  hostType?: Maybe<Scalars['String']['output']>
  retentionApplies: Scalars['Boolean']['output']
  retentionIvaRate?: Maybe<Scalars['String']['output']>
  retentionIsrRate?: Maybe<Scalars['String']['output']>
  ivaRetention?: Maybe<Scalars['Float']['output']>
  isrRetention?: Maybe<Scalars['Float']['output']>
  totalRetention?: Maybe<Scalars['Float']['output']>
  netDeposit?: Maybe<Scalars['Float']['output']>
  netDepositSpei?: Maybe<Scalars['Float']['output']>
  netDepositWithRfc?: Maybe<Scalars['Float']['output']>
  netDepositWithRfcSpei?: Maybe<Scalars['Float']['output']>
}

export type IHostPayoutEstimateInput = {
  price: Scalars['Float']['input']
  key: Scalars['String']['input']
  locationId?: InputMaybe<Scalars['String']['input']>
  teamId?: InputMaybe<Scalars['String']['input']>
  sizeSqm?: InputMaybe<Scalars['Float']['input']>
  locationType?: InputMaybe<LocationType>
  dealType?: InputMaybe<DealType>
}

/**
 * Tax retention info for SAT compliance — applies to personas físicas always,
 * and to personas morales for invoices dated on/after 2026-06-01. Explains why
 * the amount received differs from the gross transfer.
 */
export type IHostRetentionInfo = {
  __typename?: 'HostRetentionInfo'
  applies: Scalars['Boolean']['output']
  /**
   * One of: persona_fisica_con_rfc, persona_fisica_sin_rfc,
   * persona_moral_con_rfc, persona_moral_sin_rfc, persona_moral (pre-cutover).
   */
  hostType: Scalars['String']['output']
  isrRetention: Scalars['Float']['output']
  ivaRetention: Scalars['Float']['output']
  netTransfer: Scalars['Float']['output']
  /**
   * If host is sin_rfc (either persona type): estimated net transfer if they
   * had complete fiscal info. Null when host has RFC.
   */
  netTransferWithRfc?: Maybe<Scalars['Float']['output']>
  retentionIsrRate: Scalars['String']['output']
  retentionIvaRate: Scalars['String']['output']
  totalRetention: Scalars['Float']['output']
  transferBeforeRetention: Scalars['Float']['output']
}

export type IHostSetupGap = {
  __typename?: 'HostSetupGap'
  ctaLabel: Scalars['String']['output']
  detail?: Maybe<Scalars['String']['output']>
  key: HostSetupGapKey
  severity: HostSetupSeverity
  /** Host-facing Spanish copy, ready to render. */
  title: Scalars['String']['output']
  /** Absolute URL of the screen that fixes this gap. */
  url: Scalars['String']['output']
}

/**
 * What a host account is still missing (fiscal data, payouts, lead contact,
 * KYC, building declaration, mail routing, legal representative, company
 * contact). ONE server-side check shared by the host dashboard, the host emails
 * and the admin inventory digest — see `spotme-server/src/api/hostSetup/`.
 */
export enum HostSetupGapKey {
  Fiscal = 'FISCAL',
  Inmueble = 'INMUEBLE',
  Kyc = 'KYC',
  LeadContact = 'LEAD_CONTACT',
  LegalRep = 'LEGAL_REP',
  NotificationRouting = 'NOTIFICATION_ROUTING',
  Stripe = 'STRIPE',
  TeamContact = 'TEAM_CONTACT'
}

export type IHostSetupScope = {
  __typename?: 'HostSetupScope'
  dashboardUrl: Scalars['String']['output']
  /** Display order; empty when nothing is missing. */
  gaps: Array<IHostSetupGap>
  id: Scalars['String']['output']
  /** `team` or `user` (an individual, teamless host). */
  kind: Scalars['String']['output']
  /** Team name; null for an individual. */
  name?: Maybe<Scalars['String']['output']>
  /**
   * Whether the VIEWER can act on the blocking gaps of this scope: always true
   * for an individual account; for a team, true for its ADMINs and platform
   * admins. A team MEMBER sees the gaps but must ask an admin — the client must
   * say so instead of rendering a link that dead-ends.
   */
  viewerCanEdit: Scalars['Boolean']['output']
}

export enum HostSetupSeverity {
  Blocking = 'BLOCKING',
  Important = 'IMPORTANT'
}

export type IHostSnapshot = {
  __typename?: 'HostSnapshot'
  activeCheckouts?: Maybe<Scalars['Int']['output']>
  approvedCheckouts?: Maybe<Scalars['Int']['output']>
  asReferrer?: Maybe<Scalars['String']['output']>
  asUser?: Maybe<Scalars['String']['output']>
  /** Sum of availability across all active configurations */
  availableUnits?: Maybe<Scalars['Int']['output']>
  monthlyRevenue?: Maybe<Scalars['Float']['output']>
  occupancyRate?: Maybe<Scalars['Float']['output']>
  /** Total active (non-deleted, non-deactivated) configurations across all locations */
  totalConfigurations?: Maybe<Scalars['Int']['output']>
  totalRevenue?: Maybe<Scalars['Float']['output']>
  /** Sum of quantity across all active configurations */
  totalUnits?: Maybe<Scalars['Int']['output']>
  verifiedLocations?: Maybe<Scalars['Int']['output']>
}

/**
 * The server-only slice of host-success numbers: all-time visits/leads over the
 * host's (or team's) active listings + market-level on-demand leads + memberSince.
 * Team- or self-scoped by `teamId`. 30-day demand and off-platform money are NOT
 * here — the dashboard computes those client-side from data it already fetches.
 */
export type IHostSuccessSummary = {
  __typename?: 'HostSuccessSummary'
  lifetimeLeads: Scalars['Int']['output']
  lifetimeVisits: Scalars['Int']['output']
  /** Earliest active-listing submittedOn (ISO). '' when the host has no active listing. */
  memberSince: Scalars['String']['output']
  /** Market-level on-demand (domicilio) leads in the last 30d — 0 until the hostlead store has data. */
  onDemandLeads30d: Scalars['Int']['output']
}

export enum HostType {
  Bodegas = 'BODEGAS',
  ParkingCorporate = 'PARKING_CORPORATE',
  ParkingIndividual = 'PARKING_INDIVIDUAL',
  ParkingPension = 'PARKING_PENSION',
  SelfStorageCorporate = 'SELF_STORAGE_CORPORATE',
  SelfStorageIndividual = 'SELF_STORAGE_INDIVIDUAL'
}

export type IIpInfo = {
  __typename?: 'IPInfo'
  address?: Maybe<IAddress>
  center?: Maybe<ICoordinates>
  ip?: Maybe<Scalars['String']['output']>
}

export type IIndividualHost = {
  __typename?: 'IndividualHost'
  activeListings: Scalars['Int']['output']
  email?: Maybe<Scalars['String']['output']>
  firstname?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  lastname?: Maybe<Scalars['String']['output']>
}

export type IIndividualHostsResponse = {
  __typename?: 'IndividualHostsResponse'
  hits: Array<IIndividualHost>
  total: Scalars['Int']['output']
}

export enum IndoorOutdoor {
  Indoor = 'INDOOR',
  Outdoor = 'OUTDOOR',
  OutdoorUncovered = 'OUTDOOR_UNCOVERED'
}

/** One option of a Chubb catalog, for the host confirmation page. */
export type IInmuebleCatalogOption = {
  __typename?: 'InmuebleCatalogOption'
  desc: Scalars['String']['output']
  id: Scalars['Int']['output']
}

export type IInmuebleConfirmResult = {
  __typename?: 'InmuebleConfirmResult'
  alreadyConfirmed: Scalars['Boolean']['output']
  /** Token for the host's next pending listing, if any. */
  nextToken?: Maybe<Scalars['String']['output']>
  ok: Scalars['Boolean']['output']
  pendingCount: Scalars['Int']['output']
}

export type IInmuebleFieldInput = {
  key: Scalars['String']['input']
  valueId?: InputMaybe<Scalars['Int']['input']>
  valueIds?: InputMaybe<Array<Scalars['Int']['input']>>
}

/** One declared characteristic of the building, with what we currently hold and the options a host may pick. */
export type IInmuebleFieldView = {
  __typename?: 'InmuebleFieldView'
  confidence: Scalars['Float']['output']
  evidence?: Maybe<Scalars['String']['output']>
  key: Scalars['String']['output']
  /** select | multiselect | number */
  kind: Scalars['String']['output']
  label: Scalars['String']['output']
  options: Array<IInmuebleCatalogOption>
  /** DEFAULT | AI_INFERRED | ADMIN_SET | HOST_CONFIRMED */
  source: Scalars['String']['output']
  valueDesc?: Maybe<Scalars['String']['output']>
  valueId?: Maybe<Scalars['Int']['output']>
  valueIds?: Maybe<Array<Scalars['Int']['output']>>
}

export type IInmuebleReviewStatus = {
  __typename?: 'InmuebleReviewStatus'
  alreadyConfirmed: Scalars['Boolean']['output']
  city?: Maybe<Scalars['String']['output']>
  fields: Array<IInmuebleFieldView>
  locationTitle?: Maybe<Scalars['String']['output']>
  ok: Scalars['Boolean']['output']
  /** Pending listings for this host, including this one. */
  pendingCount: Scalars['Int']['output']
}

export type IInsurancePolicy = {
  __typename?: 'InsurancePolicy'
  ClaveId?: Maybe<Scalars['String']['output']>
  PolizaId?: Maybe<Scalars['Int']['output']>
}

export type IInsuranceQuote = {
  __typename?: 'InsuranceQuote'
  derecho?: Maybe<Scalars['Float']['output']>
  insuranceType?: Maybe<InsuranceType>
  iva?: Maybe<Scalars['Float']['output']>
  price?: Maybe<Scalars['Float']['output']>
  primaNeta?: Maybe<Scalars['Float']['output']>
  subtotal?: Maybe<Scalars['Float']['output']>
}

export type IInsuranceQuoteInput = {
  insuranceType?: InputMaybe<InsuranceType>
  locationId?: InputMaybe<Scalars['String']['input']>
}

export type IInsuranceReceipt = {
  __typename?: 'InsuranceReceipt'
  endDate?: Maybe<Scalars['String']['output']>
  policies?: Maybe<Array<IInsurancePolicy>>
  startDate?: Maybe<Scalars['String']['output']>
}

export enum InsuranceType {
  Minimum = 'MINIMUM',
  Moderate = 'MODERATE',
  None = 'NONE',
  Standard = 'STANDARD'
}

export enum Interest {
  Host = 'HOST',
  Rent = 'RENT'
}

export type IInventoryConfirmResult = {
  __typename?: 'InventoryConfirmResult'
  alreadyCompleted: Scalars['Boolean']['output']
  hostName?: Maybe<Scalars['String']['output']>
  locationsCount?: Maybe<Scalars['Int']['output']>
  ok: Scalars['Boolean']['output']
  unitsAvailable?: Maybe<Scalars['Int']['output']>
}

/** One pending building-characteristics declaration, for the public inventory-refresh confirm page. */
export type IInventoryInmueblePendingLocation = {
  __typename?: 'InventoryInmueblePendingLocation'
  city?: Maybe<Scalars['String']['output']>
  fields: Array<IInmuebleFieldView>
  locationId: Scalars['String']['output']
  locationTitle?: Maybe<Scalars['String']['output']>
}

export type IInventoryListingInsight = {
  __typename?: 'InventoryListingInsight'
  answersRequestsOnTime: Scalars['Boolean']['output']
  hasClaimableInventory: Scalars['Boolean']['output']
  hasLivePromo: Scalars['Boolean']['output']
  hasRecentDemand: Scalars['Boolean']['output']
  /** Distinct people who asked, last 30 days. Null below the public floor of 3. */
  inquiries30d?: Maybe<Scalars['Int']['output']>
  locationId: Scalars['String']['output']
  /** Points available today (4 since 2026-10-07). The client renders this many dots. */
  maxSearchPoints: Scalars['Int']['output']
  photoCount: Scalars['Int']['output']
  /** The one missing point the host can act on, in host words. */
  rankTip?: Maybe<Scalars['String']['output']>
  /** 0–4, one per signal below. */
  searchPoints: Scalars['Int']['output']
  title?: Maybe<Scalars['String']['output']>
  /** Listing visits, last 30 days (daily metrics). Null when not computed. */
  visits30d?: Maybe<Scalars['Int']['output']>
}

export type IInventoryNextStep = {
  __typename?: 'InventoryNextStep'
  ctaLabel: Scalars['String']['output']
  detail?: Maybe<Scalars['String']['output']>
  kind: InventoryNextStepKind
  /** Set on per-listing steps (photos, description, deposit). */
  locationId?: Maybe<Scalars['String']['output']>
  /** Set on SETUP steps: which account gap this is. */
  setupKey?: Maybe<HostSetupGapKey>
  /** BLOCKING = the host cannot get paid until it is done. */
  severity: HostSetupSeverity
  /** Host-facing Spanish copy, ready to render. */
  title: Scalars['String']['output']
  /** Absolute URL of the screen that does it. */
  url: Scalars['String']['output']
}

export enum InventoryNextStepKind {
  Deposit = 'DEPOSIT',
  Description = 'DESCRIPTION',
  Photos = 'PHOTOS',
  PromoNow = 'PROMO_NOW',
  PromoOperator = 'PROMO_OPERATOR',
  Setup = 'SETUP'
}

export type IInventoryNextSteps = {
  __typename?: 'InventoryNextSteps'
  listings: Array<IInventoryListingInsight>
  steps: Array<IInventoryNextStep>
}

export type IInventoryReviewScopeInput = {
  teamId?: InputMaybe<Scalars['String']['input']>
  /** true = personal scope + every team the requester belongs to. */
  userAndTeams?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * Target a specific user's personal scope. Self, or ANY user when the
   * requester is a platform admin. Takes precedence over teamId.
   */
  userId?: InputMaybe<Scalars['String']['input']>
}

/** Inventario al día — monthly host inventory-refresh loop. */
export type IInventoryReviewScopeStatus = {
  __typename?: 'InventoryReviewScopeStatus'
  completedAt?: Maybe<Scalars['String']['output']>
  hostKey: Scalars['String']['output']
  pending: Scalars['Boolean']['output']
  /** Null when the cron hasn't opened this period's task for the scope. */
  sentAt?: Maybe<Scalars['String']['output']>
  /** Null for the requester's personal scope. */
  teamId?: Maybe<Scalars['String']['output']>
  teamName?: Maybe<Scalars['String']['output']>
}

export type IInventoryReviewStatus = {
  __typename?: 'InventoryReviewStatus'
  /**
   * Listings across these scopes whose Chubb building declaration is still
   * unconfirmed (SpotMe Now, non-vehicle only). Computed ON DEMAND — selecting
   * it costs one active-listing scan per scope, so the badge/notification-count
   * queries deliberately do NOT select it. 0 on any read failure.
   */
  inmueblePendingCount: Scalars['Int']['output']
  /** Scopes with an open (sent, uncompleted) task — drives the badge. */
  pendingCount: Scalars['Int']['output']
  period: Scalars['String']['output']
  scopes: Array<IInventoryReviewScopeStatus>
}

export type IInvoice = {
  __typename?: 'Invoice'
  /** Original amount billed (Stripe invoice.total). Stays constant after credits are applied so the receipt keeps showing the original obligation. */
  amount?: Maybe<Scalars['Float']['output']>
  /** Amount still owed after credit notes / partial payments (Stripe invoice.amount_remaining). Equals `amount` when no credits have been applied. Use this for unpaid/open invoices to show what the renter actually has to pay now. */
  amountDue?: Maybe<Scalars['Float']['output']>
  createdAt?: Maybe<Scalars['String']['output']>
  currency?: Maybe<Scalars['String']['output']>
  /**
   * When this invoice is due (UTC string). Stripe's own `due_date` when it has
   * one (SPEI / send_invoice), otherwise one day after creation — a card invoice
   * is charged immediately, so anything still open the next day is late.
   */
  dueDate?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  /**
   * True when the invoice is still open and its `dueDate` has passed. Server-
   * computed so the dashboard's "Vencido" and the unpaid clock never disagree.
   */
  isOverdue?: Maybe<Scalars['Boolean']['output']>
  paid?: Maybe<Scalars['Boolean']['output']>
  paidAt?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  type?: Maybe<InvoiceType>
  url?: Maybe<Scalars['String']['output']>
}

export type IInvoiceCreditInput = {
  /** Credit amount in MXN (positive number — will be applied as a negative charge) */
  amount: Scalars['Float']['input']
  /** Reason for the credit (stored in Stripe invoice item description) */
  description: Scalars['String']['input']
}

export enum InvoiceType {
  Credit = 'CREDIT',
  Damage = 'DAMAGE',
  Deposit = 'DEPOSIT',
  FirstMonth = 'FIRST_MONTH',
  Insurance = 'INSURANCE',
  OneTimeFee = 'ONE_TIME_FEE',
  Subscription = 'SUBSCRIPTION',
  Upcoming = 'UPCOMING'
}

export type IInvoicesResponse = {
  __typename?: 'InvoicesResponse'
  hits: Array<IInvoice>
  total: Scalars['Int']['output']
}

/**
 * Record of an automated KYC action taken on a user (reject or ban) based on
 * the AI verdict + optional Vercel BotID signal. Persisted on the
 * aiVerification field for audit; never written by anything other than the
 * KycAiReviewService.
 */
export type IKycAutoActionRecord = {
  __typename?: 'KycAutoActionRecord'
  appliedAt: Scalars['String']['output']
  /**
   * True when the Vercel BotID signal contributed to the ban decision
   * (Tier 3 path A). False for AI-only decisions.
   */
  botIdContributed: Scalars['Boolean']['output']
  /**
   * Catalog keys joined to build the user-facing rejection reason. See
   * kycAutoActionReasons.ts for the catalog. Persisted for audit so a
   * future re-localization of reason text can re-compose without losing
   * the original signal mapping.
   */
  /**
   * `KYC_AI_REVIEW_PROMPT_VERSION` of the driving verdict — the version whose
   * calibration the action reflects, not whatever version last re-ran.
   */
  promptVersionAtAction?: Maybe<Scalars['Int']['output']>
  reasonKeys: Array<Scalars['String']['output']>
  /**
   * `overallScore` of the driving verdict. Compare against the tier
   * predicate, never against the sibling `score`, which may be a re-run.
   */
  scoreAtAction?: Maybe<Scalars['Float']['output']>
  /**
   * One of: reject_soft | reject_hard | ban. Soft = re-submittable polite
   * language; Hard = re-submittable but explicit fraud language; Ban =
   * isDeactivated set on the user (admin appeal required to reverse).
   */
  tier: Scalars['String']['output']
  /**
   * Snapshot of the verdict that ACTUALLY drove this action, captured at
   * apply time. `rerunKycAiReview` overwrites the sibling verdict fields in
   * place while deliberately preserving this record, so without the snapshot
   * the (verdict, action) pair DETACHES. Null on records written before
   * 2026-08-22 — those stay unjoinable.
   */
  verdictAtAction?: Maybe<Scalars['String']['output']>
  /**
   * `ranAt` of the driving verdict. THE join key: equal to the sibling
   * verdict's `ranAt` while the pair is intact, and diverges the moment a
   * re-run replaces it.
   */
  verdictRanAtAction?: Maybe<Scalars['String']['output']>
}

/**
 * Vercel BotID verdict captured at the final KYC submit step. Carries the
 * isBot determination from the per-submission preflight check. Persisted on
 * the user record so the KYC AI review (async, runs ~seconds after submit)
 * can incorporate it into the auto-action gate without re-checking. Admin-
 * only field — hidden from non-admin/non-self callers by
 * hideConfidentialUserInfo.
 */
export type IKycBotIdSignal = {
  __typename?: 'KycBotIdSignal'
  collectedAt: Scalars['String']['output']
  isBot: Scalars['Boolean']['output']
  surface: Scalars['String']['output']
}

export type IKycBotIdSignalInput = {
  collectedAt: Scalars['String']['input']
  isBot: Scalars['Boolean']['input']
  surface: Scalars['String']['input']
}

export enum Language {
  En = 'en',
  Es = 'es'
}

export type ILastKnownLocation = {
  __typename?: 'LastKnownLocation'
  center?: Maybe<ICoordinates>
  city?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
}

export type ILastMessage = {
  __typename?: 'LastMessage'
  files?: Maybe<Array<IPhoto>>
  message?: Maybe<Scalars['String']['output']>
}

/**
 * Severity of a renter-vs-partner contradiction on one lead (spec §D3).
 * DERIVED server-side by `verification/reconcile.ts` on every outcome write and
 * cleared the moment the contradiction stops being one — never accumulated.
 *
 * HIGH = the renter says they rented with this partner and the partner denies it
 * ("no cerró" / "ya era mi cliente"); it fans `AdminNoti.LeadOutcomeConflict` to
 * every admin and the deal stays unconfirmed and unbilled.
 * LOW = the renter says they rented elsewhere (or no longer needs a space) while
 * the partner reports a close — usually a confused renter; digest only.
 */
export enum LeadConflictLevel {
  High = 'HIGH',
  Low = 'LOW'
}

export type ILocation = INode & {
  leadContact?: Maybe<ILeadContact>
  leadContacts?: Maybe<Array<ILeadContact>>
  __typename?: 'Location'
  accessAvailability?: Maybe<AccessAvailability>
  accessFrequency?: Maybe<AccessFrequency>
  accessHours?: Maybe<AccessHours>
  accessPermission?: Maybe<AccessPermission>
  address?: Maybe<Scalars['String']['output']>
  addressDetails?: Maybe<IAddress>
  agreedToTerms?: Maybe<Scalars['Boolean']['output']>
  /**
   * AI listing-verification verdict (advisory + auto-action audit trail).
   * ADMIN-ONLY — the backend field resolver returns null for every
   * non-admin caller. Only select it on admin surfaces.
   */
  aiVerification?: Maybe<ILocationAiVerification>
  bankTransferOnly?: Maybe<Scalars['Boolean']['output']>
  bussinessProfile?: Maybe<IBussiness>
  canonicalUrl?: Maybe<Scalars['String']['output']>
  /**
   * Search-card location label. Resolves to `locationReference` when set,
   * otherwise a derived `{colonia}, {municipio}` (or bare `{municipio}`), with
   * the municipality normalized from the postal code so a single brand's
   * branches can't render at three different granularities.
   *
   * Deliberately NOT `shortAddress`: that field is read by Stripe invoice
   * metadata, HubSpot properties, email templates, the chatbot prompts and the
   * print views, and must stay byte-stable. Output-only — never in an input type.
   */
  cardLocation?: Maybe<Scalars['String']['output']>
  configSummary?: Maybe<IConfigSummary>
  configurations?: Maybe<Array<IConfiguration>>
  contract?: Maybe<IPhoto>
  coordinates?: Maybe<ICoordinates>
  coverPhoto?: Maybe<IPhoto>
  currency?: Maybe<Currency>
  currentCurrency?: Maybe<Currency>
  defaultConfiguration?: Maybe<IConfiguration>
  /**
   * True when this listing's host team collects rent DIRECTLY (CollectionMode
   * HOST_DIRECT): the checkout skips the Stripe payment step and the insurance
   * step, and the renter is told they'll pay the host by transfer. Public by
   * design so the funnel can branch, but it exposes only the BOOLEAN — the CLABE
   * itself is never public (see `Checkout.directPaymentInstructions`).
   */
  directCollection?: Maybe<Scalars['Boolean']['output']>
  /**
   * True when this listing's operator confirmed its published price already
   * INCLUDES IVA — the Traditional price card then says "IVA incluido" instead
   * of adding "+ IVA = $X". Resolved server-side from the operator rate-card
   * registry; false for every SpotMe Now listing (Anexo A prices are pre-IVA).
   */
  listPriceIncludesIva?: Maybe<Scalars['Boolean']['output']>
  defaultConfigurationId?: Maybe<Scalars['String']['output']>
  /**
   * Listing description — locale-aware. Resolves to `descriptionEs` or
   * `descriptionEn` depending on `ctx.locale` (header `x-spotme-locale`),
   * falling back to whichever localized variant exists, then to the raw
   * host-authored text on `descriptionSource`. Hosts always write to this
   * field (via `SubmitLocationInput.description`); the audit script
   * populates the localized variants as a side effect.
   */
  description?: Maybe<Scalars['String']['output']>
  /**
   * English localized description — anonymized + SEO-enhanced for EN
   * pillar keywords. Not a literal translation: targets a different keyword
   * cluster (see `src/constants/pillarKeywords.ts`). Populated by the audit
   * script. Output-only — hosts write to `description`.
   */
  descriptionEn?: Maybe<Scalars['String']['output']>
  /**
   * Spanish localized description — anonymized + SEO-enhanced for ES
   * pillar keywords. Populated by the audit script. Output-only — hosts
   * write to `description`.
   */
  descriptionEs?: Maybe<Scalars['String']['output']>
  /**
   * Raw host-authored description, in whatever language the host typed it
   * in. Frozen reference of the most recent host edit. Read by the audit
   * script to detect source language; never displayed directly.
   */
  descriptionSource?: Maybe<Scalars['String']['output']>
  /**
   * Locale of the host's most recent edit (`'es'` | `'en'`), auto-detected.
   * Determines which localized variant the audit script treats as canonical
   * before generating the other-locale variant.
   */
  descriptionSourceLocale?: Maybe<Scalars['String']['output']>
  /**
   * UTC timestamp (HTTP date format) of the last time the localized
   * variants were generated. Falsy means description has been edited since
   * the last translation pass — UI may show "translation pending".
   */
  descriptionTranslatedAt?: Maybe<Scalars['String']['output']>
  directoryHasContact?: Maybe<Scalars['Boolean']['output']>
  directoryMeta?: Maybe<IDirectoryMeta>
  directorySources?: Maybe<Array<Scalars['String']['output']>>
  facilityKey?: Maybe<Scalars['String']['output']>
  firstVerifiedOn?: Maybe<Scalars['String']['output']>
  /**
   * Where a Google review for THIS listing should go — the venue's own Google
   * Business Profile when SpotMe operates it, the SpotMe brand profile
   * otherwise. Every renter-facing "Dejar reseña en Google" CTA reads this.
   */
  googleReviewUrl?: Maybe<Scalars['String']['output']>
  hasTechnicalReport?: Maybe<Scalars['Boolean']['output']>
  /**
   * Is the ACTUAL HOST identity-verified? Output-only, hand-mirrored from
   * `spotme-server/graphql/location.graphql`.
   *
   * 🛑 Read this — never `location.user.isVerified` — for any renter-facing
   * "Anfitrión verificado" claim. `Location.user` resolves off `submittedBy`,
   * which on an admin-onboarded team listing is a SpotMe admin (always
   * verified), so the badge would describe US rather than the host. Team wins
   * over the submitter; a team whose only members are SpotMe admins resolves
   * false. Carries no identity, so it survives `scrubHostIdentity`.
   */
  hostIsVerified?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['String']['output']
  indoorOrOutdoor?: Maybe<IndoorOutdoor>
  /**
   * Last time the host confirmed/edited this listing's inventory (Inventario al
   * día loop). Freshness signal only — nothing gates on it yet.
   */
  inventoryConfirmedAt?: Maybe<Scalars['String']['output']>
  /** Host confirmed inventory within 45 days (server-decided; gates
   * off-platform scarcity). */
  inventoryIsFresh?: Maybe<Scalars['Boolean']['output']>
  isDeactivated?: Maybe<Scalars['Boolean']['output']>
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  isDirectoryListing?: Maybe<Scalars['Boolean']['output']>
  isDraft?: Maybe<Scalars['Boolean']['output']>
  isVerified?: Maybe<Scalars['Boolean']['output']>
  lastEditedByAdmin?: Maybe<Scalars['Boolean']['output']>
  lastUpdatedOn: Scalars['String']['output']
  lastVerifiedOn?: Maybe<Scalars['String']['output']>
  /**
   * Human-recognizable branch reference shown on search cards in place of the
   * derived locality — e.g. "Av. Vallarta", "Zona Real", "López Mateos Sur".
   * Admin-write only (`IAdminEdit.locationReference`). This is a REFERENCE,
   * never an address. Render `cardLocation`, not this field — it applies the
   * fallback chain.
   */
  locationReference?: Maybe<Scalars['String']['output']>
  logisticsServices?: Maybe<Array<LogisticsService>>
  metrics?: Maybe<ILocationMetrics>
  optOutAt?: Maybe<Scalars['String']['output']>
  owner?: Maybe<IOwnerInfo>
  photos?: Maybe<Array<IPhoto>>
  plans?: Maybe<IPhoto>
  priceCapturedAt?: Maybe<Scalars['String']['output']>
  priceSource?: Maybe<Scalars['String']['output']>
  privateSpace?: Maybe<Scalars['Boolean']['output']>
  /** ADMIN-ONLY (null for everyone else): branch free closes left. */
  promoFreeClosesRemaining?: Maybe<Scalars['Int']['output']>
  /** ADMIN-ONLY: promo window end (GMT string). */
  promoFreeClosesUntil?: Maybe<Scalars['String']['output']>
  propertyType?: Maybe<PropertyType>
  publicAddress?: Maybe<Scalars['Boolean']['output']>
  reasonForDenial?: Maybe<Scalars['String']['output']>
  /**
   * Distinct people who started a lead action on this branch in the last 30
   * days — branch-level, not per unit. Null below 3. Recomputed daily.
   */
  recentInquiries?: Maybe<Scalars['Int']['output']>
  reports?: Maybe<IReportsResponse>
  requestedVerification?: Maybe<Scalars['Boolean']['output']>
  requestedVerificationAt?: Maybe<Scalars['String']['output']>
  /** Measured, never asserted: ≥80% of ≥3 Now requests answered within 24 h in 90 days, none expired. */
  respondsWithin24h?: Maybe<Scalars['Boolean']['output']>
  reviewCount?: Maybe<Scalars['Int']['output']>
  reviewScore?: Maybe<Scalars['Float']['output']>
  shortAddress?: Maybe<Scalars['String']['output']>
  snapshot?: Maybe<ILocationSnapshot>
  /**
   * Specialist for Broker/Traditional-eligible listings. Null for Monthly
   * self-storage. Used by the variant library on listing pages to surface a
   * direct human contact instead of the generic checkout flow.
   */
  specialist?: Maybe<ISpecialist>
  step?: Maybe<Scalars['String']['output']>
  submittedBy?: Maybe<Scalars['String']['output']>
  submittedOn?: Maybe<Scalars['String']['output']>
  team?: Maybe<ITeam>
  teamId?: Maybe<Scalars['String']['output']>
  technicalReport?: Maybe<IPhoto>
  title?: Maybe<Scalars['String']['output']>
  traditionalListing?: Maybe<Scalars['Boolean']['output']>
  urlRoute?: Maybe<Scalars['String']['output']>
  useOfSpace?: Maybe<UseOfSpace>
  user?: Maybe<IUser>
  verifiedBy?: Maybe<Scalars['String']['output']>
  visualScore?: Maybe<Scalars['Int']['output']>
  welcomeMessage?: Maybe<Scalars['String']['output']>
  welcomePhotos?: Maybe<Array<IPhoto>>
}

export type ILocationConfigurationsArgs = {
  searchInput?: InputMaybe<ISearchLocationsInput>
}

export type ILocationCoverPhotoArgs = {
  searchInput?: InputMaybe<ISearchLocationsInput>
}

export type ILocationDefaultConfigurationArgs = {
  searchInput?: InputMaybe<ISearchLocationsInput>
}

export type ILocationReportsArgs = {
  pagination: IPaginationInput
}

export type ILocationAssessment = {
  isVerified: Scalars['Boolean']['input']
  locationId: Scalars['String']['input']
  reasonForDenial?: InputMaybe<Scalars['String']['input']>
}

export type ILocationCountsInput = {
  teamId?: InputMaybe<Scalars['String']['input']>
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>
  userAndTeams?: InputMaybe<Scalars['Boolean']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
}

export type ILocationInput = {
  configurationId?: InputMaybe<Scalars['String']['input']>
  locationId: Scalars['String']['input']
}

/** A repair the fix-first policy applied before judging (2026-08-24). */
export type ILocationAiAutoFix = {
  __typename?: 'LocationAiAutoFix'
  at: Scalars['String']['output']
  fromValue: Scalars['String']['output']
  /** vehicle_flag | location_type | description */
  kind: Scalars['String']['output']
  toValue: Scalars['String']['output']
}

export type ILocationAiAutoAction = {
  __typename?: 'LocationAiAutoAction'
  at: Scalars['String']['output']
  promptVersion: Scalars['Int']['output']
  reasonKeys: Array<Scalars['String']['output']>
  /** approve | reject */
  tier: Scalars['String']['output']
}

/**
 * Verdict of the listing AI verification review. Admin-only via the
 * backend Location.aiVerification field resolver — mirror of
 * spotme-server graphql/location.graphql (hand-maintained, do NOT codegen).
 */
export type ILocationAiVerification = {
  __typename?: 'LocationAiVerification'
  autoAction?: Maybe<ILocationAiAutoAction>
  /** Repairs applied before judging (fix-first). Absent when none. */
  autoFixes?: Maybe<Array<ILocationAiAutoFix>>
  containsContactInfo?: Maybe<Scalars['Boolean']['output']>
  descriptionCoherent?: Maybe<Scalars['Boolean']['output']>
  deterministicFlags?: Maybe<Array<Scalars['String']['output']>>
  /** Identity-leak categories across photos AND text (anonymity policy). */
  identityLeakTypes?: Maybe<Array<Scalars['String']['output']>>
  model: Scalars['String']['output']
  observedSpaceType?: Maybe<Scalars['String']['output']>
  observedSpaceTypeConfidence?: Maybe<Scalars['Float']['output']>
  photoQualityScore?: Maybe<Scalars['Float']['output']>
  photosAuthentic?: Maybe<Scalars['String']['output']>
  photosAuthenticConfidence?: Maybe<Scalars['Float']['output']>
  photosMatchClaimedType?: Maybe<Scalars['String']['output']>
  photosReviewed?: Maybe<Scalars['Int']['output']>
  photosTotal?: Maybe<Scalars['Int']['output']>
  promptVersion: Scalars['Int']['output']
  ranAt: Scalars['String']['output']
  reasoning: Scalars['String']['output']
  reasons: Array<Scalars['String']['output']>
  /** none | incidental | prominent — anonymity verdict (photos AND text). */
  revealsHostIdentity?: Maybe<Scalars['String']['output']>
  score: Scalars['Float']['output']
  suggestedFixes?: Maybe<Array<Scalars['String']['output']>>
  verdict: Scalars['String']['output']
}

export type ILocationMetrics = {
  __typename?: 'LocationMetrics'
  computedAt?: Maybe<Scalars['String']['output']>
  current?: Maybe<IMetricsPeriod>
  previous?: Maybe<IMetricsPeriod>
}

export type ILocationSnapshot = {
  __typename?: 'LocationSnapshot'
  monthlyRevenue?: Maybe<Scalars['Float']['output']>
  occupancyRate?: Maybe<Scalars['Float']['output']>
  totalRevenue?: Maybe<Scalars['Float']['output']>
}

export type ILocationTabCounts = {
  __typename?: 'LocationTabCounts'
  active: Scalars['Int']['output']
  all: Scalars['Int']['output']
  drafts: Scalars['Int']['output']
  inactive: Scalars['Int']['output']
  pending: Scalars['Int']['output']
}

/** Ordering hint for a contact within its scope. NEVER used to gate eligibility, reveal or reminders. */
export enum LeadContactRole {
  Backup = 'BACKUP',
  Primary = 'PRIMARY'
}

export type IListingSuggestion = {
  __typename?: 'ListingSuggestion'
  canStoreVehicle?: Maybe<Scalars['Boolean']['output']>
  description?: Maybe<Scalars['String']['output']>
  features: Array<Features>
  indoorOrOutdoor?: Maybe<IndoorOutdoor>
  lengthM?: Maybe<Scalars['Float']['output']>
  locationType?: Maybe<LocationType>
  locationTypeConfidence: Scalars['Float']['output']
  promptVersion: Scalars['String']['output']
  sizeConfidence: Scalars['Float']['output']
  widthM?: Maybe<Scalars['Float']['output']>
}

export enum ListingSuggestionRefusal {
  Cap = 'CAP',
  Disabled = 'DISABLED',
  /** The vision call failed; the wizard continues manually. */
  Error = 'ERROR',
  NoPhotos = 'NO_PHOTOS'
}

export type IListingSuggestionResult = {
  __typename?: 'ListingSuggestionResult'
  /** Why there is no suggestion. The client hides the card, never errors. */
  refusal?: Maybe<ListingSuggestionRefusal>
  /** Signed measurement token; pass to attachListingSuggestion once the draft exists. Null on refusal. */
  stampToken?: Maybe<Scalars['String']['output']>
  suggestion?: Maybe<IListingSuggestion>
}

export enum LocationType {
  Attic = 'ATTIC',
  Basement = 'BASEMENT',
  BodegaCommercial = 'BODEGA_COMMERCIAL',
  BodegaIndustrial = 'BODEGA_INDUSTRIAL',
  Closet = 'CLOSET',
  Garage = 'GARAGE',
  House = 'HOUSE',
  Land = 'LAND',
  Local = 'LOCAL',
  MiniWinery = 'MINI_WINERY',
  NaveIndustrial = 'NAVE_INDUSTRIAL',
  Office = 'OFFICE',
  Other = 'OTHER',
  Parking = 'PARKING',
  Penthouse = 'PENTHOUSE',
  Room = 'ROOM',
  SelfStorageUnit = 'SELF_STORAGE_UNIT',
  Shed = 'SHED',
  ShippingContainer = 'SHIPPING_CONTAINER',
  Terrace = 'TERRACE',
  Warehouse = 'WAREHOUSE',
  Yard = 'YARD'
}

export type ILocationTypeCount = {
  __typename?: 'LocationTypeCount'
  count: Scalars['Int']['output']
  locationType: Scalars['String']['output']
}

export enum LogisticsService {
  InventoryManagement = 'INVENTORY_MANAGEMENT',
  PickingPacking = 'PICKING_PACKING',
  Receiving = 'RECEIVING',
  Shipping = 'SHIPPING'
}

export enum ManualBillingEntryStatus {
  NotOwed = 'NOT_OWED',
  Owed = 'OWED'
}

/**
 * A confirmed manual-billing-ledger row for a legacy closed deal (pre-dates
 * automated billing). Admin-recorded, off the Stripe/billing engine.
 */
export type IManualBillingEntry = {
  __typename?: 'ManualBillingEntry'
  addedAt: Scalars['String']['output']
  addedBy: Scalars['String']['output']
  addedByUser?: Maybe<IUser>
  amountMxn?: Maybe<Scalars['Float']['output']>
  facturaIds: Array<Scalars['String']['output']>
  hasFactura: Scalars['Boolean']['output']
  id: Scalars['String']['output']
  lastUpdatedOn: Scalars['String']['output']
  note?: Maybe<Scalars['String']['output']>
  paid: Scalars['Boolean']['output']
  paidAt?: Maybe<Scalars['String']['output']>
  period: Scalars['String']['output']
  status: ManualBillingEntryStatus
}

/** A suggested (unconfirmed) month an admin can confirm as owed/not-owed onto the manual billing ledger. */
export type IManualBillingCandidate = {
  __typename?: 'ManualBillingCandidate'
  facturaIds: Array<Scalars['String']['output']>
  hasFactura: Scalars['Boolean']['output']
  period: Scalars['String']['output']
}

export type IMarkRefundPaidOffPlatformInput = {
  /** How the host paid: 'transferencia', 'efectivo', 'otro'. */
  method: Scalars['String']['input']
  /** Did the host already issue a nota de crédito outside SpotMe? */
  notaDeCreditoIssued: Scalars['Boolean']['input']
  /** Optional additional notes. */
  notes?: InputMaybe<Scalars['String']['input']>
  /** Approximate date the host paid the renter (ISO 8601). */
  paidAt: Scalars['String']['input']
}

/**
 * One member's notification-topic assignment for `setMemberTopics`. `topics`
 * REPLACES that member's list wholesale — pass the full set the member should
 * receive; [] means none. Floor topics (see `TeamMember.topics`) are enforced
 * team-wide, not per member: the mutation rejects the WHOLE batch if it would
 * leave any floor topic with zero assignees across the team, naming the topic.
 */
export type IMemberLocationsInput = {
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
  userId: Scalars['String']['input']
}

export type IMemberTopicsInput = {
  topics: Array<NotificationTopic>
  userId: Scalars['String']['input']
}

export type IMessage = {
  __typename?: 'Message'
  author: IChatParticipant
  authorId: Scalars['String']['output']
  authorUser?: Maybe<IUser>
  chatId: Scalars['String']['output']
  checkout?: Maybe<ICheckout>
  event?: Maybe<IMessageEvent>
  files?: Maybe<Array<IPhoto>>
  id: Scalars['String']['output']
  locations?: Maybe<Array<ILocation>>
  message?: Maybe<Scalars['String']['output']>
  quantity?: Maybe<Scalars['Int']['output']>
  readReceipts: Array<IReadReceipt>
  reported?: Maybe<Scalars['Boolean']['output']>
  storageTime?: Maybe<StorageTime>
  timestamp: Scalars['String']['output']
}

export type IMessageEvent = {
  __typename?: 'MessageEvent'
  date?: Maybe<Scalars['String']['output']>
  eventType?: Maybe<MessageEventType>
}

export enum MessageEventType {
  CheckoutCancelled = 'CHECKOUT_CANCELLED',
  CheckoutEnded = 'CHECKOUT_ENDED',
  CheckoutStart = 'CHECKOUT_START',
  RequestAccepted = 'REQUEST_ACCEPTED',
  RequestRejected = 'REQUEST_REJECTED',
  RequestSent = 'REQUEST_SENT'
}

export type IMetricsPeriod = {
  __typename?: 'MetricsPeriod'
  addToCarts?: Maybe<Scalars['Int']['output']>
  leads?: Maybe<Scalars['Int']['output']>
  nowLeads?: Maybe<Scalars['Int']['output']>
  proLeads?: Maybe<Scalars['Int']['output']>
  rents?: Maybe<Scalars['Int']['output']>
  revenue?: Maybe<Scalars['Float']['output']>
  sessions?: Maybe<Scalars['Int']['output']>
  tradLeads?: Maybe<Scalars['Int']['output']>
  visits?: Maybe<Scalars['Int']['output']>
  waThreads?: Maybe<Scalars['Int']['output']>
}

/**
 * Per-period missing-factura detail with the actual paid amount sourced from
 * Stripe. Supersedes the bare `missingFacturaPeriods` field on the detail
 * page — the period-string list is kept for backward compatibility and is
 * derived from this one.
 */
export type IMissingFactura = {
  __typename?: 'MissingFactura'
  /** IVA-inclusive amount the host must factura for this period. Null only when no invoice has been generated yet. */
  amount?: Maybe<IFacturaAmount>
  /** Concept key for i18n. Mirrors InvoiceType values surfaced to FacturaGuide: SUBSCRIPTION, FIRST_MONTH. */
  conceptKey: Scalars['String']['output']
  /** Stripe invoice id when the period has been billed; null only in the rare bridge edge case where the invoice has not yet been generated. */
  invoiceId?: Maybe<Scalars['String']['output']>
  /** True when the period's amount differs materially from the standard monthly amount (mid-month start, scheduled-end proration, discount). */
  isProrated: Scalars['Boolean']['output']
  /** When the originating Stripe invoice was paid. */
  paidAt?: Maybe<Scalars['String']['output']>
  /** YYYY-MM (UTC of the Stripe invoice's paidAt). */
  period: Scalars['String']['output']
}

export type IMutation = {
  ackHostLeadByPartnerLink: Scalars['Boolean']['output']
  ackHostLeadByToken: Scalars['Boolean']['output']
  confirmStaffRecordedDeal: IPartnerLinkResult
  declareClosedDealByToken: IPartnerLinkResult
  markHostLeadContacted: IHostLead
  __typename?: 'Mutation'
  /** Activate off-platform billing on a closed deal. Creates the Stripe sub/schedule/invoice. */
  activateClosedDealBilling: IClosedDeal
  /** Appends a new configuration to an existing location WITHOUT resetting its verification status. */
  addInventoryConfiguration: ILocation
  adminCreateAccountSession: Scalars['String']['output']
  adminEdit: ILocation
  adminGenerateHostAccounting: IHostAccountingResponse
  adminUserEdit: IRequestVerificationResponse
  /**
   * Admin-only: apply a credit to the renter for this checkout. If the renter has an
   * open (unpaid / past-due) invoice on this checkout's subscription, the credit is issued
   * as a Stripe credit note against that invoice (reduces amount_remaining directly). Otherwise,
   * the credit attaches as a negative invoice item to the next upcoming subscription invoice.
   * Refuses if there's neither an open invoice nor a still-active subscription.
   * Use for 1-month-free discounts, inconvenience credits, or manual adjustments.
   */
  applyInvoiceCredit: ICheckoutResponse
  applyReferrer: IRequestVerificationResponse
  assesVerification: IRequestVerificationResponse
  assessCheckout: ICheckoutResponse
  assessReferrer: IRequestVerificationResponse
  /** Measurement only: links a photo suggestion to its draft. Returns false, never errors (except unauthenticated). */
  attachListingSuggestion: Scalars['Boolean']['output']
  calcAddPhotos: Scalars['Boolean']['output']
  calcSuggestFromPhotos: IListingSuggestionResult
  calcUpdateDraft: ICalcDraftResult
  calcUploadUrls: Array<ICalcUploadUrl>
  calculatePrice: ILocation
  cancelCheckout: ICheckoutResponse
  /** Cancel an active billing plan (period-close, immediate, or immediate+void). */
  cancelClosedDealBilling: IClosedDeal
  claimCalcDraft: ILocation
  /** Admin. Clear a roster dispute so the deal re-enters the next month-close roster. */
  clearAccrualRosterDispute: IClosedDeal
  /** Admin. Clear a reported exit so the deal re-enters the month-close roster and accrual resumes. */
  clearAccrualRosterExit: IClosedDeal
  /** Admin. Reject a "ya era mi cliente" claim — clears the flag so the deal re-enters the roster. */
  clearAccrualRosterNotOriginated: IClosedDeal
  /** Admin. Confirm a "ya era mi cliente" reject — junks the deal (settle NOT_ORIGINATED + HubSpot Lost). */
  confirmAccrualRosterNotOriginated: IClosedDeal
  clearUser?: Maybe<IUser>
  completeInventoryReview: IInventoryReviewStatus
  /** Public, token-authorized confirm action from the host magic-link page. Rate-limited. */
  confirmClosedDealByToken: IClosedDealConfirmationResult
  /**
   * AUTHED (dashboard sibling of `confirmInmuebleByInventoryToken`). Confirm ONE
   * listing's building declaration. Requester must own the listing / belong to
   * its team (platform admins bypass). Idempotent; `pendingCount` is that
   * listing's host scope's REMAINING pending listings.
   */
  confirmInmueble: IInmuebleConfirmResult
  /** PUBLIC — the signed token is the auth. Idempotent. */
  confirmInmuebleByInventoryToken: IInmuebleConfirmResult
  /** PUBLIC — the signed token is the auth. IP rate-limited, idempotent. */
  confirmInmuebleByToken: IInmuebleConfirmResult
  /** PUBLIC — the signed token is the auth. IP rate-limited, idempotent. */
  confirmInventoryByToken: IInventoryConfirmResult
  createCalcDraft: ICalcDraftResult
  createCheckout: ICheckoutResponse
  acceptTeamInvite: IAcceptTeamInviteResponse
  createClosedDeal: IClosedDeal
  /** Partner declares a closed deal we never tracked (roster / Interesados). Creates an ACCRUAL deal that enters the partner's next month-close roster; nothing bills until confirmation. Auth: valid session that owns the listing. */
  declareClosedDeal: IClosedDeal
  createLocation: ISubmitLocationResponse
  createTeam: ITeamResponse
  createTeamInvite: ITeamInvite
  requestPartnerCloseConfirmation: IPartnerConfirmLink
  resendAllTeamInvites: Array<ITeamInvite>
  resendTeamInvite: ITeamInvite
  adminDispositionDirectoryRow: IAdminDirectoryDispositionResult
  adminRetireDirectoryRow: ILocation
  attachDirectoryClaimDocument: IDirectoryClaimSelf
  optOutDirectoryFacility: IDirectoryOptOutResult
  requestDirectoryRemoval: IDirectoryRemovalRequestResult
  revealDirectoryContact: IDirectoryRevealResult
  reviewDirectoryClaim: IAdminDirectoryClaim
  sendDirectoryClaimCode: IDirectoryClaimCodeResult
  linkDirectoryClaim: IDirectoryClaimSelf
  startDirectoryClaim: IDirectoryClaimSelf
  startDirectoryClaimGuest: IDirectoryClaimGuestStart
  /** Logged-in twin of `startPayoutActivation`. `returnPath` is where Stripe sends the host back (a `?stripe=return|refresh` marker is appended). */
  startMyPayoutActivation: IPayoutActivationStart
  /** PUBLIC — mints a fresh Stripe onboarding link for the token's host. Provisions the Connect account when the team can have one. IP rate-limited. */
  startPayoutActivation: IPayoutActivationStart
  submitDirectoryClaim: IDirectoryClaimSelf
  verifyDirectoryClaimCode: IDirectoryClaimSelf
  revokeTeamInvite: ITeamInvite
  deleteClosedDeal: IDeleteItemResponse
  deleteFiscalDocument: Scalars['Boolean']['output']
  deleteLocation: IDeleteItemResponse
  deleteTeam: ITeamResponse
  discardFiscalDocument: IFiscalDocument
  dismissFacturaPeriod: IFiscalDocument
  /** Public, token-authorized dispute action from the host magic-link page. Rate-limited. */
  disputeClosedDealByToken: IClosedDealConfirmationResult
  /** Enable SPEI bank transfer on an existing checkout: flips the rent + insurance subscriptions to send_invoice with customer_balance, adds SPEI to every pending invoice (first month, deposit, one-time fees, insurance), and marks the checkout stripeBankTransfer. Renter, renter-team member, or admin only. */
  enableCheckoutBankTransfer: IEnableBankTransferResponse
  generateHostAccounting: IHostAccountingResponse
  generateMyHostAccounting: IHostAccountingResponse
  /**
   * Host / team member / admin: "Mantener la reserva" — hold off the automatic
   * release for `holdDays` more days because the host still expects the renter.
   */
  holdUnpaidRelease: ICheckoutResponse
  /**
   * Re-mints the caller's Firebase session after a server-initiated identity
   * change (email/phone attach during KYC) revoked their refresh tokens.
   * Returns a custom sign-in token only when the presented session predates
   * the revocation; null for healthy sessions and disabled/deactivated
   * accounts, so it cannot act as a general session extender.
   */
  mintSessionToken?: Maybe<Scalars['String']['output']>
  newMessage: IChat
  /** Admin-only: force a closed deal's hostConfirmation.status to OVERRIDDEN with an internal note, bypassing the host's response. Server remains the real enforcer of billing activation. */
  overrideClosedDealConfirmation: IClosedDeal
  paymentSetupComplete: ICheckoutResponse
  /** Reads a SAT Constancia de Situación Fiscal and returns its fields to PRE-FILL a form. Never saves. */
  readConstanciaFiscal: IConstanciaFiscalReading
  readMessages: IChat
  recordBrowserLeadConversion: Scalars['Boolean']['output']
  /**
   * Records the "¿Cómo nos conociste?" answer. Auth OPTIONAL: signed-in callers
   * are identified by their token (input email/phone ignored) and the answer is
   * stamped set-once on the User; anonymous callers (lead forms) are identified
   * by the email/phone they just submitted and only reach HubSpot, fill-only.
   * Always resolves true — a survey must never surface an error to the user.
   */
  recordSelfReportedSource: Scalars['Boolean']['output']
  registerUser: IRequestVerificationResponse
  /**
   * Host / team member / admin: release a reservation whose FIRST MONTH was never
   * paid — whether or not the renter has moved in — now instead of waiting for the
   * automatic release. Cancels the rental, voids its open rent invoices and puts
   * the unit back on the market.
   */
  releaseUnpaidReservation: ICheckoutResponse
  /**
   * Retroactively re-point an already-uploaded CFDI to a different closed
   * deal and/or Stripe invoice. Admin-only — every relink is audited via
   * `relinkedAt` / `relinkedBy` / `previousClosedDealId` /
   * `previousStripeInvoiceId` on the FiscalDocument.
   *
   * Use cases:
   * - CFDI uploaded BEFORE the closed deal was activated (no `closedDealId`
   *   set yet) — admin attaches it after billing activation.
   * - CFDI was originally linked to a Stripe invoice that got replaced by
   *   a `restart-canceled-sub` / `recover-expired-sub` recovery — admin
   *   re-points to the live invoice on the new subscription.
   * - CFDI uploaded against the wrong deal entirely.
   *
   * Pass `closedDealId: null` to CLEAR the existing link (e.g. an admin
   * uploaded a generic CFDI by mistake against this deal — drop it back
   * to host-aggregated). Same semantics for `stripeInvoiceId: null`. Omit
   * the field entirely (null + present field treated identically here)
   * to indicate "keep existing value". Server validates that the new
   * `stripeInvoiceId`, when set, names an invoice on the resolved deal's
   * billing — prevents typos that would orphan the CFDI ↔ invoice link.
   */
  relinkFiscalDocument: IFiscalDocument
  /**
   * Admin-only. Execute a closed-deal repair (see ClosedDealRepairMode). The
   * plan is recomputed server-side against live Stripe/fiscal state and refused
   * if it carries refusals — a stale preview can't force an unsafe repair.
   * DISCARD deletes the deal on success.
   */
  repairClosedDeal: IClosedDealRepairResult
  reportLocation: ILocation
  reportMessage: Scalars['Boolean']['output']
  /**
   * Host / team member / admin: rescind a STARTED rental for non-payment. THE
   * CLICK IS THE NOTICE — SpotMe sends the renter the Anexo A §18 written notice,
   * the rental ends `noticeDays` later, and paying in full before then voids it.
   * Refunds nothing. Only available once the debt is `rescissionAvailableAfterDays`
   * old (see Query.unpaidPolicy).
   */
  rescindCheckoutForNonPayment: ICheckoutResponse
  reportUser: Scalars['Boolean']['output']
  /** Admin-only: re-send the HostConfirmN0 magic-link request to the deal's host. */
  resendClosedDealConfirmation: IClosedDeal
  /** Admin-only: re-send an ACTIVE fiscal document's FiscalN1/FiscalN2 delivery email (PDF/XML re-attached) to its recipient (host or renter, user or team). */
  resendFiscalDocument: IFiscalDocument
  /**
   * Admin. One-click resolution of a partner's structured roster proposal —
   * approve applies the corrections (or discards for 'nunca cerramos');
   * reject keeps the recorded terms (note required — sent to the partner).
   */
  resolveAccrualRosterProposal: IClosedDeal
  respondToReview: ICheckoutResponse
  /**
   * Logged-in host responds to an open visit request from the dashboard.
   * Auth mirrors setHostLeadOutcome: recipient host / team member (any
   * role) / platform admin. CONFIRM_1 / CONFIRM_2 accept the renter's
   * first / second proposed window (window arg ignored for those two);
   * PROPOSE requires window; DECLINE ignores both.
   */
  respondVisit: IHostLead
  /**
   * PUBLIC, token-authorized — the host responds to an open visit request
   * from the /visita/[token] page, no login. Same rate limiter as
   * visitRequestPreview. A business refusal (wrong visit state, missing
   * window index) returns the CURRENT preview rather than throwing —
   * visible, never silent. Returns null only when the token itself is
   * invalid, expired, or rate-limited.
   */
  respondVisitByToken?: Maybe<IVisitRequestPreview>
  reviewCheckout: ICheckoutResponse
  rewindCheckout: IRewindCheckoutResult
  saveBankInfo: IRequestVerificationResponse
  saveCalcLead: Scalars['Boolean']['output']
  saveCheckout: ICheckoutResponse
  saveLocation: ISubmitLocationResponse
  saveUserPreferences: IRequestVerificationResponse
  saveUserVerification: IRequestVerificationResponse
  sendAuthEmail: Scalars['Boolean']['output']
  sendCustomerInfoEmail?: Maybe<Scalars['Boolean']['output']>
  /**
   * Set (or clear) the host-reported outcome overlay on a lead. Auth mirrors
   * the hostLeads query (recipient host / team member / admin). Pass
   * `outcome: null` to clear. REPORTING-ONLY — never affects billing.
   */
  setHostLeadOutcome: IHostLead
  /**
   * ADMIN-ONLY — record a renter's outcome by hand (phone call, Fer's notes).
   * Runs the same downstream as a WhatsApp/email answer (renter-declared deal).
   */
  setRenterLeadOutcome: IHostLead
  /**
   * PUBLIC, token-authorized — the /interesado/[token] page. Rate-limited
   * 10/60s/IP (shared bucket with leadVerificationPreview). Refuses to
   * overwrite a `renterOutcomeSource` of 'wa' or 'admin' — the refusal is
   * visible, never silent: it returns the preview carrying the EXISTING
   * renterOutcome so the page renders "ya registramos tu respuesta" instead
   * of pretending the tap landed. Returns null for an invalid/expired/
   * rate-limited token.
   */
  setRenterLeadOutcomeByToken?: Maybe<ILeadVerificationPreview>
  /**
   * PUBLIC, token-authorized — the renter's LISTING review on the
   * /interesado/[token] page. Same rate limiter and token guard as
   * setRenterLeadOutcomeByToken. Writes `renterReview` on the lead's
   * renter-declared closed deal; refuses — visibly, by returning the preview
   * with `listingReviewOpen: false` — when there is no deal, when the deal no
   * longer exists, or when one review is already on record. Never overwrites.
   * Returns null for an invalid/expired/rate-limited token.
   */
  setRenterLeadReviewByToken?: Maybe<ILeadVerificationPreview>
  /** Admin-only: permanently remove a manual billing ledger entry from a legacy closed deal. */
  deleteManualBillingEntry: IClosedDeal
  /** Admin-only: toggle the paid state of a manual billing ledger entry on a legacy closed deal. */
  setManualBillingEntryPaid: IClosedDeal
  /** Mark a closed deal as settled (paid off-platform / won't bill / other). Admin-only. */
  /**
   * Admin-only. Mark ONE **open** commission invoice paid OUTSIDE Stripe — the
   * host wired SpotMe directly (BBVA, cheque) instead of paying the invoice's
   * SPEI CLABE.
   *
   * This is NOT `settleClosedDeal`, and NOT a void. It flips the real Stripe
   * invoice to `paid` via `paid_out_of_band`, so it takes the same path a real
   * SPEI payment takes: dunning stops, the billing flags clear, the Complemento
   * de Pago (REP) stamps against the PPD factura the host already holds, and the
   * money lands in the revenue reports. Voiding instead would leave that PPD
   * CFDI uncredited and its REP permanently unissued.
   */
  markCommissionInvoicePaidOutOfBand: IClosedDeal
  settleClosedDeal: IClosedDeal
  /**
   * Set a team's rent COLLECTION mode (admin only). Flipping to HOST_DIRECT
   * requires the team to already carry a valid `clabe` AND a `legalName` — under
   * direct collection those two ARE the renter's payment instructions, and SPEI
   * bounces when the beneficiary name doesn't match the bank's registered name.
   * Does NOT touch existing checkouts (`Checkout.collectionMode` is stamped at
   * assessment; active rentals migrate via `yarn migrate-host-direct`).
   */
  /**
   * Confirm a HOST_DIRECT month-close from the magic link, declaring what was
   * actually collected per client. On success the close flips CONFIRMED and the
   * consolidated commission invoice is cut. Idempotent.
   */
  submitDirectCollectionClose: IDirectCloseResponse
  /**
   * Assign notification topics to team members (team admin of THIS team, or a
   * SpotMe admin). Only the members present in `assignments` are touched —
   * other members keep their existing `topics`. Rejects the whole batch,
   * naming every floor topic (see `TeamMember.topics`) that would be left with
   * zero assignees across the team once the change is applied.
   */
  setMemberLocations: ITeamResponse
  setMemberTopics: ITeamResponse
  setTeamCollectionMode: ITeamResponse
  setTeamCommission: ITeamResponse
  setTeamCommissionScheme: ITeamResponse
  setTeamInvoicingMode: ITeamResponse
  setTeamLogisticsServices: ITeamResponse
  setTeamPartnerType: ITeamResponse
  setTeamSegment: ITeamResponse
  softRejectLocation: ILocation
  /** Admin-only: create/update a manual billing ledger entry (or confirm a suggested candidate month) on a legacy closed deal. */
  upsertManualBillingEntry: IClosedDeal
  /**
   * Admin-only: submit structured evidence to Stripe to counter a dispute.
   * Automatically gathers checkout data, terms acceptance, IP, chat history, and payment records.
   */
  /** Public, token-authorized month-close roster submit. Cuts ONE consolidated invoice. */
  submitAccrualRoster: IAccrualRosterSubmitResult
  submitDisputeEvidence: IDisputeEvidenceResponse
  submitOnDemandLead: ISubmitOnDemandLeadResult
  toggleLocationActive: ISubmitLocationResponse
  trackEvent?: Maybe<Scalars['Boolean']['output']>
  /**
   * Admin-only. Re-points a listing (and, by default, its non-cancelled
   * rents) at its real owner. Refuses (throws) rather than returning a 200
   * with `errors` populated — read blocking problems from the PREVIEW query
   * before calling this.
   */
  transferLocationOwnership: IOwnershipTransferPreview
  /** Un-cancel or reschedule end date on an active checkout with scheduled cancellation */
  uncancelCheckout: ICheckoutResponse
  /** Revert a settled closed deal back to its computed status. Admin-only. */
  unsettleClosedDeal: IClosedDeal
  updateCheckout: ICheckoutResponse
  updateClosedDeal: IClosedDeal
  /** Edit an active billing plan (amount, end condition, notes). */
  updateClosedDealBilling: IClosedDeal
  /**
   * Field-level patch of configuration inventory on a fresh server read.
   * Deliberately NOT saveLocation: avoids the resolvedDealType strip-list
   * footgun and the availability clobber race vs checkout approval. Atomic per
   * call (any invalid patch fails the whole batch). Returns the updated
   * locations.
   */
  updateConfigurationInventory: Array<ILocation>
  updateNotificationPreferences: IUser
  updateTeam: ITeamResponse
  uploadFiscalDocument: IFiscalDocument
  verifyLocation: IVerifyLocationResponse
  verifyReportedLocation: ILocation
  verifyReportedUser: IRequestVerificationResponse
}

export type IMutationActivateClosedDealBillingArgs = {
  input: IActivateClosedDealBillingInput
}

export type IMutationAddInventoryConfigurationArgs = {
  configuration: IConfigurationInput
  locationId: Scalars['String']['input']
}

export type IMutationAdminCreateAccountSessionArgs = {
  stripeAccountId: Scalars['String']['input']
}

export type IMutationAdminEditArgs = {
  edit: IAdminEdit
  locationId: Scalars['String']['input']
}

export type IMutationAdminGenerateHostAccountingArgs = {
  identifier: Scalars['String']['input']
  months?: InputMaybe<Scalars['Int']['input']>
}

export type IMutationAdminUserEditArgs = {
  edit: IAdminUserEdit
  userId: Scalars['String']['input']
}

export type IMutationApplyInvoiceCreditArgs = {
  checkoutId: Scalars['String']['input']
  input: IInvoiceCreditInput
}

export type IMutationAssesVerificationArgs = {
  assess: IAssesVerificationInput
}

export type IMutationAssessCheckoutArgs = {
  assessment: IAssessCheckoutInput
}

export type IMutationAssessReferrerArgs = {
  assess: IAssesVerificationInput
}

export type IMutationAttachListingSuggestionArgs = {
  locationId: Scalars['ID']['input']
  stampToken: Scalars['String']['input']
}

export type IMutationCalcAddPhotosArgs = {
  claimSecret: Scalars['String']['input']
  draftId: Scalars['ID']['input']
  photos: Array<IPhotoInput>
}

export type IMutationCalcSuggestFromPhotosArgs = {
  claimSecret: Scalars['String']['input']
  draftId: Scalars['ID']['input']
  photoUrls: Array<Scalars['String']['input']>
}

export type IMutationCalcUpdateDraftArgs = {
  claimSecret: Scalars['String']['input']
  draftId: Scalars['ID']['input']
  input: ICalcDraftInput
}

export type IMutationCalcUploadUrlsArgs = {
  claimSecret: Scalars['String']['input']
  draftId: Scalars['ID']['input']
  files: Array<ICalcUploadFileInput>
}

export type IMutationCalculatePriceArgs = {
  lead?: InputMaybe<ICustomerInfoInput>
  loc: ICalculatePriceInput
  suggestion?: InputMaybe<Scalars['Boolean']['input']>
}

export type IMutationCancelCheckoutArgs = {
  actingAs?: InputMaybe<Interest>
  checkoutId: Scalars['String']['input']
  endedReason?: InputMaybe<Scalars['String']['input']>
  renterClabe?: InputMaybe<Scalars['String']['input']>
  scheduledEndDate?: InputMaybe<Scalars['String']['input']>
}

export type IMutationCancelClosedDealBillingArgs = {
  input: ICancelClosedDealBillingInput
}

export type IMutationClaimCalcDraftArgs = {
  claimSecret: Scalars['String']['input']
  draftId: Scalars['ID']['input']
}

export type IMutationClearAccrualRosterDisputeArgs = {
  dealId: Scalars['String']['input']
  note?: InputMaybe<Scalars['String']['input']>
}

export type IMutationClearAccrualRosterNotOriginatedArgs = {
  dealId: Scalars['String']['input']
  note?: InputMaybe<Scalars['String']['input']>
}

export type IMutationConfirmAccrualRosterNotOriginatedArgs = {
  dealId: Scalars['String']['input']
  note?: InputMaybe<Scalars['String']['input']>
}

export type IMutationClearAccrualRosterExitArgs = {
  dealId: Scalars['String']['input']
  note?: InputMaybe<Scalars['String']['input']>
}

export type IMutationSubmitAccrualRosterArgs = {
  actions: Array<IAccrualRosterActionInput>
  submitterName?: InputMaybe<Scalars['String']['input']>
  token: Scalars['String']['input']
}

export type IMutationCompleteInventoryReviewArgs = {
  input?: InputMaybe<IInventoryReviewScopeInput>
}

export type IMutationConfirmClosedDealByTokenArgs = {
  token: Scalars['String']['input']
}

export type IMutationConfirmInmuebleArgs = {
  input: IConfirmInmuebleInput
}

export type IMutationConfirmInmuebleByInventoryTokenArgs = {
  input: IConfirmInmuebleByInventoryTokenInput
}

export type IMutationConfirmInmuebleByTokenArgs = {
  input: IConfirmInmuebleByTokenInput
}

export type IMutationConfirmInventoryByTokenArgs = {
  token: Scalars['String']['input']
}

export type IMutationCreateCalcDraftArgs = { input: ICalcDraftInput }

export type IMutationCreateCheckoutArgs = {
  configurationId: Scalars['String']['input']
  locationId: Scalars['String']['input']
  saveCheckout: ISaveCheckoutInput
}

export type IMutationCreateClosedDealArgs = {
  input: ICreateClosedDealInput
}

export type IMutationCreateTeamArgs = {
  input: IUpdateTeamInput
}

export type IMutationDeclareClosedDealArgs = {
  input: IDeclareClosedDealInput
}

export type IMutationDeleteClosedDealArgs = {
  id: Scalars['String']['input']
}

export type IMutationDeleteFiscalDocumentArgs = {
  id: Scalars['String']['input']
}

export type IMutationDeleteLocationArgs = {
  locationId: Scalars['String']['input']
}

export type IMutationDeleteTeamArgs = {
  teamId: Scalars['String']['input']
}

export type IMutationDiscardFiscalDocumentArgs = {
  id: Scalars['String']['input']
  reason: Scalars['String']['input']
}

export type IMutationDismissFacturaPeriodArgs = {
  checkoutId: Scalars['String']['input']
  period: Scalars['String']['input']
  reason: Scalars['String']['input']
}

export type IMutationDisputeClosedDealByTokenArgs = {
  details?: InputMaybe<Scalars['String']['input']>
  reason: HostDisputeReason
  token: Scalars['String']['input']
}

export type IMutationEnableCheckoutBankTransferArgs = {
  checkoutId: Scalars['String']['input']
}

export type IMutationGenerateHostAccountingArgs = {
  months?: InputMaybe<Scalars['Int']['input']>
  teamId: Scalars['String']['input']
}

export type IMutationGenerateMyHostAccountingArgs = {
  months?: InputMaybe<Scalars['Int']['input']>
}

export type IMutationNewMessageArgs = {
  chatId?: InputMaybe<Scalars['String']['input']>
  message: INewMessageInput
  participants?: InputMaybe<Array<IChatParticipantInput>>
}

export type IMutationOverrideClosedDealConfirmationArgs = {
  id: Scalars['String']['input']
  note: Scalars['String']['input']
}

export type IMutationPaymentSetupCompleteArgs = {
  stripeSessionId: Scalars['String']['input']
}

export type IMutationReadConstanciaFiscalArgs = {
  input: IReadConstanciaFiscalInput
}

export type IMutationReadMessagesArgs = {
  chatId: Scalars['String']['input']
}

export type IMutationRecordBrowserLeadConversionArgs = {
  input: IRecordBrowserLeadConversionInput
}

export type IMutationRecordSelfReportedSourceArgs = {
  input: ISelfReportedSourceInput
}

export type IMutationRegisterUserArgs = {
  input: IRegisterUserInput
}

export type IMutationReleaseUnpaidReservationArgs = {
  checkoutId: Scalars['ID']['input']
}

export type IMutationRescindCheckoutForNonPaymentArgs = {
  checkoutId: Scalars['ID']['input']
}

export type IMutationRelinkFiscalDocumentArgs = {
  closedDealId?: InputMaybe<Scalars['String']['input']>
  documentType?: InputMaybe<FiscalDocumentType>
  id: Scalars['String']['input']
  period?: InputMaybe<Scalars['String']['input']>
  recipientTeamId?: InputMaybe<Scalars['String']['input']>
  recipientUserId?: InputMaybe<Scalars['String']['input']>
  stripeInvoiceId?: InputMaybe<Scalars['String']['input']>
}

export type IMutationReportLocationArgs = {
  locationId: Scalars['String']['input']
  reason: Scalars['String']['input']
}

export type IMutationReportMessageArgs = {
  chatId: Scalars['String']['input']
  messageId: Scalars['String']['input']
}

export type IMutationReportUserArgs = {
  input: IReportUserInput
}

export type IMutationRepairClosedDealArgs = {
  edits?: InputMaybe<IClosedDealRepairEditsInput>
  id: Scalars['String']['input']
  mode: ClosedDealRepairMode
  reason: Scalars['String']['input']
}

export type IMutationResendClosedDealConfirmationArgs = {
  id: Scalars['String']['input']
}

export type IMutationResendFiscalDocumentArgs = {
  id: Scalars['String']['input']
}

export type IMutationResolveAccrualRosterProposalArgs = {
  approve: Scalars['Boolean']['input']
  dealId: Scalars['String']['input']
  note?: InputMaybe<Scalars['String']['input']>
}

export type IMutationRespondToReviewArgs = {
  checkoutId: Scalars['String']['input']
  response: Scalars['String']['input']
}

export type IMutationRespondVisitArgs = {
  action: VisitResponseAction
  id: Scalars['String']['input']
  note?: InputMaybe<Scalars['String']['input']>
  window?: InputMaybe<Scalars['String']['input']>
}

export type IMutationRespondVisitByTokenArgs = {
  action: VisitResponseAction
  note?: InputMaybe<Scalars['String']['input']>
  token: Scalars['String']['input']
  window?: InputMaybe<Scalars['String']['input']>
}

export type IMutationRevealDirectoryContactArgs = {
  input: IDirectoryRevealInput
}

export type IMutationReviewCheckoutArgs = {
  checkoutId: Scalars['String']['input']
  rating: Scalars['Int']['input']
  review: Scalars['String']['input']
}

export type IMutationRewindCheckoutArgs = {
  checkoutId: Scalars['String']['input']
  reason: Scalars['String']['input']
}

export type IMutationSaveBankInfoArgs = {
  bankInfo: IBankInfoInput
  userId: Scalars['String']['input']
}

export type IMutationSaveCalcLeadArgs = {
  claimSecret: Scalars['String']['input']
  draftId: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  phone: Scalars['String']['input']
}

export type IMutationSaveCheckoutArgs = {
  checkoutId: Scalars['String']['input']
  createStripeCheckoutSession?: InputMaybe<Scalars['Boolean']['input']>
  saveCheckout: ISaveCheckoutInput
  submitCheckoutRequest?: InputMaybe<Scalars['Boolean']['input']>
}

export type IMutationSaveLocationArgs = {
  location: ISubmitLocationInput
  submitForVerification?: InputMaybe<Scalars['Boolean']['input']>
}

export type IMutationSaveUserPreferencesArgs = {
  userChanges: IRequestPreferencesInput
}

export type IMutationSaveUserVerificationArgs = {
  kycBotIdSignal?: InputMaybe<IKycBotIdSignalInput>
  requestUserVerification: Scalars['Boolean']['input']
  savingUserProfile?: InputMaybe<Scalars['Boolean']['input']>
  userChanges: IRequestVerificationInput
}

export type IMutationSendAuthEmailArgs = {
  email: Scalars['String']['input']
  emailType: AuthEmailType
  redirectUrl?: InputMaybe<Scalars['String']['input']>
}

export type IMutationSendCustomerInfoEmailArgs = {
  customerInfo: ICustomerInfoInput
  searchInput?: InputMaybe<ISearchLocationsInput>
}

export type IMutationSetHostLeadOutcomeArgs = {
  id: Scalars['String']['input']
  outcome?: InputMaybe<HostLeadOutcome>
}

export type IMutationSetRenterLeadOutcomeArgs = {
  freeText?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  outcome: RenterLeadOutcome
}

export type IMutationSetRenterLeadOutcomeByTokenArgs = {
  details?: InputMaybe<IRenterLeadOutcomeDetailsInput>
  outcome: RenterLeadOutcome
  token: Scalars['String']['input']
}

export type IMutationSettleClosedDealArgs = {
  duplicateOfClosedDealId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  note?: InputMaybe<Scalars['String']['input']>
  reason: ClosedDealSettlementReason
}

export type IMutationMarkCommissionInvoicePaidOutOfBandArgs = {
  dealId: Scalars['String']['input']
  note?: InputMaybe<Scalars['String']['input']>
  reference: Scalars['String']['input']
  stripeInvoiceId: Scalars['String']['input']
}

export type IMutationDeleteManualBillingEntryArgs = {
  dealId: Scalars['String']['input']
  entryId: Scalars['String']['input']
}

export type IMutationSetManualBillingEntryPaidArgs = {
  dealId: Scalars['String']['input']
  entryId: Scalars['String']['input']
  paid: Scalars['Boolean']['input']
  paidAt?: InputMaybe<Scalars['String']['input']>
}

export type IMutationUpsertManualBillingEntryArgs = {
  amountMxn?: InputMaybe<Scalars['Float']['input']>
  dealId: Scalars['String']['input']
  note?: InputMaybe<Scalars['String']['input']>
  paid?: InputMaybe<Scalars['Boolean']['input']>
  period: Scalars['String']['input']
  status: ManualBillingEntryStatus
}

export type IMutationSetTeamCommissionArgs = {
  commissionType?: InputMaybe<CommissionType>
  commissionValue?: InputMaybe<Scalars['Float']['input']>
  teamId: Scalars['String']['input']
}

export type IMutationSetTeamCommissionSchemeArgs = {
  scheme?: InputMaybe<ICommissionSchemeInput>
  teamId: Scalars['String']['input']
}

export type IMutationSetTeamInvoicingModeArgs = {
  mode: ClosedDealInvoicingMode
  paymentSpreadPercent?: InputMaybe<Scalars['Float']['input']>
  teamId: Scalars['String']['input']
}

export type IMutationSetTeamLogisticsServicesArgs = {
  services: Array<InputMaybe<Scalars['String']['input']>>
  teamId: Scalars['String']['input']
}

export type IMutationSetMemberLocationsArgs = {
  assignments: Array<IMemberLocationsInput>
  teamId: Scalars['String']['input']
}

export type IMutationSetMemberTopicsArgs = {
  assignments: Array<IMemberTopicsInput>
  teamId: Scalars['String']['input']
}

export type IMutationSetRenterLeadReviewByTokenArgs = {
  rating: Scalars['Int']['input']
  review?: InputMaybe<Scalars['String']['input']>
  token: Scalars['String']['input']
}

export type IMutationSetTeamPartnerTypeArgs = {
  partnerType?: InputMaybe<TeamPartnerType>
  teamId: Scalars['String']['input']
}

export type IMutationSubmitDirectCollectionCloseArgs = {
  lines: Array<IDirectCloseLineInput>
  submitterName?: InputMaybe<Scalars['String']['input']>
  token: Scalars['String']['input']
}

export type IMutationSetTeamCollectionModeArgs = {
  collectionMode: CollectionMode
  teamId: Scalars['String']['input']
}

export type IMutationSetTeamSegmentArgs = {
  segment: TeamSegment
  teamId: Scalars['String']['input']
}

export type IMutationSoftRejectLocationArgs = {
  locationId: Scalars['String']['input']
}

export type IMutationSubmitDisputeEvidenceArgs = {
  checkoutId: Scalars['String']['input']
  disputeId: Scalars['String']['input']
  draftOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export type IMutationSubmitOnDemandLeadArgs = {
  input: ISubmitOnDemandLeadInput
}

export type IMutationToggleLocationActiveArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>
}

export type IMutationTrackEventArgs = {
  input: ITrackEventInput
}

export type IMutationTransferLocationOwnershipArgs = {
  input: ITransferLocationOwnershipInput
}

export type IMutationUncancelCheckoutArgs = {
  checkoutId: Scalars['String']['input']
  newEndDate?: InputMaybe<Scalars['String']['input']>
}

export type IMutationUnsettleClosedDealArgs = {
  id: Scalars['String']['input']
}

export type IMutationUpdateCheckoutArgs = {
  checkoutId: Scalars['String']['input']
  input: IUpdateCheckoutInput
}

export type IMutationUpdateClosedDealArgs = {
  id: Scalars['String']['input']
  input: IUpdateClosedDealInput
}

export type IMutationUpdateClosedDealBillingArgs = {
  input: IUpdateClosedDealBillingInput
}

export type IMutationUpdateConfigurationInventoryArgs = {
  updates: Array<IConfigInventoryUpdateInput>
}

export type IMutationUpdateNotificationPreferencesArgs = {
  input: INotificationInput
}

export type IMutationUpdateTeamArgs = {
  input: IUpdateTeamInput
  teamId: Scalars['String']['input']
}

export type IMutationUploadFiscalDocumentArgs = {
  input: IUploadFiscalDocumentInput
}

export type IMutationVerifyLocationArgs = {
  verification: ILocationAssessment
}

export type IMutationVerifyReportedLocationArgs = {
  verification: ILocationAssessment
}

export type IMutationVerifyReportedUserArgs = {
  verification: IAssesVerificationInput
}

export type INearbySearchCountsInput = {
  days?: InputMaybe<Scalars['Int']['input']>
  lat: Scalars['Float']['input']
  lng: Scalars['Float']['input']
  locationType?: InputMaybe<Scalars['String']['input']>
  radiusKm?: InputMaybe<Scalars['Float']['input']>
}

export type INearbySearchCountsResult = {
  __typename?: 'NearbySearchCountsResult'
  byLocationType: Array<ILocationTypeCount>
  locationTypeFiltered: Scalars['Boolean']['output']
  radiusUsed: Scalars['Float']['output']
  tier: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type INewMessageInput = {
  checkoutId?: InputMaybe<Scalars['String']['input']>
  files?: InputMaybe<Array<IPhotoInput>>
  locations?: InputMaybe<Array<ILocationInput>>
  message?: InputMaybe<Scalars['String']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  storageTime?: InputMaybe<StorageTime>
}

export type INode = {
  id: Scalars['String']['output']
  lastUpdatedOn: Scalars['String']['output']
}

export enum NotificationGenre {
  AccountActivity = 'ACCOUNT_ACTIVITY',
  Messages = 'MESSAGES',
  News = 'NEWS',
  Perks = 'PERKS',
  PolicyChange = 'POLICY_CHANGE',
  Promotions = 'PROMOTIONS',
  Reminders = 'REMINDERS'
}

export type INotificationInput = {
  email?: InputMaybe<Scalars['String']['input']>
  genre?: InputMaybe<NotificationGenre>
  method?: InputMaybe<NotificationMethod>
  notiPreferences?: InputMaybe<Array<INotificationPreferenceInput>>
  preferedNotiMethod?: InputMaybe<NotificationMethod>
  token?: InputMaybe<Scalars['String']['input']>
  topicChannels?: InputMaybe<Array<ITopicChannelPreferenceInput>>
  unsubscribeAll?: InputMaybe<Scalars['Boolean']['input']>
}

export enum NotificationMethod {
  Email = 'EMAIL',
  Push = 'PUSH',
  Sms = 'SMS',
  Whatsapp = 'WHATSAPP'
}

export type INotificationPreference = {
  __typename?: 'NotificationPreference'
  disabledMethods?: Maybe<Array<NotificationMethod>>
  genre?: Maybe<NotificationGenre>
}

export type INotificationPreferenceInput = {
  disabledMethods?: InputMaybe<Array<NotificationMethod>>
  genre?: InputMaybe<NotificationGenre>
}

/**
 * Routing bucket for team-directed host mail. Finer than NotificationGenre:
 * AccountActivity bundles payout confirmations with lead alerts, which is why
 * genre alone cannot express "I handle fiscal, not leads".
 */
export enum NotificationTopic {
  Billing = 'BILLING',
  Digests = 'DIGESTS',
  Fiscal = 'FISCAL',
  Leads = 'LEADS',
  Listings = 'LISTINGS',
  Payments = 'PAYMENTS',
  Reservations = 'RESERVATIONS'
}

export type INumRangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>
  min?: InputMaybe<Scalars['Float']['input']>
}

export type IOfac = {
  __typename?: 'Ofac'
  hasMatch?: Maybe<Scalars['Boolean']['output']>
  matches?: Maybe<Scalars['String']['output']>
}

/**
 * Whether the renter is a person or a business. B2B tickets are bigger and
 * stays are longer, so sales routes them to the broker specialist.
 */
export enum OnDemandPersonaType {
  PersonaFisica = 'PERSONA_FISICA',
  PersonaMoral = 'PERSONA_MORAL'
}

/**
 * Pickup-site logistics — how hard the move-out will be. Drives the partner's
 * truck/crew sizing and quote accuracy.
 */
export enum OnDemandPickupLogistics {
  ComplicatedAccess = 'COMPLICATED_ACCESS',
  Elevator = 'ELEVATOR',
  GroundFloor = 'GROUND_FLOOR',
  Stairs = 'STAIRS'
}

/**
 * How soon the renter needs the pickup. Drives sales prioritization — urgent
 * slots typically eat the most logistics overhead, longer-lead picks are
 * easier to staff. Stored on the HubSpot deal as `on_demand_pickup_window_v2`.
 */
export enum OnDemandPickupTiming {
  Flexible_30Plus = 'FLEXIBLE_30_PLUS',
  NextTwoWeeks = 'NEXT_TWO_WEEKS',
  ThisWeek = 'THIS_WEEK',
  UrgentTodayTomorrow = 'URGENT_TODAY_TOMORROW'
}

export enum OnDemandPickupWindow {
  OneOff = 'ONE_OFF',
  Recurring = 'RECURRING'
}

export enum OnDemandVolumeEstimate {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL',
  Unsure = 'UNSURE'
}

export type IOneTimeFee = {
  __typename?: 'OneTimeFee'
  amount?: Maybe<Scalars['Float']['output']>
  category?: Maybe<OneTimeFeeCategory>
  description?: Maybe<Scalars['String']['output']>
  stripeInvoiceId?: Maybe<Scalars['String']['output']>
  withTax?: Maybe<Scalars['Boolean']['output']>
}

export enum OneTimeFeeCategory {
  AccessCard = 'ACCESS_CARD',
  Other = 'OTHER',
  SecurityDeposit = 'SECURITY_DEPOSIT'
}

export type IOneTimeFeeInput = {
  amount: Scalars['Float']['input']
  category: OneTimeFeeCategory
  description: Scalars['String']['input']
  withTax: Scalars['Boolean']['input']
}

/** An Operador de Autoalmacenaje Tradicional's OWN promotion (not a SpotMe discount). */
export type IOperatorPromo = {
  __typename?: 'OperatorPromo'
  conditions?: Maybe<Scalars['String']['output']>
  expiresAt?: Maybe<Scalars['String']['output']>
  freeMonths?: Maybe<Scalars['Int']['output']>
  /** Renter-facing Spanish one-liner, built server-side. */
  headline: Scalars['String']['output']
  isUpTo?: Maybe<Scalars['Boolean']['output']>
  kind: OperatorPromoKind
  minMonths?: Maybe<Scalars['Int']['output']>
  months?: Maybe<Scalars['Int']['output']>
  operatorWording: Scalars['String']['output']
  percentOff?: Maybe<Scalars['Float']['output']>
  prepayMonths?: Maybe<Scalars['Int']['output']>
  promoPrice?: Maybe<Scalars['Float']['output']>
  sourceUrl?: Maybe<Scalars['String']['output']>
  tiers?: Maybe<Array<IOperatorPromoTier>>
  verifiedOn: Scalars['String']['output']
}

/** An operator's own promotion, declared from its dashboard (inventory page). */
export type IOperatorPromoInput = {
  conditions?: InputMaybe<Scalars['String']['input']>
  expiresAt?: InputMaybe<Scalars['String']['input']>
  freeMonths?: InputMaybe<Scalars['Int']['input']>
  isUpTo?: InputMaybe<Scalars['Boolean']['input']>
  kind: OperatorPromoKind
  minMonths?: InputMaybe<Scalars['Int']['input']>
  months?: InputMaybe<Scalars['Int']['input']>
  operatorWording?: InputMaybe<Scalars['String']['input']>
  percentOff?: InputMaybe<Scalars['Float']['input']>
  prepayMonths?: InputMaybe<Scalars['Int']['input']>
  promoPrice?: InputMaybe<Scalars['Float']['input']>
  sourceUrl?: InputMaybe<Scalars['String']['input']>
  tiers?: InputMaybe<Array<IOperatorPromoTierInput>>
}

export type IOperatorPromoTierInput = {
  minMonths: Scalars['Int']['input']
  percentOff: Scalars['Float']['input']
}

export enum OperatorPromoKind {
  FreeMonths = 'FREE_MONTHS',
  PercentOff = 'PERCENT_OFF',
  Perk = 'PERK',
  Prepay = 'PREPAY',
  PromoPrice = 'PROMO_PRICE',
  TermTiers = 'TERM_TIERS'
}

export type IOperatorPromoTier = {
  __typename?: 'OperatorPromoTier'
  minMonths: Scalars['Int']['output']
  percentOff: Scalars['Float']['output']
}

export type IOwnerInfo = {
  __typename?: 'OwnerInfo'
  bgColor: Scalars['String']['output']
  initial: Scalars['String']['output']
  isUnassigned: Scalars['Boolean']['output']
  label: Scalars['String']['output']
  pinBgColor: Scalars['String']['output']
  pinTextColor: Scalars['String']['output']
  textColor: Scalars['String']['output']
}

export type ITransferLocationOwnershipInput = {
  locationId: Scalars['String']['input']
  /** Pass an empty string to CLEAR the team. Omit to leave unchanged. */
  toTeamId?: InputMaybe<Scalars['String']['input']>
  /** New `submittedBy`. Omit to leave the person unchanged. */
  toUserId?: InputMaybe<Scalars['String']['input']>
  /**
   * Re-point `landlordId` / `landlordTeamId` on the listing's non-cancelled
   * checkouts. Defaults to true server-side — a transfer that moves the
   * listing but leaves its rents addressed to a SpotMe admin is the bug
   * this feature exists to fix.
   */
  includeRents?: InputMaybe<Scalars['Boolean']['input']>
}

/**
 * What a transfer WOULD do. Returned by the preview query and, with the same
 * shape, by the mutation once applied.
 */
export type IOwnershipTransferPreview = {
  __typename?: 'OwnershipTransferPreview'
  locationId: Scalars['String']['output']
  fromUserId?: Maybe<Scalars['String']['output']>
  toUserId?: Maybe<Scalars['String']['output']>
  fromTeamId?: Maybe<Scalars['String']['output']>
  toTeamId?: Maybe<Scalars['String']['output']>
  /** Non-cancelled checkouts that would be (or were) re-pointed. */
  rentsAffected: Scalars['Int']['output']
  /** Of those, how many are ACTIVE (started, not ended). */
  activeRentsAffected: Scalars['Int']['output']
  /**
   * Retention bracket the live rents resolve to BEFORE and AFTER. Null when
   * no target owner could be resolved, when owner AND team are both
   * unchanged, or when the listing has no ACTIVE rent to sample.
   */
  retentionBefore?: Maybe<Scalars['String']['output']>
  retentionAfter?: Maybe<Scalars['String']['output']>
  /** Blocking problems. Non-empty means the mutation will refuse. */
  errors: Array<Scalars['String']['output']>
  /**
   * Non-blocking cautions the admin must read before confirming — notably
   * any rent whose Stripe transfer percent is frozen at a value that no
   * longer matches the recomputed post-transfer percent.
   */
  warnings: Array<Scalars['String']['output']>
}

/**
 * Why one live listing is still held by a SpotMe admin identity instead of
 * its real host. THREE DIFFERENT FIXES — never sum the three counts into
 * one number. SIN_EQUIPO and SOLO_SELLO are both fixed by
 * `transferLocationOwnership`. EQUIPO_SIN_MIEMBRO is NOT a transfer
 * target — the team is already correct, what's missing is a human in it.
 * Fix with `createTeamInvite`, never `transferLocationOwnership`. This is a
 * TWO-STEP fix, not one: once the invite is ACCEPTED, the verdict flips to
 * SOLO_SELLO (real member now, `submittedBy` still stale) — which DOES
 * need a transfer. A row reappearing after an invite is progress, not a
 * sign the invite failed.
 */
export enum OwnershipVerdict {
  EquipoSinMiembro = 'EQUIPO_SIN_MIEMBRO',
  SinEquipo = 'SIN_EQUIPO',
  SoloSello = 'SOLO_SELLO'
}

/** One live listing still held by a SpotMe admin identity instead of its real host. */
export type IAdminOwnershipGapRow = {
  __typename?: 'AdminOwnershipGapRow'
  locationId: Scalars['String']['output']
  title?: Maybe<Scalars['String']['output']>
  /** See `OwnershipVerdict`'s doc comment for the three fixes. */
  verdict: OwnershipVerdict
  /** The platform admin currently holding it (`location.submittedBy`). */
  adminUserId: Scalars['String']['output']
  teamId?: Maybe<Scalars['String']['output']>
  teamName?: Maybe<Scalars['String']['output']>
}

/**
 * The same admin-ownership backlog the weekly host-ops digest reports
 * (section 4, "Titularidad pendiente"), exposed for the admin panel's work
 * queue. COST: runs several Elasticsearch reads plus a full DynamoDB scan of
 * the team-invite table — do not poll.
 */
export type IAdminOwnershipQueue = {
  __typename?: 'AdminOwnershipQueue'
  rows: Array<IAdminOwnershipGapRow>
  /**
   * Full match count for `rows` — may exceed `rows.length` when `truncated`.
   * Excludes listings suppressed because their team already has a pending
   * invite in flight — see `invitePendingListings` for that count, and add
   * the two together for the real total.
   */
  total: Scalars['Int']['output']
  /**
   * True when a backing query hit its size cap — `total` is then a FLOOR,
   * not the full count. Independent of `degraded`.
   */
  truncated: Scalars['Boolean']['output']
  /**
   * True when the section itself could not be read at all — `rows` is then
   * `[]` and `total` is `0`, but that is "we could not look", never "we
   * looked and found nothing". Check this BEFORE trusting an empty
   * `rows`/zero `total`.
   */
  degraded: Scalars['Boolean']['output']
  /**
   * Every checkout DOCUMENT (any stage) whose landlord resolves to a SpotMe
   * identity. NOT "how many are really rented" — pair with
   * `rentsActiveAdminLandlord` for that.
   */
  rentsAdminLandlordAllStages: Scalars['Int']['output']
  /** Of the above, how many are ACTIVE rents right now. */
  rentsActiveAdminLandlord: Scalars['Int']['output']
  /**
   * True when the checkout-side read behind the two `rents*` fields above
   * failed. When true, treat both as UNKNOWN — never render them as 0.
   */
  rentsDegraded: Scalars['Boolean']['output']
  /** How many teams were suppressed from `rows` for already having a pending invite. */
  invitePendingTeams: Scalars['Int']['output']
  /**
   * How many LISTINGS that covers (always >= `invitePendingTeams`).
   * `total + invitePendingListings` is the real admin-held backlog size.
   */
  invitePendingListings: Scalars['Int']['output']
}

export type IPaginationInput = {
  from: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
}

export type IPastDueInvoice = {
  __typename?: 'PastDueInvoice'
  amountDue: Scalars['Float']['output']
  /** Admin: checkout HubSpot deal ID */
  checkoutHubspotId?: Maybe<Scalars['String']['output']>
  checkoutId?: Maybe<Scalars['String']['output']>
  /** For HOST_COMMISSION kind: full closed-deal id (UUID). Null otherwise. */
  closedDealId?: Maybe<Scalars['String']['output']>
  /** For HOST_COMMISSION kind: first 8 chars of the closed-deal id for at-a-glance display. */
  closedDealShortId?: Maybe<Scalars['String']['output']>
  /** For HOST_COMMISSION kind: the closed deal's dealType — 'monthly' | 'broker' | 'traditional'. Pulled from the Stripe invoice metadata. */
  closedDealType?: Maybe<Scalars['String']['output']>
  /** For HOST_COMMISSION kind: deep link to the closed-deal detail page in the admin dashboard (e.g. '/dashboard/host/closed-deals/{id}'). */
  closedDealUrl?: Maybe<Scalars['String']['output']>
  currency: Scalars['String']['output']
  daysPastDue: Scalars['Int']['output']
  dueDate?: Maybe<Scalars['String']['output']>
  hostName?: Maybe<Scalars['String']['output']>
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  /** For HOST_COMMISSION kind: true if the invoice came from a subscription cycle (recurring monthly commission), false for one-off commission invoices. */
  isRecurring?: Maybe<Scalars['Boolean']['output']>
  /** Discriminator for how to render this row. Defaults to RENTER for backwards compat with pre-2026-06 clients. */
  kind: PastDueInvoiceKind
  /** Admin: landlord user HubSpot contact ID */
  landlordHubspotId?: Maybe<Scalars['String']['output']>
  /** Admin: landlord (team or user) Stripe Connect account ID */
  landlordStripeAccountId?: Maybe<Scalars['String']['output']>
  lastReminderSentAt?: Maybe<Scalars['String']['output']>
  locationAddress?: Maybe<Scalars['String']['output']>
  owner?: Maybe<IOwnerInfo>
  paymentType: Scalars['String']['output']
  reminderStep?: Maybe<Scalars['Int']['output']>
  /** For RENTER kind: the renter (B2C user). For HOST_COMMISSION kind: the billed host (individual). Null when the billed party is a team. */
  renter?: Maybe<IPastDueInvoiceUser>
  /** For RENTER kind: the renter team (B2B). For HOST_COMMISSION kind: the billed host team. Null when the billed party is an individual. */
  renterTeam?: Maybe<IPastDueInvoiceTeam>
  /** Admin: checkout insurance Stripe subscription ID */
  stripeChubbSubId?: Maybe<Scalars['String']['output']>
  /** Replaced (older) Chubb subscription IDs from past plan-switches; kept for invoice history. */
  stripeReplacedChubbSubIds?: Maybe<Array<Scalars['String']['output']>>
  /** Admin: checkout rent Stripe subscription ID */
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>
}

/**
 * What kind of invoice this row represents. Drives how the admin UI renders
 * the row (renter-flow vs host-commission-flow vs catch-all) and which fields
 * are populated.
 */
export enum PastDueInvoiceKind {
  /** Closed-deal commission invoice: SpotMe billed a HOST commission on an off-platform closed deal. The `closedDealId` / `closedDealShortId` / `closedDealType` / `closedDealUrl` fields apply, and `renter`/`renterTeam` carry the billed host's user/team (semantic: "billed party"). */
  HostCommission = 'HOST_COMMISSION',
  /** Open Stripe invoice that we couldn't classify (Chubb edge cases, manual one-offs, etc). Minimum-information row — only the bare invoice fields are populated. */
  Other = 'OTHER',
  /** Renter-checkout invoice: SpotMe billed a renter for monthly rent / insurance / first-month bridge. The `renter` / `renterTeam` / `hostName` / `locationAddress` fields apply. */
  Renter = 'RENTER'
}

/** Minimal team info for past-due invoice display when renter is a team. */
export type IPastDueInvoiceTeam = {
  __typename?: 'PastDueInvoiceTeam'
  email?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  legalName?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  phone?: Maybe<Scalars['String']['output']>
}

export type IPastDueInvoiceUser = {
  __typename?: 'PastDueInvoiceUser'
  email?: Maybe<Scalars['String']['output']>
  hubspotId?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  phone?: Maybe<Scalars['String']['output']>
  stripeCustomerId?: Maybe<Scalars['String']['output']>
}

export type IPastDueInvoicesResponse = {
  __typename?: 'PastDueInvoicesResponse'
  invoices: Array<IPastDueInvoice>
  total: Scalars['Int']['output']
}

export type IPaymentMethod = {
  __typename?: 'PaymentMethod'
  card?: Maybe<ICard>
  created?: Maybe<Scalars['Int']['output']>
  id: Scalars['String']['output']
  type?: Maybe<Scalars['String']['output']>
}

export type IPayout = {
  __typename?: 'Payout'
  amount?: Maybe<Scalars['Float']['output']>
  arrivalDate?: Maybe<Scalars['String']['output']>
  created?: Maybe<Scalars['String']['output']>
  currency?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
}

/**
 * "Activar depósitos" — ONE path that takes a host into Stripe's hosted
 * onboarding, from a WhatsApp/email tap (signed token, no login) or from any
 * dashboard button (session). See `spotme-server/src/api/payoutActivation/`.
 */
export enum PayoutActivationState {
  /** Payouts already work; nothing to do. */
  Enabled = 'ENABLED',
  /** Bad, expired or foreign token. */
  Invalid = 'INVALID',
  /** An individual host whose identity SpotMe has not verified yet — no payout account is created before KYC. */
  NeedsKyc = 'NEEDS_KYC',
  /** A Stripe onboarding link can be minted; `missing` names what Stripe will ask for. */
  NeedsOnboarding = 'NEEDS_ONBOARDING',
  /** A team that cannot have a Connect account yet (RFC or company email missing). */
  NeedsTeamDetails = 'NEEDS_TEAM_DETAILS',
  /** The link was minted for someone else, or a team MEMBER who cannot act for the team. */
  NotAllowed = 'NOT_ALLOWED',
  /** Stripe could not be read right now. */
  Unknown = 'UNKNOWN'
}

export type IPayoutActivationStart = {
  __typename?: 'PayoutActivationStart'
  status: IPayoutActivationStatus
  /** Fresh single-use Stripe onboarding URL; null when nothing was minted (see status.state). */
  url?: Maybe<Scalars['String']['output']>
}

export type IPayoutActivationStatus = {
  __typename?: 'PayoutActivationStatus'
  dashboardUrl?: Maybe<Scalars['String']['output']>
  /** `team` or `user`; null when the token is invalid. */
  hostKind?: Maybe<Scalars['String']['output']>
  hostName?: Maybe<Scalars['String']['output']>
  /** Host-facing Spanish, do-this-first order ("tu CLABE …", "aceptar los términos …"). */
  missing: Array<Scalars['String']['output']>
  /** One line: "tu CLABE y aceptar los términos". */
  missingShort?: Maybe<Scalars['String']['output']>
  /** Values Stripe rejected, translated for the host. */
  rejected: Array<Scalars['String']['output']>
  state: PayoutActivationState
  /** Team details editor, when NEEDS_TEAM_DETAILS. */
  teamDetailsUrl?: Maybe<Scalars['String']['output']>
}

export enum PayoutSettlement {
  OffPlatform = 'OFF_PLATFORM',
  OnPlatform = 'ON_PLATFORM'
}

export type IPayoutsResponse = {
  __typename?: 'PayoutsResponse'
  hits: Array<IPayout>
  total: Scalars['Int']['output']
}

/**
 * A pending SpotMe→Host fiscal document obligation. Three shapes share this type:
 *
 * - Host-aggregated rent commission factura (`documentType: FACTURA`,
 *   `closedDealId: null`): SpotMe issues ONE factura per host per month covering
 *   every active rent. `periods` holds every YYYY-MM where the host earned rent
 *   commission but no factura has been uploaded.
 * - Host-aggregated retentions CFDI (`documentType: RETENCIONES`,
 *   `closedDealId: null`): emitted only for persona-física hosts (i.e. no
 *   `landlordTeamId`) — SpotMe is required by SAT to issue a separate CFDI de
 *   retenciones for each month where any IVA/ISR was withheld from the host's
 *   invoices. `periods` holds every uncovered YYYY-MM.
 * - Per-deal closed-deal commission factura (`documentType: FACTURA`,
 *   `closedDealId` set): closed deals get ONE factura per deal (not rolled into
 *   the monthly host factura), so `periods` holds the single YYYY-MM the deal
 *   closed in. Closed deals never produce RETENCIONES entries — SpotMe doesn't
 *   withhold tax on broker-mediated commissions.
 */
export type IPendingPlatformFactura = {
  __typename?: 'PendingPlatformFactura'
  closedDealId?: Maybe<Scalars['String']['output']>
  /**
   * Which document SpotMe still owes for these periods. Defaults to FACTURA for
   * every existing entry; RETENCIONES is emitted as a separate entry alongside
   * the FACTURA entry when the host is persona-física and any retention applies.
   */
  documentType: FiscalDocumentType
  host?: Maybe<IUser>
  hostTeam?: Maybe<ITeam>
  hostTeamId?: Maybe<Scalars['String']['output']>
  hostUserId?: Maybe<Scalars['String']['output']>
  periods: Array<Scalars['String']['output']>
}

export type IPendingPlatformFacturasResponse = {
  __typename?: 'PendingPlatformFacturasResponse'
  computedAt?: Maybe<Scalars['String']['output']>
  degraded: Scalars['Boolean']['output']
  degradedCount: Scalars['Int']['output']
  hits: Array<IPendingPlatformFactura>
  isRefreshing: Scalars['Boolean']['output']
  total: Scalars['Int']['output']
}

export type IPhoto = {
  __typename?: 'Photo'
  height?: Maybe<Scalars['Int']['output']>
  id: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  nonPublic?: Maybe<Scalars['Boolean']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Int']['output']>
}

export type IPhotoInput = {
  height?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['String']['input']
  name: Scalars['String']['input']
  nonPublic?: InputMaybe<Scalars['Boolean']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Int']['input']>
}

export type IPhotoUpload = {
  __typename?: 'PhotoUpload'
  id: Scalars['String']['output']
  signedUrl?: Maybe<Scalars['String']['output']>
  uploadUrl: Scalars['String']['output']
}

export type IPricing = {
  __typename?: 'Pricing'
  /** Impuestos */
  impuestos?: Maybe<Scalars['Float']['output']>
  /** Tarfifa de Seguro */
  insurance?: Maybe<Scalars['Float']['output']>
  /** Subtotal */
  subtotal?: Maybe<Scalars['Float']['output']>
  /** Tarfifa de Espacio */
  tde?: Maybe<Scalars['Float']['output']>
  /** Tarfifa de Espacio Recibida por Anfition */
  tdera?: Maybe<Scalars['Float']['output']>
  /** Tarfifa de Procesamiento */
  tdp?: Maybe<Scalars['Float']['output']>
  /** Tarfifa de Servicio */
  tds?: Maybe<Scalars['Float']['output']>
  /** Tarfifa Final */
  tf?: Maybe<Scalars['Float']['output']>
  /** Tarfifa final sin seguro */
  tfNoInsurance?: Maybe<Scalars['Float']['output']>
}

export enum PropertyType {
  Brokerage = 'BROKERAGE',
  Commercial = 'COMMERCIAL',
  IndividualBroker = 'INDIVIDUAL_BROKER',
  Residential = 'RESIDENTIAL'
}

export type IQuery = {
  __typename?: 'Query'
  /**
   * Read one HOST_DIRECT month-close by its magic-link token (the
   * `/cobro-directo/cierre/{token}` page). Returns null for an unknown,
   * consumed, or expired token — and for a viewer who isn't a member of the
   * team being billed.
   */
  directCollectionClose?: Maybe<IDirectCloseResponse>
  /**
   * ADMIN-ONLY. Every accrual partner's month-close history grouped by
   * partner — the cross-partner browse view for the "Cierres" admin tab.
   * Partners with zero close activity are omitted. Forbidden for non-admins.
   */
  accrualAllPartnerCloses: Array<IAccrualPartnerClosesGroup>
  /**
   * AUTHED month-close history ("Cierres") for a partner. Pass teamId for a
   * team partner (requester must be a member, or an admin); omit it to read
   * the requester's own individual-partner history.
   */
  accrualPartnerCloses: Array<IAccrualPartnerClose>
  /** PUBLIC — token is the auth. Month-close roster preview for a partner. */
  accrualRosterPreview?: Maybe<IAccrualRosterPreview>
  adminChats: IUserChatsResponse
  /** Admin-only list of every closed deal across all locations, with filters. */
  adminClosedDeals: IClosedDealsResponse
  /**
   * Admin-only. Batch host labels for search/map cards so the sales team can
   * see who the landlord is. Fetched client-side as an overlay — deliberately
   * NOT a `Location` field, so it can never leak into the public SSG card
   * payloads (hosts are anonymous on renter-facing surfaces). Entries that
   * can't be resolved (unknown id, directory row, nameless host) are simply
   * omitted. Max 200 ids per call; the client chunks well below that.
   */
  adminLocationHostBadges: Array<IAdminHostBadge>
  /**
   * Admin-only. The same admin-ownership backlog as the weekly host-ops
   * digest email (section 4), for the admin panel's work queue. Runs
   * several Elasticsearch reads plus a full DynamoDB scan — do not poll.
   */
  adminOwnershipQueue: IAdminOwnershipQueue
  /**
   * ADMIN-ONLY (any admin role). The transcript of one Line 1 WhatsApp
   * conversation from our store, newest message last. Null when no thread with
   * this id exists. `limit` caps the messages returned (default 200, max 500).
   */
  adminWaTranscript?: Maybe<IWaTranscript>
  authenticated: Scalars['Boolean']['output']
  chat: IChat
  chatByParticipants?: Maybe<IChat>
  checkout: ICheckout
  checkoutFiscalDocuments: IFiscalDocumentsResponse
  /**
   * Single closed deal by id. Returns the deal if the caller is an admin or
   * owns/team-belongs to the deal's location. Throws Forbidden otherwise.
   */
  closedDeal?: Maybe<IClosedDeal>
  /**
   * Public, token-authorized preview for the host magic-link confirmation
   * page (`/tratos/confirmar/[token]`). No auth required — the token itself
   * is the credential. Rate-limited; returns null for an invalid/expired/
   * rate-limited token (the resolver never throws for this query so the
   * page can render a generic "link no longer valid" card either way).
   */
  closedDealConfirmationPreview?: Maybe<IClosedDealConfirmationPreview>
  /**
   * Admin-only. Dry-run repair plan for a closed deal — fetches live Stripe
   * invoices + ACTIVE facturas and returns the ordered action list, refusals,
   * warnings, and deferred follow-ups. Read-only; `repairClosedDeal` executes.
   */
  closedDealRepairPreview: IClosedDealRepairPlan
  closedDeals: IClosedDealsResponse
  commercialLocations: ISearchLocationResponse
  currentUser?: Maybe<IUser>
  dashboardContext: IDashboardContext
  /**
   * The directory surface's SECOND, explicit query (plan §2.1) — the ONLY
   * public read path that opts in to `isDirectoryListing: true` rows. Its
   * results render in a separate list below the tier-floor divider and are
   * NEVER merged into the ranked `searchLocations` array, so no future scoring
   * change can promote a directory row above monetized supply.
   *
   * Deliberately reuses `SearchLocationsInput` for `center` / `zoom` /
   * `locationTypes` only; price, size, sort and text filters are ignored —
   * directory rows carry one unpriced configuration whose only job is to make
   * the category filterable. Never counted in any public "X espacios" stat.
   */
  adminDirectoryClaims: IAdminDirectoryClaimResponse
  adminDirectoryDuplicates: IAdminDirectoryDuplicatesResponse
  directoryClaimDemand: IDirectoryClaimDemand
  directoryLocations: ISearchLocationResponse
  directoryOptOutPreview?: Maybe<IDirectoryOptOutPreview>
  directorySitemapRows: Array<ILocation>
  /** SpotMe Now's first-month discount rule and whether the early-exit clawback is on. */
  firstMonthDiscountPolicy: IFirstMonthDiscountPolicy
  myDirectoryClaim?: Maybe<IDirectoryClaimSelf>
  /** Logged-in: the viewer's own account, or a team the viewer administers (platform admins: any team). */
  myPayoutActivationStatus: IPayoutActivationStatus
  partnerLinkView: IPartnerLinkView
  /** PUBLIC — the signed token is the auth. IP rate-limited; an invalid token yields state INVALID, never an error. */
  payoutActivationStatus: IPayoutActivationStatus
  discounts: Array<IDiscount>
  emailBelongsToUser: Scalars['Boolean']['output']
  fiscalDocuments: IFiscalDocumentsResponse
  generateUploadUrls: Array<IPhotoUpload>
  googleAddress: IAddress
  googleAutocompleteSuggestions: Array<IGoogleAutocompleteSuggestion>
  googleCoordinates: IGooglePlaceDetails
  googlePlaceDetails: IGooglePlaceDetails
  hostLeads: IHostLeadsResponse
  hostPayoutEstimates: Array<IHostPayoutEstimate>
  /**
   * With `teamId`: that team (member or platform admin, Forbidden otherwise).
   * Without: the viewer's own individual-host account plus every host team they
   * belong to (platform admins: their own account only). Accounts that are not
   * hosts are omitted.
   */
  hostSetup: Array<IHostSetupScope>
  /** Success numbers for the caller (teamId set → that team; requester must be a member/admin. Omitted → own individual listings). */
  hostSuccessSummary?: Maybe<IHostSuccessSummary>
  individualHosts: IIndividualHostsResponse
  /**
   * AUTHED (dashboard sibling of `inventoryInmueblePending`, which is
   * token-authorized). Of the given listings, the ones the requester may manage
   * whose building declaration is still unconfirmed. Ids the requester may NOT
   * manage are skipped silently — never a Forbidden, so one stale id from a
   * client cache can't blank the whole strip.
   */
  inmueblePendingForLocations: Array<IInventoryInmueblePendingLocation>
  /** PUBLIC — the signed token is the auth. */
  inmuebleReviewStatus: IInmuebleReviewStatus
  insuranceQuote?: Maybe<Array<IInsuranceQuote>>
  /** PUBLIC. Returns [] when the token is invalid or nothing is pending. */
  inventoryInmueblePending: Array<IInventoryInmueblePendingLocation>
  /** AUTHED — next steps for the requester's scope (same scope rules as inventoryReviewStatus). */
  inventoryNextSteps: IInventoryNextSteps
  /** PUBLIC — the signed inventory token is the auth. Empty on an invalid token. */
  inventoryNextStepsByToken: IInventoryNextSteps
  inventoryReviewStatus: IInventoryReviewStatus
  ipInfo?: Maybe<IIpInfo>
  /**
   * PUBLIC, token-authorized. Rate-limited 10/60s/IP (shared bucket with
   * setRenterLeadOutcomeByToken). Returns null for an invalid, expired, or
   * rate-limited token — the page renders one generic "link no longer valid"
   * card regardless of cause.
   */
  leadVerificationPreview?: Maybe<ILeadVerificationPreview>
  location: ILocation
  locationByConfiguration: ILocation
  locationConfigurationByNanoId: ILocation
  /** Get tab counts for all listing filters in a single query (auth + teams resolved once) */
  locationCounts: ILocationTabCounts
  /**
   * Admin-only. Dry-run preview of what `transferLocationOwnership` would
   * do, without applying it.
   */
  locationOwnershipTransferPreview: IOwnershipTransferPreview
  locationVerificationRequests: ISearchLocationResponse
  /**
   * Count of host's active checkouts missing a factura for the current period.
   * When `searchInput` provides team-scoping signal (`teamId` and/or
   * `userAndTeams`), the count narrows accordingly so the navbar/drawer
   * badges align with the dashboard team filter. Omit `searchInput` for the
   * legacy cross-team total.
   */
  missingFacturaCount: Scalars['Int']['output']
  /**
   * Count of host's past checkouts (last 6 months) with refund obligations
   * that lack the required nota-de-crédito + refund-proof pair. Same
   * team-scoping behavior as `missingFacturaCount`.
   */
  missingRefundDocCount: Scalars['Int']['output']
  nearbySearchCounts: INearbySearchCountsResult
  ofacQuery: IOfac
  pastDueInvoices: IPastDueInvoicesResponse
  /**
   * Count of closed deals owned by the current user (or their team locations)
   * whose off-platform host commission billing has at least one OPEN (unpaid)
   * invoice — due or not. Drives the host notification trail: sidebar 'Tratos
   * cerrados' badge, profile-button red dot, and the payment banner on the
   * detail page.
   *
   * Scoping mirrors `closedDeals`: admins see the cross-platform total;
   * non-admins are scoped to deals on their own locations + team locations.
   * Backed by the `billing.hasOpenInvoice` ES flag maintained by the
   * host-billing-dunning cron sweep + invoice webhooks. Returns 0 when every
   * invoice is settled.
   */
  pendingClosedDealCount: Scalars['Int']['output']
  /** Admin-only. Lists every SpotMe→Host factura SpotMe has not yet uploaded. */
  pendingPlatformFacturas: IPendingPlatformFacturasResponse
  /**
   * Admin-only. Lightweight count for the admin tab badge. Uses a fast-path
   * check (current period only, no Stripe calls) — may be slightly lower than
   * the full pendingPlatformFacturas.total but safe to run on every page load.
   */
  pendingPlatformFacturasCount: Scalars['Int']['output']
  /** Preview what would happen if this checkout were cancelled */
  previewCancellation: ICancellationBreakdown
  recommendedLocations: ISearchLocationResponse
  referredUsers: IUsersResponse
  /** Get tab counts for renter rents in a single query */
  rentCounts: ICheckoutTabCounts
  rents: ICheckoutsResponse
  reportedLocations: ISearchLocationResponse
  reportedUsers: IUsersResponse
  /**
   * Reservation contact for the pre-auth /reservar page. Returns the human
   * specialist for unauthed renters bailing out of the OTP flow. Select
   * `whatsappE164` to receive the direct contact number — this query is the
   * only surface that populates it. `configurationId` is reserved for future
   * routing-by-region / routing-by-volume; today the resolver returns
   * Fernando unconditionally.
   */
  reservarContact: ISpecialist
  /** Server-render only: the chatbot link's encrypted phone token → E.164 (null for any non-SSR caller). */
  reservarPhonePrefill?: Maybe<Scalars['String']['output']>
  /** Get tab counts for all checkout types in a single query (auth + teams resolved once) */
  reservationCounts: ICheckoutTabCounts
  reservations: ICheckoutsResponse
  /** Admin-only: preview a full checkout rewind (refund + host-transfer reversal + cancel), with window status. */
  rewindCheckoutPreview: IRewindCheckoutPreview
  /**
   * Returns the SAT fiscal compliance report for the current auditor.
   * Authorization: caller must have user.isSatAuditor === true OR be a SpotMe
   * admin (admins can preview the portal). Every call is logged for audit.
   */
  satComplianceReport: ISatComplianceReport
  searchLocations: ISearchLocationResponse
  searchUsers: IUsersResponse
  /**
   * Authenticated. 1–3 photo URLs already uploaded to our bucket
   * (generateUploadUrls). Kill switch LISTING_SUGGESTION_DISABLED; per-user
   * daily cap LISTING_SUGGESTION_DAILY_CAP (default 10).
   */
  suggestListingFromPhotos: IListingSuggestionResult
  suggestedClosedDealCommission: ISuggestedCommission
  team: ITeam
  teamInvitePreview?: Maybe<ITeamInvitePublic>
  teamInvites: Array<ITeamInvite>
  teams: ITeamsResponse
  /**
   * The non-payment day counts (rescission window, release window, hold length).
   * Constants, identical for everyone — no auth, no arguments.
   */
  unpaidPolicy: IUnpaidPolicy
  unreadMessages: IChatMessagesResponse
  user: IUser
  userByNanoId: IUser
  userChats: IUserChatsResponse
  userLeads: IUsersResponse
  userLocations: ISearchLocationResponse
  userVerificationRequests: IUsersResponse
  /**
   * PUBLIC, token-authorized preview for the /visita/[token] host page.
   * Token is the only credential. Rate-limited — SAME shared bucket as
   * leadVerificationPreview / setRenterLeadOutcomeByToken. Returns null for
   * an invalid, expired, or rate-limited token — the page renders one
   * generic "link no longer valid" card regardless of cause.
   */
  visitRequestPreview?: Maybe<IVisitRequestPreview>
}

export type IQueryAccrualPartnerClosesArgs = {
  teamId?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
}

export type IQueryAccrualRosterPreviewArgs = {
  token: Scalars['String']['input']
}

export type IQueryAdminChatsArgs = {
  pagination: IPaginationInput
}

export type IQueryAdminClosedDealsArgs = {
  filter?: InputMaybe<IAdminClosedDealsFilter>
  pagination: IPaginationInput
}

export type IQueryAdminLocationHostBadgesArgs = {
  locationIds: Array<Scalars['String']['input']>
}

export type IQueryAdminWaTranscriptArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  threadId: Scalars['String']['input']
}

export type IQueryChatArgs = {
  chatId: Scalars['String']['input']
}

export type IQueryChatByParticipantsArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>
  participants: Array<IChatParticipantInput>
}

export type IQueryCheckoutArgs = {
  checkoutId: Scalars['String']['input']
}

export type IQueryCheckoutFiscalDocumentsArgs = {
  checkoutId: Scalars['String']['input']
}

export type IQueryClosedDealArgs = {
  id: Scalars['String']['input']
}

export type IQueryClosedDealConfirmationPreviewArgs = {
  token: Scalars['String']['input']
}

export type IQueryClosedDealRepairPreviewArgs = {
  edits?: InputMaybe<IClosedDealRepairEditsInput>
  id: Scalars['String']['input']
  mode: ClosedDealRepairMode
  reason?: InputMaybe<Scalars['String']['input']>
}

export type IQueryClosedDealsArgs = {
  configurationId?: InputMaybe<Scalars['String']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
}

export type IQueryCommercialLocationsArgs = {
  pagination: IPaginationInput
}

export type IQueryCurrentUserArgs = {
  interest?: InputMaybe<Interest>
  referrer?: InputMaybe<Scalars['String']['input']>
}

export type IQueryDashboardContextArgs = {
  hostId?: InputMaybe<Scalars['String']['input']>
  teamId?: InputMaybe<Scalars['String']['input']>
}

export type IQueryDirectoryClaimDemandArgs = {
  locationId: Scalars['String']['input']
}

export type IQueryDirectoryLocationsArgs = {
  pagination: IPaginationInput
  searchInput: ISearchLocationsInput
}

export type IQueryEmailBelongsToUserArgs = {
  email: Scalars['String']['input']
}

export type IQueryFiscalDocumentsArgs = {
  pagination: IPaginationInput
  search?: InputMaybe<IFiscalDocumentSearchInput>
}

export type IQueryGenerateUploadUrlsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  nonPublic?: InputMaybe<Scalars['Boolean']['input']>
}

export type IQueryGoogleAddressArgs = {
  lat: Scalars['Float']['input']
  lng: Scalars['Float']['input']
}

export type IQueryGoogleAutocompleteSuggestionsArgs = {
  searchValue: Scalars['String']['input']
}

export type IQueryGoogleCoordinatesArgs = {
  address: Scalars['String']['input']
}

export type IQueryGooglePlaceDetailsArgs = {
  placeId: Scalars['String']['input']
}

export type IQueryHostLeadsArgs = {
  input: IHostLeadsInput
}

export type IQueryHostPayoutEstimatesArgs = {
  inputs: Array<IHostPayoutEstimateInput>
}

export type IQueryHostSetupArgs = {
  teamId?: InputMaybe<Scalars['String']['input']>
}

export type IQueryHostSuccessSummaryArgs = {
  teamId?: InputMaybe<Scalars['ID']['input']>
}

export type IQueryIndividualHostsArgs = {
  pagination: IPaginationInput
  searchText?: InputMaybe<Scalars['String']['input']>
}

export type IQueryInmueblePendingForLocationsArgs = {
  locationIds: Array<Scalars['String']['input']>
}

export type IQueryInmuebleReviewStatusArgs = {
  token: Scalars['String']['input']
}

export type IQueryInsuranceQuoteArgs = {
  insuranceInput: IInsuranceQuoteInput
}

export type IQueryInventoryInmueblePendingArgs = {
  token: Scalars['String']['input']
}

export type IQueryInventoryNextStepsArgs = {
  input?: InputMaybe<IInventoryReviewScopeInput>
}

export type IQueryInventoryNextStepsByTokenArgs = {
  token: Scalars['String']['input']
}

export type IQueryInventoryReviewStatusArgs = {
  input?: InputMaybe<IInventoryReviewScopeInput>
}

export type IQueryLeadVerificationPreviewArgs = {
  token: Scalars['String']['input']
}

export type IQueryLocationArgs = {
  configurationId?: InputMaybe<Scalars['String']['input']>
  locationId: Scalars['String']['input']
}

export type IQueryLocationByConfigurationArgs = {
  configurationId: Scalars['String']['input']
}

export type IQueryLocationConfigurationByNanoIdArgs = {
  nanoId: Scalars['String']['input']
}

export type IQueryLocationCountsArgs = {
  input?: InputMaybe<ILocationCountsInput>
}

export type IQueryLocationOwnershipTransferPreviewArgs = {
  input: ITransferLocationOwnershipInput
}

export type IQueryLocationVerificationRequestsArgs = {
  pagination: IPaginationInput
}

export type IQueryMissingFacturaCountArgs = {
  searchInput?: InputMaybe<ISearchCheckoutsInput>
}

export type IQueryMissingRefundDocCountArgs = {
  searchInput?: InputMaybe<ISearchCheckoutsInput>
}

export type IQueryNearbySearchCountsArgs = {
  input: INearbySearchCountsInput
}

export type IQueryOfacQueryArgs = {
  firstname: Scalars['String']['input']
  lastname: Scalars['String']['input']
  lastnameMaternal: Scalars['String']['input']
}

export type IQueryPastDueInvoicesArgs = {
  pagination: IPaginationInput
}

export type IQueryPreviewCancellationArgs = {
  actingAs?: InputMaybe<Interest>
  checkoutId: Scalars['String']['input']
  scheduledEndDate?: InputMaybe<Scalars['String']['input']>
}

export type IQueryRecommendedLocationsArgs = {
  pagination: IPaginationInput
  searchInput: ISearchLocationsInput
}

export type IQueryReferredUsersArgs = {
  pagination: IPaginationInput
}

export type IQueryRentCountsArgs = {
  searchInput?: InputMaybe<ISearchCheckoutsInput>
}

export type IQueryRentsArgs = {
  pagination: IPaginationInput
  searchInput: ISearchCheckoutsInput
}

export type IQueryReportedLocationsArgs = {
  pagination: IPaginationInput
}

export type IQueryReportedUsersArgs = {
  pagination: IPaginationInput
}

export type IQueryReservarContactArgs = {
  configurationId?: InputMaybe<Scalars['String']['input']>
}

export type IQueryReservarPhonePrefillArgs = {
  token: Scalars['String']['input']
}

export type IQueryReservationCountsArgs = {
  searchInput?: InputMaybe<ISearchCheckoutsInput>
}

export type IQueryReservationsArgs = {
  pagination: IPaginationInput
  searchInput: ISearchCheckoutsInput
}

export type IQueryRewindCheckoutPreviewArgs = {
  checkoutId: Scalars['String']['input']
}

export type IQuerySatComplianceReportArgs = {
  filters?: InputMaybe<ISatComplianceFilters>
}

export type IQuerySearchLocationsArgs = {
  pagination: IPaginationInput
  searchInput: ISearchLocationsInput
}

export type IQuerySearchUsersArgs = {
  options: IUserSearchInput
  pagination: IPaginationInput
}

export type IQuerySuggestListingFromPhotosArgs = {
  photoUrls: Array<Scalars['String']['input']>
}

export type IQuerySuggestedClosedDealCommissionArgs = {
  closedDealId: Scalars['String']['input']
  segment?: InputMaybe<TeamSegment>
}

export type IQueryDirectCollectionCloseArgs = {
  token: Scalars['String']['input']
}

export type IQueryTeamArgs = {
  teamId: Scalars['String']['input']
}

export type IQueryTeamsArgs = {
  pagination?: InputMaybe<IPaginationInput>
  searchText?: InputMaybe<Scalars['String']['input']>
}

export type IQueryUnreadMessagesArgs = {
  chatId?: InputMaybe<Scalars['String']['input']>
}

export type IQueryUserArgs = {
  userId: Scalars['String']['input']
}

export type IQueryUserByNanoIdArgs = {
  nanoId: Scalars['String']['input']
}

export type IQueryUserChatsArgs = {
  pagination: IPaginationInput
}

export type IQueryUserLeadsArgs = {
  pagination: IPaginationInput
}

export type IQueryUserLocationsArgs = {
  pagination: IPaginationInput
  userLocationsInput: IUserLocationsInput
}

export type IQueryUserVerificationRequestsArgs = {
  pagination: IPaginationInput
}

export type IQueryVisitRequestPreviewArgs = {
  token: Scalars['String']['input']
}

export type IReadReceipt = {
  __typename?: 'ReadReceipt'
  memberId: Scalars['String']['output']
  participant: IChatParticipant
  read: Scalars['Boolean']['output']
}

export type IReadConstanciaFiscalInput = {
  /** application/pdf, image/jpeg, image/png, image/webp or image/heic. */
  fileBase64: Scalars['String']['input']
  mediaType: Scalars['String']['input']
}

export type IRecordBrowserLeadConversionInput = {
  configurationId?: InputMaybe<Scalars['String']['input']>
  contentCategory?: InputMaybe<Scalars['String']['input']>
  contentName?: InputMaybe<Scalars['String']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  eventId: Scalars['String']['input']
  locationId?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['Float']['input']>
  vertical?: InputMaybe<Scalars['String']['input']>
}

export enum ReferrerStatus {
  Accepted = 'ACCEPTED',
  Na = 'NA',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/**
 * A single refund the host owes the renter. Surfaced as a list so a checkout
 * with both a prorated-rent refund AND a deposit return AND/OR a one-time-fee
 * reversal can show each one with its own amount, breakdown, due date, and
 * nota-de-crédito guidance — instead of collapsing them into a single
 * aggregate `refundAmount`.
 */
export type IRefundObligation = {
  __typename?: 'RefundObligation'
  /** IVA-inclusive amount to transfer to the renter. */
  amount: Scalars['Float']['output']
  /** Subtotal + IVA + total breakdown. Null for kinds that are intrinsically IVA-free (e.g. security deposit return). */
  breakdown?: Maybe<IFacturaAmount>
  /** Concept key for i18n (REFUND_OBLIGATION.KIND.*). */
  conceptKey: Scalars['String']['output']
  /** ISO date the obligation should be completed by — typically scheduledEndDate / endedAt + the regulatory window. */
  dueBy?: Maybe<Scalars['String']['output']>
  /** Synthetic id stable per (checkoutId, kind, sourceId). Frontend uses this for keying lists. */
  id: Scalars['String']['output']
  kind: RefundObligationKind
  /** Pre-built nota-de-crédito guidance when required (receptor, RFC, tipo, uso CFDI, concepto sugerido, instructions). */
  notaDeCredito?: Maybe<ICancellationNotaDeCredito>
  /** True when the host must additionally issue a CFDI nota de crédito for this obligation (rent proration + grace period). False for deposit return / one-time-fee reversal (no factura was issued). */
  notaDeCreditoRequired: Scalars['Boolean']['output']
}

/**
 * What kind of refund obligation this represents. Drives the concept label
 * shown to the host and which CFDI / nota-de-crédito guidance applies.
 */
export enum RefundObligationKind {
  /** Security-deposit return at end of rental (Anexo A §6). */
  DepositReturn = 'DEPOSIT_RETURN',
  /** 24h grace-period cancellation per Anexo A §5.1 — host transfers total minus Stripe processing fee. */
  GracePeriod = 'GRACE_PERIOD',
  /** Reversal of a one-time fee (access card, etc.) when applicable. */
  OneTimeFeeReversal = 'ONE_TIME_FEE_REVERSAL',
  /** Prorated unused-days refund after a scheduled or immediate cancellation. */
  RentProration = 'RENT_PRORATION'
}

/**
 * Structured resolution record. Persisted on Checkout; gates banners + emails
 * + cron reminders across the refund flow.
 */
export type IRefundResolution = {
  __typename?: 'RefundResolution'
  /** True when the host still owes SAT a nota de crédito outside the platform (typical for COMPLETED_OFF_PLATFORM where docs weren't uploaded). */
  notaDeCreditoStillExpected?: Maybe<Scalars['Boolean']['output']>
  reason?: Maybe<Scalars['String']['output']>
  /** For COMPLETED_OFF_PLATFORM: tracks renter confirmation. Null for other resolution types. */
  renterConfirmation?: Maybe<IRefundResolutionRenterConfirmation>
  resolvedAt: Scalars['String']['output']
  /** Human-readable name of who resolved it, for audit display. */
  resolvedByName?: Maybe<Scalars['String']['output']>
  resolvedByUserId: Scalars['String']['output']
  type: RefundResolutionType
}

export enum RefundResolutionConfirmationStatus {
  AutoConfirmedByDeadline = 'AUTO_CONFIRMED_BY_DEADLINE',
  Confirmed = 'CONFIRMED',
  Disputed = 'DISPUTED',
  Pending = 'PENDING'
}

/**
 * Renter-side confirmation loop for COMPLETED_OFF_PLATFORM resolutions (Phase 2).
 * The renter has 7 days to confirm receipt or dispute; otherwise auto-confirms.
 */
export type IRefundResolutionRenterConfirmation = {
  __typename?: 'RefundResolutionRenterConfirmation'
  disputeReason?: Maybe<Scalars['String']['output']>
  /** ISO deadline by which the renter must confirm or dispute before auto-confirmation. */
  expiresAt?: Maybe<Scalars['String']['output']>
  respondedAt?: Maybe<Scalars['String']['output']>
  status: RefundResolutionConfirmationStatus
}

/**
 * How a refund obligation was resolved when it didn't go through the standard
 * fiscal-docs upload path. Drives copy + downstream behavior.
 */
export enum RefundResolutionType {
  /** Host transferred the refund to the renter via bank/cash/other off SpotMe. Phase 2 host self-attestation flow. */
  CompletedOffPlatform = 'COMPLETED_OFF_PLATFORM',
  /** Host uploaded both nota de crédito + comprobante via fiscal-docs flow. Mirrors checkRefundDocsComplete=true semantically — admins may set this manually for legacy cases. */
  CompletedOnPlatform = 'COMPLETED_ON_PLATFORM',
  /** The platform computed a refund in error. Admin-only cleanup path. */
  SystemCorrection = 'SYSTEM_CORRECTION',
  /** SpotMe admin determined no refund is owed (damage to space, fraud, contract breach, etc.) */
  WaivedByAdmin = 'WAIVED_BY_ADMIN',
  /** Renter explicitly waived the refund (goodwill, mutual settlement, etc.). Phase 3 — renter-initiated, irreversible. */
  WaivedByRenter = 'WAIVED_BY_RENTER'
}

export enum RegimenFiscal {
  Id_601 = 'ID_601',
  Id_603 = 'ID_603',
  Id_605 = 'ID_605',
  Id_606 = 'ID_606',
  Id_607 = 'ID_607',
  Id_608 = 'ID_608',
  Id_610 = 'ID_610',
  Id_611 = 'ID_611',
  Id_612 = 'ID_612',
  Id_614 = 'ID_614',
  Id_615 = 'ID_615',
  Id_616 = 'ID_616',
  Id_620 = 'ID_620',
  Id_621 = 'ID_621',
  Id_622 = 'ID_622',
  Id_623 = 'ID_623',
  Id_624 = 'ID_624',
  Id_625 = 'ID_625',
  Id_626 = 'ID_626'
}

export type IRegisterUserInput = {
  email?: InputMaybe<Scalars['String']['input']>
  firstname?: InputMaybe<Scalars['String']['input']>
  interest?: InputMaybe<Interest>
  lastname?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  profilePicture?: InputMaybe<IPhotoInput>
  referrer?: InputMaybe<Scalars['String']['input']>
}

/** Whether the renter on a closed deal is an individual or a business (B2B). */
export enum RenterType {
  Business = 'BUSINESS',
  Individual = 'INDIVIDUAL'
}

export type IReport = {
  __typename?: 'Report'
  chatId?: Maybe<Scalars['String']['output']>
  reason?: Maybe<Scalars['String']['output']>
  reportedAt?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['String']['output']>
}

export type IReportUserInput = {
  chatId?: InputMaybe<Scalars['String']['input']>
  reason: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type IReportsResponse = {
  __typename?: 'ReportsResponse'
  reports: Array<IReport>
  total: Scalars['Int']['output']
}

export type IRequestPreferencesInput = {
  currency?: InputMaybe<Currency>
  language?: InputMaybe<Language>
}

export type IRequestSavePreferencesResponse = {
  __typename?: 'RequestSavePreferencesResponse'
  user: IUser
}

export type IRequestVerificationInput = {
  actividadEmpresarial?: InputMaybe<Scalars['Boolean']['input']>
  address?: InputMaybe<IAddressInput>
  birthdate?: InputMaybe<Scalars['String']['input']>
  civilStatus?: InputMaybe<CivilStatus>
  clabe?: InputMaybe<Scalars['String']['input']>
  configurationId?: InputMaybe<Scalars['String']['input']>
  constanciaFiscal?: InputMaybe<IPhotoInput>
  curp?: InputMaybe<Scalars['String']['input']>
  currentCity?: InputMaybe<Scalars['String']['input']>
  customerType?: InputMaybe<CustomerType>
  description?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  facebookUrl?: InputMaybe<Scalars['String']['input']>
  favoriteSong?: InputMaybe<Scalars['String']['input']>
  firstname?: InputMaybe<Scalars['String']['input']>
  hobbie?: InputMaybe<Scalars['String']['input']>
  hostType?: InputMaybe<HostType>
  identification?: InputMaybe<IPhotoInput>
  instagramUrl?: InputMaybe<Scalars['String']['input']>
  interest?: InputMaybe<Interest>
  job?: InputMaybe<Scalars['String']['input']>
  languages?: InputMaybe<Array<Scalars['String']['input']>>
  lastname?: InputMaybe<Scalars['String']['input']>
  lastnameMaternal?: InputMaybe<Scalars['String']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
  movieAsLife?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  profilePicture?: InputMaybe<IPhotoInput>
  quantity?: InputMaybe<Scalars['Int']['input']>
  regimenFiscal?: InputMaybe<RegimenFiscal>
  rfc?: InputMaybe<Scalars['String']['input']>
  storageTime?: InputMaybe<StorageTime>
  twitterUrl?: InputMaybe<Scalars['String']['input']>
  userId: Scalars['String']['input']
  usoCFDI?: InputMaybe<UsoCfdi>
}

export type IRequestVerificationResponse = {
  __typename?: 'RequestVerificationResponse'
  user: IUser
}

export type IResolveRefundInput = {
  /** When true, host still needs to issue a nota de crédito outside SpotMe (we just clear the platform obligation). */
  notaDeCreditoStillExpected?: InputMaybe<Scalars['Boolean']['input']>
  /** Free-text rationale, required. Audit log captures this verbatim. */
  reason: Scalars['String']['input']
  type: RefundResolutionType
}

export type IReview = {
  __typename?: 'Review'
  createdAt?: Maybe<Scalars['String']['output']>
  interest?: Maybe<Interest>
  rating?: Maybe<Scalars['Float']['output']>
  respondedAt?: Maybe<Scalars['String']['output']>
  response?: Maybe<Scalars['String']['output']>
  review?: Maybe<Scalars['String']['output']>
  reviewer?: Maybe<IUser>
  reviewerId?: Maybe<Scalars['String']['output']>
}

export type IReviewResponse = {
  __typename?: 'ReviewResponse'
  avgRating?: Maybe<Scalars['Float']['output']>
  hits?: Maybe<Array<IReview>>
  total?: Maybe<Scalars['Int']['output']>
}

export type IRewindCheckoutPreview = {
  __typename?: 'RewindCheckoutPreview'
  /** Why a rewind is blocked when canRewind is false: already_cancelled | not_approved | no_paid_charge | outside_window. */
  blockedReason?: Maybe<Scalars['String']['output']>
  /** True only when the checkout can be rewound right now: not already cancelled, has a paid first-month charge, AND within the transfer-reversal window. */
  canRewind: Scalars['Boolean']['output']
  checkoutId: Scalars['String']['output']
  /** Whole days since host approval — the reversal-window clock starts there. */
  daysSinceApproval: Scalars['Int']['output']
  /** UTC string — the last moment the reversal window is open. */
  deadline?: Maybe<Scalars['String']['output']>
  /** MXN Stripe processing fee withheld from the refund (SpotMe never eats it). */
  feeKept?: Maybe<Scalars['Float']['output']>
  /** Estimated MXN of security deposit + one-time fees that rewind will ALSO refund (null when none). A legacy deposit-only invoice with unknown amount isn't in this estimate but is still refunded at execute time. */
  oneTimeRefundEstimate?: Maybe<Scalars['Float']['output']>
  /** MXN refunded to the renter (rent + commission, minus the non-refundable Stripe fee). */
  refundAmount?: Maybe<Scalars['Float']['output']>
  /** When the renter already scheduled a flexible cancellation that hasn't taken effect yet, the pending end date (rewind supersedes it). Null otherwise. */
  scheduledCancellationDate?: Maybe<Scalars['String']['output']>
  /** MXN host transfer that will be clawed back IN FULL (host ends at $0). */
  transferToReverse?: Maybe<Scalars['Float']['output']>
  windowDays: Scalars['Int']['output']
  withinWindow: Scalars['Boolean']['output']
}

export type IRewindCheckoutResult = {
  __typename?: 'RewindCheckoutResult'
  checkoutId: Scalars['String']['output']
  feeKept?: Maybe<Scalars['Float']['output']>
  /** MXN of security deposit + one-time fees refunded alongside the bridge charge. */
  oneTimeRefunded?: Maybe<Scalars['Float']['output']>
  refundAmount?: Maybe<Scalars['Float']['output']>
  refundId?: Maybe<Scalars['String']['output']>
  transferReversed?: Maybe<Scalars['Float']['output']>
}

/**
 * One lead SpotMe sent this partner during the close month — masked
 * recognition row for the roster page. Always masked (lada + last 4) and
 * first-name-only, regardless of Team.isPartner.
 *
 * ⚠️ NEVER add `conflict` (the §D3 renter-vs-partner severity) back to this
 * type. The partner sees the renter's OWN ANSWER (`renterOutcome`) — that IS
 * §D4's cross-check — and never SpotMe's verdict about it: `HIGH` is precisely
 * the disintermediation signal (`notOriginated` / a renter retraction / "the
 * partner says they never closed"), §D3 routes conflicts to the admin digest,
 * `AdminNoti` and Fer, and a partner who can read the severity learns which of
 * their answers trips it. The field still exists on the INTERNAL row
 * (`IRosterLeadSentRow.conflict`) for the admin submit email only.
 */
export type IRosterLeadSent = {
  /** Host acknowledgment time; never proof of contact or a rental outcome. */
  hostContactedAt?: Maybe<Scalars['String']['output']>
  __typename?: 'RosterLeadSent'
  /** True when hostOutcome is CLOSED or contact was unlocked — row shows ✓, not tappable. */
  alreadyReported: Scalars['Boolean']['output']
  /** The lead's configurationId when present — prefills the declare form's listing picker. */
  configurationId?: Maybe<Scalars['String']['output']>
  /** Host-reported outcome overlay — the tri-state's current value (null = untouched). */
  hostOutcome?: Maybe<HostLeadOutcome>
  leadId: Scalars['String']['output']
  /**
   * WHERE the lead was generated — 'city · listing title' frozen on the record
   * at dispatch (market city alone for on-demand). Multi-sucursal teams share
   * one roster across branch managers; the branch makes a lead recognizable.
   */
  listingLabel?: Maybe<Scalars['String']['output']>
  /** The lead's location when listing-scoped (null for on-demand market leads) — per-sucursal filter key. */
  locationId?: Maybe<Scalars['String']['output']>
  /** Display phone: full when the recipient is a partner NOW or the lead froze FULL/unlocked; else masked '81 ·· ·· 0182' (MX lada) / '+593 ·· ·· 5962' (foreign). Null when the lead has no phone. */
  maskedPhone?: Maybe<Scalars['String']['output']>
  /** Display name: full when the recipient is a partner NOW or the lead froze FULL/unlocked; else first name only. Null when the lead came nameless. */
  name?: Maybe<Scalars['String']['output']>
  /**
   * Canonical metro slug for an ON-DEMAND (market) lead — the city the
   * "almacenamiento a domicilio" close happened in. Null for listing leads. The
   * quick-report panel sends it straight back on declareClosedDeal, which is why
   * a listing-less close needs no city picker.
   */
  onDemandCity?: Maybe<Scalars['String']['output']>
  /**
   * The renter-declared deal this lead already minted (§C1). When it is set,
   * «Cerré» routes to Confirmar on THAT "Reportado por el interesado" row
   * instead of opening the quick report — a second declare would bill one rental
   * twice (spec §D3 row 1).
   */
  renterDeclaredDealId?: Maybe<Scalars['String']['output']>
  /**
   * The renter's OWN answer (spec §D1's amber chip). Structured only — the
   * renter's free text is their reply to SpotMe and never crosses to the partner
   * (spec §D4).
   */
  renterOutcome?: Maybe<RenterLeadOutcome>
  /** Lead createdOn (as stored on the record). */
  sentAt: Scalars['String']['output']
  /** What they asked about, e.g. '4 m²' — the frozen host-facing label from the notification. Non-PII. */
  sizeLabel?: Maybe<Scalars['String']['output']>
  /**
   * The lead's DISPLAY status — the SAME vocabulary the Interesados inbox shows
   * (computeDisplayStatus → toHostLeadStatus). The roster renders the same
   * tri-state control as the inbox, so it derives the same LOCKED predicate from
   * it (RESERVED with a non-CLOSED hostOutcome = SpotMe observed the close, the
   * partner cannot un-close it). Two vocabularies would give one partner two
   * words for one state.
   */
  status: HostLeadStatus
}

export type ISatComplianceFilters = {
  /**
   * Limit oferentes list (default 200). The receptores list is always
   * returned fully for the targetMonth — auditors must see every operation.
   */
  oferentesLimit?: InputMaybe<Scalars['Int']['input']>
  /** Filter to hosts with revenue in targetMonth only (default false). */
  onlyWithRevenue?: InputMaybe<Scalars['Boolean']['input']>
  /** YYYY-MM (e.g. '2026-04'). Defaults to previous month. */
  targetMonth?: InputMaybe<Scalars['String']['input']>
}

/**
 * SAT fiscal-compliance portal (Art. 30-B CFF + Regla 2.9.21 RMF, ficha 168/CFF).
 *
 * Exposes the data the Mexican tax authority is entitled to consult in real time
 * about (1) the intermediation service SpotMe sells to hosts and (2) the
 * underlying operations SpotMe intermediates between hosts and renters.
 *
 * Every field on this query is GATED by user.isSatAuditor === true. The
 * SAT auditor account is a regular Firebase user with no admin role — they
 * authenticate normally and the resolver verifies the flag.
 */
export type ISatComplianceReport = {
  __typename?: 'SatComplianceReport'
  generatedAt: Scalars['String']['output']
  /**
   * Fracción II — Oferentes intermediados. Per-host record with full fiscal
   * identity plus the aggregate of intermediated operations and tax
   * retentions applied during targetMonth.
   */
  oferentes: ISatOferenteBlock
  /**
   * Fracción I — Receptores del servicio digital. Each item is one operation
   * where SpotMe charged a host for its intermediation service (commission).
   */
  receptores: ISatReceptorBlock
  summary: ISatComplianceSummary
  /** YYYY-MM format. The month whose data this report covers. */
  targetMonth: Scalars['String']['output']
}

export type ISatComplianceSummary = {
  __typename?: 'SatComplianceSummary'
  /**
   * Subtotal of Fracción I operations whose origin is `closedDeal` (SpotMe
   * Pro / Modelo Tradicional — host paid us our commission directly,
   * off-platform, off-Stripe). The amount is parsed from each CFDI's
   * `<cfdi:Comprobante Total>` attribute.
   */
  closedDealReceptorAmount: Scalars['Float']['output']
  closedDealReceptorOperations: Scalars['Int']['output']
  /**
   * Subtotal of Fracción I operations whose origin is `onPlatform` (Monthly
   * intermediation — SpotMe collected rent via Stripe, transferred the host
   * their portion, withheld our commission). Excludes closed-deal CFDIs.
   */
  onPlatformReceptorAmount: Scalars['Float']['output']
  onPlatformReceptorOperations: Scalars['Int']['output']
  totalIsrRetenido: Scalars['Float']['output']
  totalIvaRetenido: Scalars['Float']['output']
  totalOferenteAmount: Scalars['Float']['output']
  totalOferenteOperations: Scalars['Int']['output']
  totalOferentes: Scalars['Int']['output']
  /**
   * Total facturado (commission + IVA) summed across BOTH on-platform Monthly
   * intermediation AND off-platform closed-deal commissions. Equals
   * `onPlatformReceptorAmount + closedDealReceptorAmount`.
   */
  totalReceptorAmount: Scalars['Float']['output']
  totalReceptorOperations: Scalars['Int']['output']
}

export type ISatFiscalAddress = {
  __typename?: 'SatFiscalAddress'
  calle?: Maybe<Scalars['String']['output']>
  ciudad?: Maybe<Scalars['String']['output']>
  codigoPostal?: Maybe<Scalars['String']['output']>
  colonia?: Maybe<Scalars['String']['output']>
  completa?: Maybe<Scalars['String']['output']>
  estado?: Maybe<Scalars['String']['output']>
  pais?: Maybe<Scalars['String']['output']>
}

/** Monto de operación per Regla 2.9.21 II.f. */
export type ISatMontoOperacion = {
  __typename?: 'SatMontoOperacion'
  /** IEPS is N/A for SpotMe (no goods/services subject to it). */
  baseIeps: Scalars['Float']['output']
  /** Base for ISR — typically equal to gross before retentions. */
  baseIsr: Scalars['Float']['output']
  /** Base for IVA — typically equal to gross before retentions. */
  baseIva: Scalars['Float']['output']
  /** IEPS withheld — always 0 for SpotMe. */
  iepsRetenido: Scalars['Float']['output']
  /** ISR withheld by SpotMe and remitted to SAT. */
  isrRetenido: Scalars['Float']['output']
  /** IVA withheld by SpotMe and remitted to SAT. */
  ivaRetenido: Scalars['Float']['output']
  /** SpotMe payout method to host (always SPEI via Stripe Connect). */
  metodoPagoPlataforma: Scalars['String']['output']
  /** Renter payment methods (typically 'Tarjeta' / 'Transferencia SPEI'). */
  metodosPagoAdquirientes: Array<Scalars['String']['output']>
}

export type ISatOferenteBlock = {
  __typename?: 'SatOferenteBlock'
  items: Array<ISatOferenteRecord>
  total: Scalars['Int']['output']
}

export enum SatOferenteHostType {
  PersonaFisica = 'PERSONA_FISICA',
  PersonaMoral = 'PERSONA_MORAL'
}

/**
 * Fracción II, Regla 2.9.21 RMF: per-host fiscal identity plus the aggregate
 * of every operation SpotMe intermediated for them during targetMonth.
 */
export type ISatOferenteRecord = {
  __typename?: 'SatOferenteRecord'
  banco?: Maybe<Scalars['String']['output']>
  clabe?: Maybe<Scalars['String']['output']>
  /** Only for personas físicas residentes en México. */
  curp?: Maybe<Scalars['String']['output']>
  domicilioFiscal?: Maybe<ISatFiscalAddress>
  /** Indicates the host's fiscal info is complete enough to issue valid CFDIs. */
  fiscalInfoComplete: Scalars['Boolean']['output']
  /**
   * CFDI de Retenciones folio fiscal (TimbreFiscalDigital UUID) for this
   * host's `targetMonth`, when SpotMe withheld IVA/ISR and the retention
   * CFDI has been issued + parsed. Null when the host had no retentions,
   * the retention CFDI hasn't been issued yet, or the XML hasn't been
   * parsed yet (legacy uploads pre-2026-05). Falls back to a
   * `spotme:<docId>` sentinel when the retention FiscalDocument exists but
   * its UUID hasn't been extracted — mirrors the `folioFiscalCfdi`
   * resolution order on `SatReceptorOperation`.
   */
  folioFiscalRetenciones?: Maybe<Scalars['String']['output']>
  /** Internal host ID (SpotMe user or team). */
  hostId: Scalars['String']['output']
  hostType: SatOferenteHostType
  /** List of missing required fields, empty if complete. */
  missingFields: Array<Scalars['String']['output']>
  /** Aggregate monto de operación intermediated for this host during targetMonth. */
  montoOperacion: ISatMontoOperacion
  /** Razón social if persona moral, full name if persona física. */
  nombreCompleto?: Maybe<Scalars['String']['output']>
  /** All-time gross intermediated (MXN), for context. */
  operacionesAcumuladas: Scalars['Float']['output']
  /** Number of intermediated operations in targetMonth. */
  operacionesCount: Scalars['Int']['output']
  rfc?: Maybe<Scalars['String']['output']>
}

/**
 * SAT payment method classification derived from Stripe charge details.
 * Helps hosts select the correct Forma de Pago and Método de Pago when issuing facturas.
 */
export type ISatPaymentInfo = {
  __typename?: 'SatPaymentInfo'
  /** SAT c_FormaPago catalog code (e.g. 04=Tarjeta de Crédito, 28=Tarjeta de Débito, 03=Transferencia) */
  formaDePagoCode?: Maybe<Scalars['String']['output']>
  /** Human-readable label for the Forma de Pago */
  formaDePagoLabel?: Maybe<Scalars['String']['output']>
  /** PUE (same-month payment) or PPD (different-month, requires complemento de pago) */
  metodoDePago?: Maybe<Scalars['String']['output']>
}

export type ISatReceptorBlock = {
  __typename?: 'SatReceptorBlock'
  items: Array<ISatReceptorOperation>
  /** Total count across all pages. Use for pagination math. */
  total: Scalars['Int']['output']
}

/**
 * Fracción I, Regla 2.9.21 RMF: one operation = one CFDI we (SpotMe) issued
 * to a host (= our customer for digital-intermediation purposes). Includes
 * BOTH on-platform Monthly commissions (bracket-approximate from Stripe
 * transfers) AND off-platform closed-deal commissions (parsed directly from
 * CFDI XML). The `origen` field distinguishes the two.
 */
export type ISatReceptorOperation = {
  __typename?: 'SatReceptorOperation'
  checkoutId?: Maybe<Scalars['String']['output']>
  /** ClosedDeal id for `origen=CLOSED_DEAL` rows; null otherwise. */
  closedDealId?: Maybe<Scalars['String']['output']>
  /** Operation timestamp (ISO 8601 UTC). */
  date: Scalars['String']['output']
  /** CFDI folio fiscal (UUID) if the CFDI has been issued. */
  folioFiscalCfdi?: Maybe<Scalars['String']['output']>
  /** 16% IVA on the commission (MXN). */
  ivaTrasladado: Scalars['Float']['output']
  /** How the host paid (deducted from rent transfer, by default). */
  metodoPago: Scalars['String']['output']
  /** Host's name or razón social. */
  nombreCliente?: Maybe<Scalars['String']['output']>
  /** Origin marker. See `SatReceptorOrigin` for what each value means. */
  origen: SatReceptorOrigin
  /** Commission + IVA (MXN). */
  precioConIva: Scalars['Float']['output']
  /** Commission amount in MXN, IVA-exclusive. */
  precioSinIva: Scalars['Float']['output']
  /** Host's RFC if on file (cliente nuestro). */
  rfcCliente?: Maybe<Scalars['String']['output']>
  /** Internal references for auditability. */
  stripeInvoiceId?: Maybe<Scalars['String']['output']>
  /**
   * Type of digital service. Differentiated by origin:
   *   - On-platform: 'Tarifa de Servicios SpotMe (intermediación digital)'
   *   - Closed-deal (Broker): 'Tarifa de Servicios SpotMe — SpotMe Pro (deal facilitado fuera de plataforma)'
   *   - Closed-deal (Traditional): 'Tarifa de Servicios SpotMe — Modelo Tradicional (deal facilitado fuera de plataforma)'
   */
  tipoServicio: Scalars['String']['output']
}

/**
 * Origin of a receptor operation.
 *   - ON_PLATFORM: Monthly intermediation — SpotMe collected the renter's
 *     payment via Stripe, transferred the host their portion, and withheld
 *     our commission. The commission amount is bracket-approximate; the
 *     authoritative figure lives in the CFDI we issue at month-end.
 *   - CLOSED_DEAL: SpotMe Pro / Modelo Tradicional — host paid us our
 *     commission directly, off-platform. SpotMe never intermediated the
 *     rent itself. Commission amount comes from the CFDI XML directly.
 */
export enum SatReceptorOrigin {
  ClosedDeal = 'CLOSED_DEAL',
  OnPlatform = 'ON_PLATFORM'
}

export type ISaveCheckoutInput = {
  /** The submitting client displayed the «50% primer mes» early-exit terms. Consent is stamped only when this AND the server's clawback switch agree. */
  acceptedFirstMonthDiscountTerms?: InputMaybe<Scalars['Boolean']['input']>
  insuranceType?: InputMaybe<InsuranceType>
  quantity?: InputMaybe<Scalars['Int']['input']>
  /** Renter's CLABE for security deposit refund — can be provided during active rent */
  renterClabe?: InputMaybe<Scalars['String']['input']>
  renterTeamId?: InputMaybe<Scalars['String']['input']>
  /** Optional end date — sets automatic cancellation (cancel_at) on the subscription */
  requestedEndDate?: InputMaybe<Scalars['String']['input']>
  requestedStartDate?: InputMaybe<Scalars['String']['input']>
  storageItems?: InputMaybe<Scalars['String']['input']>
  storageItemsPhotos?: InputMaybe<Array<IPhotoInput>>
  storageNeeds?: InputMaybe<Scalars['String']['input']>
  storageTime?: InputMaybe<StorageTime>
  stripeBankTransfer?: InputMaybe<Scalars['Boolean']['input']>
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>
  vehicles?: InputMaybe<Array<IVehicleInput>>
}

export type ISearchCheckoutsInput = {
  configurationId?: InputMaybe<Scalars['String']['input']>
  landlordId?: InputMaybe<Scalars['String']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
  teamId?: InputMaybe<Scalars['String']['input']>
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>
  type?: InputMaybe<CheckoutType>
  types?: InputMaybe<Array<CheckoutType>>
  userAndTeams?: InputMaybe<Scalars['Boolean']['input']>
}

export type ISearchLocationResponse = {
  __typename?: 'SearchLocationResponse'
  configStats?: Maybe<IConfigurationStats>
  fallback?: Maybe<Scalars['Boolean']['output']>
  hits: Array<ILocation>
  mode?: Maybe<IAddress>
  total: Scalars['Int']['output']
}

export type ISearchLocationsInput = {
  canStoreVehicle?: InputMaybe<Scalars['Boolean']['input']>
  center?: InputMaybe<ICoordinatesInput>
  description?: InputMaybe<Scalars['String']['input']>
  locationTypes?: InputMaybe<Array<LocationType>>
  placeId?: InputMaybe<Scalars['String']['input']>
  priceRange?: InputMaybe<INumRangeInput>
  search?: InputMaybe<Scalars['String']['input']>
  sizes?: InputMaybe<Array<SizeFilter>>
  sortBy?: InputMaybe<SortBy>
  spaceTypes?: InputMaybe<Array<Scalars['String']['input']>>
  zoom?: InputMaybe<Scalars['Float']['input']>
}

/**
 * Self-reported acquisition source ("¿Cómo nos conociste?"). Options that
 * answer what the pixel CANNOT see — paid vs organic is deliberately absent
 * (users can't tell them apart; the gclid already knows).
 */
export enum SelfReportedSource {
  AiAssistant = 'AI_ASSISTANT',
  GoogleMaps = 'GOOGLE_MAPS',
  GoogleSearch = 'GOOGLE_SEARCH',
  Other = 'OTHER',
  OtherWebsite = 'OTHER_WEBSITE',
  Referral = 'REFERRAL',
  SocialMedia = 'SOCIAL_MEDIA',
  /** Supply side only — a SpotMe rep reached out to the host. */
  SpotmeOutreach = 'SPOTME_OUTREACH'
}

export type ISelfReportedSourceAnswer = {
  __typename?: 'SelfReportedSourceAnswer'
  answeredAt: Scalars['String']['output']
  /** Optional free text (who recommended us / which site). Max 120 chars. */
  detail?: Maybe<Scalars['String']['output']>
  source: SelfReportedSource
  surface: SelfReportedSourceSurface
}

export type ISelfReportedSourceInput = {
  detail?: InputMaybe<Scalars['String']['input']>
  /** Anonymous callers only — the contact they just submitted. Ignored when signed in. */
  email?: InputMaybe<Scalars['String']['input']>
  /** Anonymous callers only — the contact they just submitted. Ignored when signed in. */
  phone?: InputMaybe<Scalars['String']['input']>
  source: SelfReportedSource
  surface: SelfReportedSourceSurface
}

/** Where the self-reported source answer was captured. */
export enum SelfReportedSourceSurface {
  CheckoutSuccess = 'CHECKOUT_SUCCESS',
  LeadForm = 'LEAD_FORM',
  ListingPublished = 'LISTING_PUBLISHED',
  WhatsappBot = 'WHATSAPP_BOT'
}

export type ISize = {
  __typename?: 'Size'
  height?: Maybe<Scalars['Float']['output']>
  length: Scalars['Float']['output']
  width: Scalars['Float']['output']
}

export enum SizeFilter {
  Any = 'ANY',
  Commercial = 'COMMERCIAL',
  Industrial = 'INDUSTRIAL',
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Nave = 'NAVE',
  Parking = 'PARKING',
  Small = 'SMALL',
  Xsmall = 'XSMALL'
}

export type ISizeInput = {
  height?: InputMaybe<Scalars['Float']['input']>
  length: Scalars['Float']['input']
  width: Scalars['Float']['input']
}

export enum SortBy {
  Closest = 'CLOSEST',
  PriceHighToLow = 'PRICE_HIGH_TO_LOW',
  PriceLowToHigh = 'PRICE_LOW_TO_HIGH',
  Recommended = 'RECOMMENDED',
  SizeHighToLow = 'SIZE_HIGH_TO_LOW',
  SizeLowToHigh = 'SIZE_LOW_TO_HIGH'
}

/**
 * Specialist presentation data for the human SpotMe contact assigned to a
 * surface (Broker/Traditional listings, /reservar pre-auth page). Name +
 * photo are safe to surface anywhere — they're the trust signal.
 *
 * `whatsappE164` is OPTIONAL by design: it's only populated by resolvers
 * that want to expose direct contact (the `reservarContact` query). The
 * field-selection nature of GraphQL means listing-page `Location.specialist`
 * queries that only request `{ name, photoUrl }` never see the number in
 * their SSR `__NEXT_DATA__` payload — so co-locating the field on this type
 * doesn't create a leak vector, it just unifies the shape.
 */
export type ISpecialist = {
  __typename?: 'Specialist'
  name: Scalars['String']['output']
  photoUrl: Scalars['String']['output']
  /**
   * E.164-formatted WhatsApp number for direct contact (e.g. +525512345678).
   * Populated only by the `reservarContact` query — null when this specialist
   * is surfaced via `Location.specialist` on listing pages.
   */
  whatsappE164?: Maybe<Scalars['String']['output']>
}

export enum StorageTime {
  FewMonths = 'FEW_MONTHS',
  FewMonthsSix = 'FEW_MONTHS_SIX',
  FewMonthsTwelve = 'FEW_MONTHS_TWELVE',
  FewYears = 'FEW_YEARS',
  Indefinitely = 'INDEFINITELY',
  Month = 'MONTH',
  Year = 'YEAR'
}

export type ISubmitLocationInput = {
  leadContact?: InputMaybe<ILeadContactInput>
  leadContacts?: InputMaybe<Array<ILeadContactInput>>
  accessAvailability?: InputMaybe<AccessAvailability>
  accessFrequency?: InputMaybe<AccessFrequency>
  accessHours?: InputMaybe<AccessHours>
  accessPermission?: InputMaybe<AccessPermission>
  addressDetails?: InputMaybe<IAddressInput>
  agreedToTerms?: InputMaybe<Scalars['Boolean']['input']>
  bussinessProfile?: InputMaybe<IBussinessInput>
  configurations?: InputMaybe<Array<IConfigurationInput>>
  contract?: InputMaybe<IPhotoInput>
  coordinates?: InputMaybe<ICoordinatesInput>
  coverPhoto?: InputMaybe<IPhotoInput>
  defaultConfigurationId?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  indoorOrOutdoor?: InputMaybe<IndoorOutdoor>
  logisticsServices?: InputMaybe<Array<LogisticsService>>
  photos?: InputMaybe<Array<IPhotoInput>>
  plans?: InputMaybe<IPhotoInput>
  privateSpace?: InputMaybe<Scalars['Boolean']['input']>
  propertyType?: InputMaybe<PropertyType>
  referrer?: InputMaybe<Scalars['String']['input']>
  step?: InputMaybe<Scalars['String']['input']>
  teamId?: InputMaybe<Scalars['String']['input']>
  technicalReport?: InputMaybe<IPhotoInput>
  title?: InputMaybe<Scalars['String']['input']>
  useOfSpace?: InputMaybe<UseOfSpace>
  welcomeMessage?: InputMaybe<Scalars['String']['input']>
  welcomePhotos?: InputMaybe<Array<IPhotoInput>>
}

export type ISubmitLocationResponse = {
  __typename?: 'SubmitLocationResponse'
  location: ILocation
}

export enum SubmitOnDemandLeadError {
  CityNotCovered = 'CITY_NOT_COVERED',
  Generic = 'GENERIC',
  HubspotFailure = 'HUBSPOT_FAILURE',
  InvalidInput = 'INVALID_INPUT',
  InvalidPhone = 'INVALID_PHONE',
  RateLimited = 'RATE_LIMITED'
}

export type ISubmitOnDemandLeadInput = {
  /**
   * Vercel BotID verdict collected client-side pre-submit. When true, the
   * lead still reaches HubSpot (sales triages) but the market-partner
   * notification is skipped.
   */
  botIdFlagged?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  /** Hidden anti-spam field; if non-empty, server silently drops the submission */
  honeypot?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  /** Whether the renter is an individual or a business. */
  personaType?: InputMaybe<OnDemandPersonaType>
  phone: Scalars['String']['input']
  /**
   * Free-text pickup address (street + colonia). Partners need the literal
   * address to scope logistics — collected on the form.
   */
  pickupAddress?: InputMaybe<Scalars['String']['input']>
  /**
   * SearchPageCity slug or any metro-area slug; backend resolves to canonical
   * on-demand city via the onDemandCoverage map.
   */
  pickupCity: Scalars['String']['input']
  /** Free text or hood slug — optional */
  pickupHood?: InputMaybe<Scalars['String']['input']>
  /** Pickup-site logistics so the partner can scope the truck + crew. */
  pickupLogistics?: InputMaybe<OnDemandPickupLogistics>
  /**
   * How urgent the pickup is — preferred over `preferredPickupStart` for new
   * submissions. Sales filters / prioritizes by this value.
   */
  pickupTiming?: InputMaybe<OnDemandPickupTiming>
  pickupWindow: OnDemandPickupWindow
  /** ISO date string, optional — legacy field, prefer `pickupTiming`. */
  preferredPickupStart?: InputMaybe<Scalars['String']['input']>
  /**
   * Expected length of storage. Reuses the platform-wide `StorageTime` enum
   * so reporting can compare on-demand stays to traditional rentals. Drives
   * the duration-tiered indicative pricing copy shown on the landing.
   */
  storageDuration?: InputMaybe<StorageTime>
  volumeEstimate: OnDemandVolumeEstimate
}

export type ISubmitOnDemandLeadResult = {
  __typename?: 'SubmitOnDemandLeadResult'
  error?: Maybe<SubmitOnDemandLeadError>
  leadId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type ISuggestedCommission = {
  __typename?: 'SuggestedCommission'
  /** false when nothing applies: NONE (on-platform), CUSTOM (no canonical preset), or no team/segment. */
  applicable: Scalars['Boolean']['output']
  commissionInstallments?: Maybe<Scalars['Int']['output']>
  commissionType?: Maybe<CommissionType>
  commissionValue?: Maybe<Scalars['Float']['output']>
  /** Machine-readable reason when applicable=false (on_platform_no_commission | custom_no_preset | unknown_segment | no_team). */
  reason?: Maybe<Scalars['String']['output']>
  sourceSegment: TeamSegment
}

export type ITeam = INode & {
  leadContact?: Maybe<ILeadContact>
  leadContacts?: Maybe<Array<ILeadContact>>
  __typename?: 'Team'
  address?: Maybe<IAddress>
  bankTransferOnly?: Maybe<Scalars['Boolean']['output']>
  cfdiFormaPago?: Maybe<CfdiFormaPago>
  cfdiMetodoPago?: Maybe<CfdiMetodoPago>
  clabe?: Maybe<Scalars['String']['output']>
  /**
   * Append-only audit trail of CLABE changes. Under HOST_DIRECT the CLABE IS the
   * renter's payment destination, so every change is recorded (who, when, last-4
   * before/after) and alerts SpotMe admins. Last-4 only — never the full number.
   * Admin + team-member only. Newest last, capped server-side.
   */
  clabeChanges?: Maybe<Array<ITeamClabeChange>>
  /**
   * How rent is collected for this team's Now rentals (null = PLATFORM).
   * Admin + team-member only — renters read the public
   * `Location.directCollection` projection instead. Set ONLY by SpotMe admins via
   * `setTeamCollectionMode`.
   */
  collectionMode?: Maybe<CollectionMode>
  /** Per-team Traditional/on-demand success-fee scheme. Null → global standard bracket applies. */
  commissionScheme?: Maybe<ICommissionScheme>
  /** Default commission type for closed deals recorded against this team's locations */
  commissionType?: Maybe<CommissionType>
  /** Default commission multiplier: decimal for PERCENTAGE (e.g. 0.05 = 5%), number for MONTHS (e.g. 1.5) */
  commissionValue?: Maybe<Scalars['Float']['output']>
  constanciaFiscal?: Maybe<IPhoto>
  contact?: Maybe<IUser>
  createdOn?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  fiscalCompliance?: Maybe<IFiscalCompliance>
  icon?: Maybe<IPhoto>
  id: Scalars['String']['output']
  /** Per-team off-platform commission invoicing configuration. Null → PER_DEAL. */
  invoicingConfig?: Maybe<IClosedDealInvoicingConfig>
  isDirectoryTeam?: Maybe<Scalars['Boolean']['output']>
  lastUpdatedOn: Scalars['String']['output']
  legalName?: Maybe<Scalars['String']['output']>
  /** Email the e-signature envelope is sent to. Admin/member-only. */
  legalRepEmail?: Maybe<Scalars['String']['output']>
  /**
   * Legal representative who can sign on the team's behalf ("representante legal
   * con poderes de actos de administración"). Admin/member-only — never expose to
   * counterparties.
   */
  legalRepName?: Maybe<Scalars['String']['output']>
  /** Cargo / poder with which they sign (e.g. "Administrador Único"). */
  legalRepTitle?: Maybe<Scalars['String']['output']>
  listings?: Maybe<ISearchLocationResponse>
  /**
   * Soluciones Logísticas (3PL) service slugs this team can be MATCHED against
   * (canonical list in src/constants/logisticsServices.ts). Non-empty = 3PL
   * operator. Set only by admins. Admin + team-member only.
   */
  logisticsServices?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  logo?: Maybe<IPhoto>
  members?: Maybe<Array<ITeamMember>>
  name?: Maybe<Scalars['String']['output']>
  /**
   * City slugs this partner services for on-demand storage (Almacenamiento a
   * Domicilio). Uses the onDemandCoverage vocabulary ('monterrey' | 'cdmx' |
   * 'guadalajara'). Drives market-level lead routing. Empty/null = none.
   */
  onDemandMarkets?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  partnerType?: Maybe<TeamPartnerType>
  payouts?: Maybe<IPayoutsResponse>
  phone?: Maybe<Scalars['String']['output']>
  regimenFiscal?: Maybe<RegimenFiscal>
  reservations?: Maybe<ICheckoutsResponse>
  reviews?: Maybe<IReviewResponse>
  rfc?: Maybe<Scalars['String']['output']>
  /**
   * Host-side analog of User.customerType. Carries the team's standard commission
   * preset, gates off-platform fiscal/partner UX, and keys copy personalization.
   * Null is treated as NONE. Admin + team-member only.
   */
  segment?: Maybe<TeamSegment>
  shouldSetUpBankAccount?: Maybe<Scalars['Boolean']['output']>
  stripeAccountDashboardLink?: Maybe<Scalars['String']['output']>
  stripeAccountId?: Maybe<Scalars['String']['output']>
  stripeAccountLink?: Maybe<Scalars['String']['output']>
  stripeAccountPayoutError?: Maybe<Scalars['Boolean']['output']>
  /** Stripe customer ID for the team as a billed party (off-platform host commission billing). */
  stripeCustomerId?: Maybe<Scalars['String']['output']>
  usoCFDI?: Maybe<UsoCfdi>
}

export type ITeamContactArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>
}

export type ITeamListingsArgs = {
  pagination: IPaginationInput
}

export type ITeamReservationsArgs = {
  pagination: IPaginationInput
}

export type ITeamReviewsArgs = {
  interest?: InputMaybe<Interest>
  pagination: IPaginationInput
}

export type ITeamStripeAccountLinkArgs = {
  returnPath?: InputMaybe<Scalars['String']['input']>
}

/**
 * One entry in a team's CLABE-change audit trail. Stores LAST 4 DIGITS ONLY —
 * the full number lives on `Team.clabe` behind the same allowlist and must never
 * be duplicated into a log.
 */
export type ITeamClabeChange = {
  __typename?: 'TeamClabeChange'
  changedAt: Scalars['String']['output']
  changedByUserId?: Maybe<Scalars['String']['output']>
  newLast4?: Maybe<Scalars['String']['output']>
  previousLast4?: Maybe<Scalars['String']['output']>
  /** True when the team was on HOST_DIRECT at the moment of the change. */
  wasHostDirect?: Maybe<Scalars['Boolean']['output']>
}

export type ITeamMember = {
  __typename?: 'TeamMember'
  addedOn?: Maybe<Scalars['String']['output']>
  /**
   * Listings (location ids) this member manages — a location manager. Null
   * means every listing of the team. Narrows only emails about a listing; one
   * nobody covers goes to the team's admins instead.
   */
  locationIds?: Maybe<Array<Scalars['String']['output']>>
  role?: Maybe<TeamRole>
  teamId?: Maybe<Scalars['String']['output']>
  /**
   * Notification topics this member is on the hook for. Null means ALL topics
   * (the back-compat default); an empty list means none. Compliance-bearing
   * topics must keep at least one assignee team-wide.
   */
  topics?: Maybe<Array<NotificationTopic>>
  user?: Maybe<IUser>
  userId?: Maybe<Scalars['String']['output']>
}

export type ITeamMemberInput = {
  email?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  role: TeamRole
  userId?: InputMaybe<Scalars['String']['input']>
}

export enum TeamPartnerType {
  BrokerLead = 'BROKER_LEAD'
}

export enum TeamSegment {
  Custom = 'CUSTOM',
  None = 'NONE',
  Pro = 'PRO',
  Traditional = 'TRADITIONAL'
}

export type ITeamResponse = {
  __typename?: 'TeamResponse'
  team: ITeam
}

export type ITeamInvite = {
  __typename?: 'TeamInvite'
  createdOn: Scalars['String']['output']
  email: Scalars['String']['output']
  expiresOn: Scalars['String']['output']
  id: Scalars['ID']['output']
  invitedByName?: Maybe<Scalars['String']['output']>
  /**
   * Optional WhatsApp destination, E.164 (`+52…`). Present only when the inviting
   * admin supplied one. Admin-visible (the team dashboard shows which channels an
   * invite went out on) — never exposed on the PUBLIC preview type.
   */
  phoneNumber?: Maybe<Scalars['String']['output']>
  role: TeamRole
  status: TeamInviteStatus
  teamId: Scalars['String']['output']
}

export type ITeamInvitePublic = {
  __typename?: 'TeamInvitePublic'
  emailMasked: Scalars['String']['output']
  inviterName?: Maybe<Scalars['String']['output']>
  role: TeamRole
  status: TeamInviteStatus
  teamLogoUrl?: Maybe<Scalars['String']['output']>
  teamName: Scalars['String']['output']
}

export type IAcceptTeamInviteResponse = {
  __typename?: 'AcceptTeamInviteResponse'
  joined: Scalars['Boolean']['output']
  needsVerification: Scalars['Boolean']['output']
  team: ITeam
}

export type ICreateTeamInviteInput = {
  email: Scalars['String']['input']
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  role: TeamRole
  teamId: Scalars['String']['input']
}

export enum TeamInviteStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export type IMutationAcceptTeamInviteArgs = {
  token: Scalars['String']['input']
}

export type IMutationCreateTeamInviteArgs = {
  input: ICreateTeamInviteInput
}

export type IMutationResendAllTeamInvitesArgs = {
  teamId: Scalars['String']['input']
}

export type IMutationResendTeamInviteArgs = {
  inviteId: Scalars['String']['input']
  phoneNumber?: InputMaybe<Scalars['String']['input']>
}

export type IMutationRevokeTeamInviteArgs = {
  inviteId: Scalars['String']['input']
}

export type IQueryTeamInvitePreviewArgs = {
  token: Scalars['String']['input']
}

export type IQueryTeamInvitesArgs = {
  status?: InputMaybe<TeamInviteStatus>
  teamId: Scalars['String']['input']
}

export enum TeamRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type ITeamsResponse = {
  __typename?: 'TeamsResponse'
  hits: Array<ITeam>
  total: Scalars['Int']['output']
}

/**
 * Per-topic channel choice for team-directed host mail. An absent field, or an
 * absent topic within it, falls back to the member's genre notification
 * preferences (`notiPreferences`) instead — it does NOT default to both
 * channels being open. An empty `methods` array is rejected at write time —
 * assigned always means reachable.
 */
export type ITopicChannelPreference = {
  __typename?: 'TopicChannelPreference'
  methods: Array<NotificationMethod>
  topic: NotificationTopic
}

export type ITopicChannelPreferenceInput = {
  methods: Array<NotificationMethod>
  topic: NotificationTopic
}

export type ITrackEventInput = {
  action: EventAction
  configurationId?: InputMaybe<Scalars['String']['input']>
  lat?: InputMaybe<Scalars['Float']['input']>
  lng?: InputMaybe<Scalars['Float']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
  pagePath?: InputMaybe<Scalars['String']['input']>
  pillar?: InputMaybe<Scalars['String']['input']>
  subType?: InputMaybe<Scalars['String']['input']>
}

/**
 * The non-payment day counts the whole feature runs on. Single source:
 * `src/api/checkout/unpaid/constants.ts`. The browser reads them from here so no
 * day count is ever hardcoded in the client (the email templates get the same
 * numbers through `meta.unpaid.timeline`).
 */
export type IUnpaidPolicy = {
  __typename?: 'UnpaidPolicy'
  /** Automatic warning and release are enabled. Missing means unknown. */
  autoReleaseEnabled?: Scalars['Boolean']['output']
  /** How long "Mantener la reserva" pushes the release date out. */
  holdDays: Scalars['Int']['output']
  /**
   * Days between the rescission notice and its effective date — the renter's
   * window to cure by paying.
   */
  noticeDays: Scalars['Int']['output']
  /**
   * Days unpaid before a reservation whose FIRST MONTH was never paid — whether
   * or not the renter has moved in — is auto-released.
   */
  releaseDays: Scalars['Int']['output']
  /** Earliest day a host may release the space themselves. */
  releaseEarlyDays: Scalars['Int']['output']
  /**
   * `UNPAID_RELEASE_FEATURE_SINCE` — only reservations the host approved
   * (`landlordAssessedAt`) on or after this UTC date ever auto-release. Served so
   * the browser can apply the SAME gate the server's `isReleaseCandidate` does:
   * a reservation approved earlier keeps every other remedy, but no surface may
   * ever promise it an automatic release date, because the cron will never come.
   */
  releaseFeatureSince: Scalars['String']['output']
  /** Days unpaid before a host may rescind a STARTED rental (Anexo A §18). */
  rescissionAvailableAfterDays: Scalars['Int']['output']
}

export type IUpdateCheckoutInput = {
  /**
   * Admin-only: override SpotMe commission percentage (0-100).
   * Set to null to revert to bracket-based calculation.
   * Updates Stripe subscription with proration on next billing cycle.
   */
  commissionOverride?: InputMaybe<Scalars['Float']['input']>
  /**
   * Cancel insurance for the next renewal cycle. Set to null to schedule the
   * existing Chubb subscription for cancellation at period end. Renter, renter
   * team member, or admin only. Plan switching is not yet supported via this
   * mutation.
   */
  insuranceType?: InputMaybe<InsuranceType>
  landlordNotes?: InputMaybe<Scalars['String']['input']>
  landlordPhotos?: InputMaybe<Array<IPhotoInput>>
  needsInvoice?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * Admin-only: override the checkout price (MXN cents).
   * Updates Stripe subscription with proration on next billing cycle.
   */
  price?: InputMaybe<Scalars['Float']['input']>
  /**
   * Admin-only: override the checkout quantity.
   * Updates Stripe subscription with proration on next billing cycle.
   */
  quantity?: InputMaybe<Scalars['Int']['input']>
  /** Edit renter's CLABE for refund. Renter, renter team member, or admin only. Allowed only when checkout has a cancellation context (cancelled or scheduled end). */
  renterClabe?: InputMaybe<Scalars['String']['input']>
  renterTeamId?: InputMaybe<Scalars['String']['input']>
  requestedEndDate?: InputMaybe<Scalars['String']['input']>
  requestedStartDate?: InputMaybe<Scalars['String']['input']>
  storageItems?: InputMaybe<Scalars['String']['input']>
  storageTime?: InputMaybe<StorageTime>
  vehicles?: InputMaybe<Array<IVehicleInput>>
}

/** Input for editing an active billing plan. Only fields that Stripe supports updating mid-plan are exposed. */
export type IUpdateClosedDealBillingInput = {
  amountMxn?: InputMaybe<Scalars['Float']['input']>
  closedDealId: Scalars['String']['input']
  endCondition?: InputMaybe<BillingEndCondition>
  endDate?: InputMaybe<Scalars['String']['input']>
  monthsRemaining?: InputMaybe<Scalars['Int']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
}

export type IUpdateClosedDealInput = {
  /**
   * ACCRUAL only — switch the deal's devengo ladder (contract renegotiation /
   * correction). Changing it after milestones billed re-times the REMAINING
   * milestones only; billed counters never move. Ignored for UPFRONT deals.
   * Also re-bases commissionValue to the new ladder's cap. Switching away
   * from CUSTOM clears customAccrualSchedule.
   */
  accrualLadderPreset?: InputMaybe<AccrualLadderPreset>
  /** When billing/commission charging should begin. Defaults to closedAt when unset. */
  chargeStartDate?: InputMaybe<Scalars['String']['input']>
  closedAt?: InputMaybe<Scalars['String']['input']>
  /** 1, 2, or 3. Required when commissionType is PERCENTAGE_TCV or MONTHS_OF_RENT; rejected for PERCENTAGE_MONTHLY. */
  commissionInstallments?: InputMaybe<Scalars['Int']['input']>
  commissionType?: InputMaybe<CommissionType>
  commissionValue?: InputMaybe<Scalars['Float']['input']>
  /**
   * Re-link the deal to a different unit (configuration). The server re-derives
   * locationId from the configuration — rejects unknown configurations.
   */
  configurationId?: InputMaybe<Scalars['String']['input']>
  /**
   * Required when switching accrualLadderPreset to CUSTOM (or editing an
   * already-CUSTOM deal's schedule). Same validation as create. Rejected when
   * the (resulting) preset is not CUSTOM.
   */
  customAccrualSchedule?: InputMaybe<Array<IAccrualScheduleStepInput>>
  duration?: InputMaybe<Scalars['Int']['input']>
  monthlyPrice?: InputMaybe<Scalars['Float']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  renterEmail?: InputMaybe<Scalars['String']['input']>
  renterName?: InputMaybe<Scalars['String']['input']>
  renterPhone?: InputMaybe<Scalars['String']['input']>
  renterRazonSocial?: InputMaybe<Scalars['String']['input']>
  renterRfc?: InputMaybe<Scalars['String']['input']>
  renterType?: InputMaybe<RenterType>
  salesOwnerId?: InputMaybe<Scalars['String']['input']>
  /**
   * Correct the deal's vertical marker (LOGISTICS ↔ null). Does NOT
   * retroactively change the ladder — pair with accrualLadderPreset when the
   * rate card should change too.
   */
  serviceModel?: InputMaybe<ClosedDealServiceModel>
}

export type IUpdateTeamInput = {
  leadContact?: InputMaybe<ILeadContactInput>
  leadContacts?: InputMaybe<Array<ILeadContactInput>>
  address?: InputMaybe<IAddressInput>
  bankTransferOnly?: InputMaybe<Scalars['Boolean']['input']>
  cfdiFormaPago?: InputMaybe<CfdiFormaPago>
  cfdiMetodoPago?: InputMaybe<CfdiMetodoPago>
  clabe?: InputMaybe<Scalars['String']['input']>
  constanciaFiscal?: InputMaybe<IPhotoInput>
  description?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  icon?: InputMaybe<IPhotoInput>
  legalName?: InputMaybe<Scalars['String']['input']>
  legalRepEmail?: InputMaybe<Scalars['String']['input']>
  /**
   * Legal representative (signer) — see `Team.legalRepName`. Used to address
   * e-signature envelopes for proveedor / CLABE-clarification letters.
   */
  legalRepName?: InputMaybe<Scalars['String']['input']>
  legalRepTitle?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<IPhotoInput>
  members?: InputMaybe<Array<ITeamMemberInput>>
  name: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  regimenFiscal?: InputMaybe<RegimenFiscal>
  rfc?: InputMaybe<Scalars['String']['input']>
  /**
   * Admin-only, honored by `createTeam` ONLY (required there for platform
   * admins). `updateTeam` ignores it — changing an existing team's segment goes
   * through the admin-only `setTeamSegment` mutation.
   */
  segment?: InputMaybe<TeamSegment>
  usoCFDI?: InputMaybe<UsoCfdi>
}

export type IUploadFiscalDocumentInput = {
  checkoutId?: InputMaybe<Scalars['String']['input']>
  closedDealId?: InputMaybe<Scalars['String']['input']>
  files: Array<IFileInput>
  flow: FiscalDocumentFlow
  period: Scalars['String']['input']
  recipientTeamId?: InputMaybe<Scalars['String']['input']>
  recipientUserId?: InputMaybe<Scalars['String']['input']>
  relatedDocumentId?: InputMaybe<Scalars['String']['input']>
  senderTeamId?: InputMaybe<Scalars['String']['input']>
  senderUserId?: InputMaybe<Scalars['String']['input']>
  stripeInvoiceId?: InputMaybe<Scalars['String']['input']>
  type: FiscalDocumentType
}

export enum UseOfSpace {
  Commercial = 'COMMERCIAL',
  Industrial = 'INDUSTRIAL',
  Mixed = 'MIXED',
  None = 'NONE',
  Residencial = 'RESIDENCIAL'
}

export type IUser = INode & {
  __typename?: 'User'
  accountVerificationError?: Maybe<Scalars['String']['output']>
  actividadEmpresarial?: Maybe<Scalars['Boolean']['output']>
  address?: Maybe<IAddress>
  adminLocations?: Maybe<ISearchLocationResponse>
  adminNotificationSettings?: Maybe<Array<IAdminNotificationSetting>>
  adminPermissions?: Maybe<Array<AdminPermission>>
  adminRegions?: Maybe<Array<AdminRegion>>
  adminRents?: Maybe<ICheckoutsResponse>
  adminReservations?: Maybe<ICheckoutsResponse>
  adminRole?: Maybe<AdminRole>
  adminTeams?: Maybe<ITeamsResponse>
  /**
   * AI vision-LLM verdict on the most recent KYC submission. Output-only;
   * written by the KycAiReviewService worker. Null until the worker runs
   * (or if the model call failed). Phase 1 is advisory-only — admin still
   * decides. See AiVerificationResult and KycAiReviewService for details.
   */
  aiVerification?: Maybe<IAiVerificationResult>
  bankInfo?: Maybe<IBankInfo>
  bankTransferOnly?: Maybe<Scalars['Boolean']['output']>
  birthdate?: Maybe<Scalars['String']['output']>
  bussinessProfile?: Maybe<IBussiness>
  cfdiFormaPago?: Maybe<CfdiFormaPago>
  cfdiMetodoPago?: Maybe<CfdiMetodoPago>
  civilStatus?: Maybe<CivilStatus>
  clabe?: Maybe<Scalars['String']['output']>
  constanciaFiscal?: Maybe<IPhoto>
  createdOn?: Maybe<Scalars['String']['output']>
  curp?: Maybe<Scalars['String']['output']>
  currency?: Maybe<Currency>
  currentCity?: Maybe<Scalars['String']['output']>
  customerType?: Maybe<CustomerType>
  description?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  emailDeliverability?: Maybe<IEmailDeliverability>
  facebookUrl?: Maybe<Scalars['String']['output']>
  favoriteSong?: Maybe<Scalars['String']['output']>
  /**
   * Read-only finance role, distinct from admin. Gates access to consumer-
   * specific finance views (SAT portal, internal accountant/finance explorer,
   * etc.). NULL = no special finance access; the user can still see their own
   * data via the normal host/renter dashboards. See `FinanceAccessRole` for
   * what each role can see.
   */
  financeAccess?: Maybe<FinanceAccessRole>
  firstVerifiedOn?: Maybe<Scalars['String']['output']>
  firstname?: Maybe<Scalars['String']['output']>
  fiscalCompliance?: Maybe<IFiscalCompliance>
  hobbie?: Maybe<Scalars['String']['output']>
  hostSnapshot?: Maybe<IHostSnapshot>
  hostType?: Maybe<HostType>
  hsOwnerId?: Maybe<Scalars['String']['output']>
  hubspotId?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  identification?: Maybe<IPhoto>
  instagramUrl?: Maybe<Scalars['String']['output']>
  interest?: Maybe<Interest>
  isAdmin?: Maybe<Scalars['Boolean']['output']>
  isDeactivated?: Maybe<Scalars['Boolean']['output']>
  isVerified?: Maybe<Scalars['Boolean']['output']>
  job?: Maybe<Scalars['String']['output']>
  /**
   * Vercel BotID verdict collected at the final KYC submit step. Written
   * by saveUserVerification when the optional kycBotIdSignal input is
   * provided. Consumed by the KYC auto-action gate alongside the AI
   * verdict (Tier 3 path A — combined-signal ban). Admin-only.
   */
  kycBotIdSignal?: Maybe<IKycBotIdSignal>
  language?: Maybe<Language>
  languages?: Maybe<Array<Scalars['String']['output']>>
  lastKnownLocation?: Maybe<ILastKnownLocation>
  lastUpdatedOn: Scalars['String']['output']
  lastVerifiedOn?: Maybe<Scalars['String']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  lastnameMaternal?: Maybe<Scalars['String']['output']>
  listings?: Maybe<ISearchLocationResponse>
  movieAsLife?: Maybe<Scalars['String']['output']>
  nanoId?: Maybe<Scalars['String']['output']>
  notiPreferences?: Maybe<Array<INotificationPreference>>
  ofac?: Maybe<IOfac>
  owner?: Maybe<IOwnerInfo>
  paymentMethods?: Maybe<Array<IPaymentMethod>>
  payouts?: Maybe<IPayoutsResponse>
  phoneNumber?: Maybe<Scalars['String']['output']>
  preferedNotiMethod?: Maybe<NotificationMethod>
  profilePicture?: Maybe<IPhoto>
  referrer?: Maybe<Scalars['String']['output']>
  referrerStatus?: Maybe<ReferrerStatus>
  referrerUser?: Maybe<Scalars['String']['output']>
  regimenFiscal?: Maybe<RegimenFiscal>
  reports?: Maybe<IReportsResponse>
  requestedVerification?: Maybe<Scalars['Boolean']['output']>
  requestedVerificationAt?: Maybe<Scalars['String']['output']>
  reviews?: Maybe<IReviewResponse>
  rfc?: Maybe<Scalars['String']['output']>
  salesReferrer?: Maybe<Scalars['String']['output']>
  salesReferrerUser?: Maybe<Scalars['String']['output']>
  /**
   * The user's own answer to "¿Cómo nos conociste?" — asked once, after a
   * conversion, never before. Set-once; self + admin only.
   */
  selfReportedSource?: Maybe<ISelfReportedSourceAnswer>
  shouldSetUpBankAccount?: Maybe<Scalars['Boolean']['output']>
  stripeAccountDashboardLink?: Maybe<Scalars['String']['output']>
  stripeAccountId?: Maybe<Scalars['String']['output']>
  stripeAccountLink?: Maybe<Scalars['String']['output']>
  stripeAccountPayoutError?: Maybe<Scalars['Boolean']['output']>
  stripeCustomerId?: Maybe<Scalars['String']['output']>
  stripeCustomerPaymentError?: Maybe<Scalars['Boolean']['output']>
  stripeCustomerPortalLink?: Maybe<Scalars['String']['output']>
  topicChannels?: Maybe<Array<ITopicChannelPreference>>
  twitterUrl?: Maybe<Scalars['String']['output']>
  userChanges?: Maybe<IUserInfoChanges>
  usoCFDI?: Maybe<UsoCfdi>
  /** @deprecated Veriff integration removed Apr 2026. Always resolves to null. Retained so older clients don't fail validation. */
  veriffStatus?: Maybe<VeriffStatus>
  verifiedBy?: Maybe<Scalars['String']['output']>
}

export type IUserAdminLocationsArgs = {
  filter?: InputMaybe<UserLocationsFilter>
  pagination: IPaginationInput
}

export type IUserAdminRentsArgs = {
  pagination: IPaginationInput
}

export type IUserAdminReservationsArgs = {
  pagination: IPaginationInput
}

export type IUserAdminTeamsArgs = {
  pagination: IPaginationInput
}

export type IUserHostSnapshotArgs = {
  asReferrer?: InputMaybe<Scalars['Boolean']['input']>
}

export type IUserListingsArgs = {
  business?: InputMaybe<IBusinessInput>
  pagination: IPaginationInput
}

export type IUserReportsArgs = {
  pagination: IPaginationInput
}

export type IUserReviewsArgs = {
  interest?: InputMaybe<Interest>
  pagination: IPaginationInput
}

export type IUserStripeAccountLinkArgs = {
  returnPath?: InputMaybe<Scalars['String']['input']>
}

export type IUserStripeCustomerPortalLinkArgs = {
  returnPath?: InputMaybe<Scalars['String']['input']>
}

export type IUserChatsResponse = {
  __typename?: 'UserChatsResponse'
  chats: Array<IChat>
  total: Scalars['Int']['output']
}

export type IUserInfoChanges = {
  __typename?: 'UserInfoChanges'
  description?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  firstname?: Maybe<Scalars['String']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  lastnameMaternal?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
  profilePicture?: Maybe<IPhoto>
}

export enum UserLocationsFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Drafts = 'DRAFTS',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export type IUserLocationsInput = {
  filter: UserLocationsFilter
  rejected?: InputMaybe<Scalars['Boolean']['input']>
  teamId?: InputMaybe<Scalars['String']['input']>
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>
  userAndTeams?: InputMaybe<Scalars['Boolean']['input']>
  userId?: InputMaybe<Scalars['String']['input']>
}

export type IUserSearchInput = {
  admins?: InputMaybe<Scalars['Boolean']['input']>
  recent?: InputMaybe<Scalars['Boolean']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type IUsersResponse = {
  __typename?: 'UsersResponse'
  total: Scalars['Int']['output']
  users: Array<IUser>
}

export enum UsoCfdi {
  IdCp01 = 'Id_CP01',
  IdD07 = 'Id_D07',
  IdG01 = 'Id_G01',
  IdG02 = 'Id_G02',
  IdG03 = 'Id_G03',
  IdI01 = 'Id_I01',
  IdI02 = 'Id_I02',
  IdI03 = 'Id_I03',
  IdI04 = 'Id_I04',
  IdI05 = 'Id_I05',
  IdI06 = 'Id_I06',
  IdI07 = 'Id_I07',
  IdI08 = 'Id_I08',
  IdS01 = 'Id_S01'
}

export type IVehicle = {
  __typename?: 'Vehicle'
  color?: Maybe<Scalars['String']['output']>
  /** Placa del vehículo */
  licensePlate?: Maybe<Scalars['String']['output']>
  /** Marca */
  make?: Maybe<Scalars['String']['output']>
  /** Modelo */
  model?: Maybe<Scalars['String']['output']>
  type?: Maybe<VehicleType>
  year?: Maybe<Scalars['String']['output']>
}

export type IVehicleInput = {
  color?: InputMaybe<Scalars['String']['input']>
  licensePlate?: InputMaybe<Scalars['String']['input']>
  make?: InputMaybe<Scalars['String']['input']>
  model?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<VehicleType>
  year?: InputMaybe<Scalars['String']['input']>
}

export enum VehicleType {
  Boat = 'BOAT',
  Car = 'CAR',
  Motorcycle = 'MOTORCYCLE'
}

/** DEPRECATED — Veriff integration removed Apr 2026. Field is retained on the schema so older clients that still select it don't fail validation; it always resolves to null. Do not add new usages. */
export enum VeriffStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type IVerifyLocationResponse = {
  __typename?: 'VerifyLocationResponse'
  verifiedLocation: ILocation
}

/**
 * A Line 1 WhatsApp conversation from our own store — the read-only transcript
 * behind the admin page `/dashboard/admin/whatsapp/[threadId]` (exit doc N14).
 * ADMIN-ONLY.
 */
export type IWaTranscript = {
  __typename?: 'WaTranscript'
  createdAt: Scalars['String']['output']
  /** Set when the id was reused from a HubSpot thread. */
  hubspotThreadId?: Maybe<Scalars['String']['output']>
  lastInboundAt?: Maybe<Scalars['String']['output']>
  lastOutboundAt?: Maybe<Scalars['String']['output']>
  lastOutboundRole?: Maybe<WaMessageRole>
  /** Oldest first — the newest message is LAST. */
  messages: Array<IWaTranscriptMessage>
  /** Customer phone, digits as stored (`waKey`). */
  phone: Scalars['String']['output']
  /** Meta phone-number id of the SpotMe line the conversation lives on. */
  phoneNumberId: Scalars['String']['output']
  threadId: Scalars['String']['output']
  /** True when the message cap stopped before the conversation's first message. */
  truncated: Scalars['Boolean']['output']
}

/** One message of a Line 1 conversation, as stored in `wa_message`. */
export type IWaTranscriptMessage = {
  __typename?: 'WaTranscriptMessage'
  /** ISO timestamp of the message. */
  at: Scalars['String']['output']
  /** Text, or the caption of a media message. */
  body?: Maybe<Scalars['String']['output']>
  /** `inbound` (from the customer) or `outbound` (from SpotMe). */
  direction: Scalars['String']['output']
  errorCode?: Maybe<Scalars['Int']['output']>
  errorTitle?: Maybe<Scalars['String']['output']>
  /** Store sort key (`<isoTs>#<wamid>`) — unique within the thread. */
  id: Scalars['String']['output']
  role: WaMessageRole
  /** received | accepted | sent | delivered | read | failed */
  status: Scalars['String']['output']
  statusAt?: Maybe<Scalars['String']['output']>
  templateName?: Maybe<Scalars['String']['output']>
  /** Meta message type: text, image, sticker, audio, video, document, interactive, location, template… */
  type: Scalars['String']['output']
  wamid: Scalars['String']['output']
}

export type IWaiveRefundInput = {
  /** Renter must confirm they understand this is irreversible. UI enforces; server validates. */
  acknowledged: Scalars['Boolean']['input']
  /** Renter's stated reason for waiving (required acknowledgment, free-text). */
  reason: Scalars['String']['input']
}

export type ILeadContact = {
  __typename?: 'LeadContact'
  label?: Maybe<Scalars['String']['output']>
  role?: Maybe<LeadContactRole>
  email?: Maybe<Scalars['String']['output']>
  hours?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  updatedOn?: Maybe<Scalars['String']['output']>
  whatsapp?: Maybe<Scalars['String']['output']>
}

export type ILeadContactInput = {
  label?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<LeadContactRole>
  email?: InputMaybe<Scalars['String']['input']>
  hours?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  whatsapp?: InputMaybe<Scalars['String']['input']>
}

export type IRevealedLeadContact = {
  __typename?: 'RevealedLeadContact'
  /**
   * `https://wa.me/{whatsapp}?text=…` with the SpotMe prefill already
   * URL-encoded — the "SpotMe brought them" marker on the operator's side. Null
   * when the contact carries no WhatsApp number; render `phone` / `email` then.
   */
  deeplink?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  /** Free text the operator set, e.g. "L–V 9:00–18:00". NEVER a response-time promise. */
  hours?: Maybe<Scalars['String']['output']>
  /** Digits only, E.164 without "+". */
  phone?: Maybe<Scalars['String']['output']>
  /** Digits only, E.164 without "+". */
  whatsapp?: Maybe<Scalars['String']['output']>
}

export type IMutationAckHostLeadByTokenArgs = {
  token: Scalars['String']['input']
}

export type IMutationMarkHostLeadContactedArgs = {
  leadId: Scalars['ID']['input']
}
